import { _ as __rest, a as __awaiter } from './tslib.es6-9c37295f.js';
import React__default, { createContext, useMemo, useEffect, useRef, useState, useContext, useCallback, forwardRef, useImperativeHandle, memo } from 'react';
import { createStyles, Box, Button as Button$1, Input as Input$1, clsx, Autocomplete, Checkbox as Checkbox$1, Radio as Radio$1, Select as Select$1, TextInput, NumberInput as NumberInput$1, Portal, Transition, Overlay } from '@mantine/core';
import dayjs from 'dayjs';
import debounce from 'lodash/debounce';
import { createFormContext, useForm } from '@mantine/form';
import { B as BEARER_TOKEN_COOKIE } from './index-227a4f49.js';
import { getCookie, setCookie } from './miscCookieHelper.js';
import { u as useTranslations } from './index-ef9bdc70.js';
import { T as TranslationsContext } from './translationsContext-0bb01e06.js';
import { M as MediaQueries, b as getWrapperDomWithSelector, a as getPopupWrapperDom } from './utils-da0db738.js';
import { T as Text } from './index-bca4f215.js';
import { S as Select, d as Checkbox, I as Input, R as Radio, P as Phone, N as NumberInput, O as OTP } from './index-3d331313.js';
import { D as DatePicker } from './index-3a7b79b6.js';
import { B as Button } from './index-5b1256a3.js';
import './index.styles-d00e47f8.js';
import { useClickOutside } from '@mantine/hooks';
import './useMantineLocale-69ff962c.js';
import { C as COMMON_DATE_TRANSLATE_KEY } from './index-ed3e7858.js';
import './index-d943196d.js';
import { Z as ZINDEX_SSO, I as ISO_FORMAT } from './index-120855f6.js';
import './other-82ea32cf.js';
import './index-72b06055.js';
import { M as MAPPED_LOCALE } from './utils-76a4a76d.js';
import { DateInput } from '@mantine/dates';
import { u as usePlacesAutocomplete, G as GOOGLE_API_KEY } from './usePlacesAutocomplete-d03969a3.js';
import { H as Heading$1 } from './index-fab13b98.js';
import { t as translationsMap$1 } from './translationsProvider-109cf3f0.js';
import { L as LOCALE } from './Locale-b74fc19a.js';
import { v1 } from 'uuid';
import { parsePhoneNumber } from 'react-phone-number-input';
import styled from '@emotion/styled';
import { theme } from './miscTheme.js';
import { css } from '@emotion/react';
import { T as TogetherComponentGlobalContext } from './utils-94d2364c.js';
import { i as isVideo } from './index-98580318.js';
import { u as useScreenSize } from './useScreenSize-0f7b1070.js';
import { createPortal } from 'react-dom';
import { B as Button$2 } from './index-7e4ea28c.js';
import { I as InputDate } from './InputDate-45857cdf.js';
import { D as DrawerComponent } from './index-9a903bfa.js';
import { C as Close } from './Close-f6459776.js';
import './constantsIsProduction.js';
import './normalizeLink-e65b1c9a.js';
import './constantsDomainLocales.js';
import '@hhgtech/icons/other';
import '@mantine/carousel';
import 'classnames';
import './useUniqueId-71ce7077.js';
import './constantsSite.js';
import '@hhgtech/icons/core';
import '@mantine/notifications';
import 'date-fns/locale';
import './constantsRiskScreener.js';
import './i18n-values/en-PH.js';
import './i18n-values/hi-IN.js';
import './i18n-values/id-ID.js';
import './i18n-values/km-KH.js';
import './i18n-values/ms-MY.js';
import './i18n-values/my-MM.js';
import './i18n-values/th-TH.js';
import './i18n-values/tl-PH.js';
import './i18n-values/vi-VN.js';
import './i18n-values/vi-VN_MB.js';
import './i18n-values/zh-TW.js';
import './index-f32a2130.js';
import 'slugify';
import 'string-format';
import './togetherApiPaths.js';
import './constants-4d8a4e7e.js';
import 'vaul';

const LeadGenComponentContext = createContext({});

const CAMPAIGN_TARGET_TYPE = { LINKS: 1, TAGS: 2 };
let LEAD_API = 'https://dev.leadgen.hellobacsi.com/';
const LEAD_DEVICE_TYPE = {
    MOBILE: 1,
    DESKTOP: 2,
};
let LEAD_CLASS = '';
if (LEAD_API.includes('localhost')) {
    LEAD_API = 'https://dev.leadgen.hellobacsi.com/';
}
if (location.hostname.includes('marrybaby.vn')) {
    LEAD_CLASS = 'pink';
}
// var LEAD_CURRENT_URL = location.href.toLowerCase();
let LEAD_CURRENT_URL = 'https://' + location.hostname + location.pathname + location.search;
LEAD_CURRENT_URL = LEAD_CURRENT_URL.toLowerCase();
// TODO: set inital object if exists
if (sessionStorage.getItem('insider_object')) {
    window.insider_object = JSON.parse(sessionStorage.getItem('insider_object'));
}
const docLang = document.documentElement.lang;
// TODO: country code
const LEAD_LOCALE_DATA$1 = {
    'vi-VN': {
        popupLang: 'vi',
        countryCode: 'vn',
        countryCodeNumber: 84,
    },
    'id-ID': {
        popupLang: 'id',
        countryCode: 'id',
        countryCodeNumber: 62,
    },
    'th-TH': {
        popupLang: 'th',
        countryCode: 'th',
        countryCodeNumber: 66,
    },
    'ms-MY': {
        popupLang: 'ms',
        countryCode: 'my',
        countryCodeNumber: 60,
    },
    'zh-TW': {
        popupLang: 'zh',
        countryCode: 'tw',
        countryCodeNumber: 886,
    },
    'km-KH': {
        popupLang: 'km',
        countryCode: 'kh',
        countryCodeNumber: 855,
    },
    'my-MM': {
        popupLang: 'my',
        countryCode: 'mm',
        countryCodeNumber: 95,
    },
    'hi-IN': {
        popupLang: 'hi',
        countryCode: 'in',
        countryCodeNumber: 91,
    },
};
const LEAD_LOCALE = LEAD_LOCALE_DATA$1[docLang] || LEAD_LOCALE_DATA$1['vi-VN'];
function LEAD_RESET_VAR() {
    // LEAD_CURRENT_URL = location.href.toLowerCase();
    LEAD_CURRENT_URL =
        'https://' + location.hostname + location.pathname + location.search;
}
const LEAD_TIMEZONE_DATA = {
    1: 'Asia/Ho_Chi_Minh',
    10: 'Asia/Ho_Chi_Minh',
    11: 'Asia/Ho_Chi_Minh',
    12: 'Asia/Ho_Chi_Minh',
    2: 'Asia/Jakarta',
    3: 'Asia/Bangkok',
    4: 'Asia/Phnom_Penh',
    5: 'Asia/Kuala_Lumpur',
    6: 'Asia/Taipei',
    7: 'Asia/Yangon',
    8: 'Asia/Kolkata',
    9: 'Asia/Manila', // Philippines / Filipinos Site
};

const LEADGEN_ACTIONS = {
    SHOW: 'SHOW',
    SCROLL: 'SCROLL',
    TIME: 'TIME',
};
const LEADGEN_LAYOUT = {
    LightBoxA: 'LightBoxA',
    LightBoxB: 'LightBoxB',
    SkinA: 'SkinA',
    SkinB: 'SkinB',
    Floating: 'Floating',
    Tab: 'Tab',
    InlineA: 'InlineA',
    InlineB: 'InlineB',
    CenterTab: 'CenterTab',
    Sidebar: 'Sidebar',
    Fullscreen: 'Fullscreen',
    Slider: 'Slider',
};
const LEADGEN_BLOCK = {
    TextBlock: 'TextBlock',
    NumberBlock: 'NumberBlock',
    DateBlock: 'DateBlock',
    EmailBlock: 'EmailBlock',
    PhoneBlock: 'PhoneBlock',
    PhoneOtpBlock: 'PhoneOtpBlock',
    WhatsappOtpBlock: 'WhatsappOtpBlock',
    ZaloOtpBlock: 'ZaloOtpBlock',
    LocationBlock: 'LocationBlock',
    LinkButtonBlock: 'LinkButtonBlock',
    RadioBlock: 'RadioBlock',
    DropdownBlock: 'DropdownBlock',
    CheckboxBlock: 'CheckboxBlock',
    TncBlock: 'TncBlock',
    TitleBlock: 'TitleBlock',
    SubtitleBlock: 'SubtitleBlock',
};
const LEADGEN_BLOCK_INPUT = [
    LEADGEN_BLOCK.TextBlock,
    LEADGEN_BLOCK.NumberBlock,
    LEADGEN_BLOCK.DateBlock,
    LEADGEN_BLOCK.EmailBlock,
    LEADGEN_BLOCK.PhoneBlock,
    LEADGEN_BLOCK.PhoneOtpBlock,
    LEADGEN_BLOCK.WhatsappOtpBlock,
    LEADGEN_BLOCK.ZaloOtpBlock,
    LEADGEN_BLOCK.LocationBlock,
    LEADGEN_BLOCK.RadioBlock,
    LEADGEN_BLOCK.DropdownBlock,
    LEADGEN_BLOCK.CheckboxBlock,
    LEADGEN_BLOCK.TncBlock,
];
const leadGenFieldNamePhone = (listBlockAdded) => {
    return listBlockAdded
        .filter(({ name }) => [
        LEADGEN_BLOCK.PhoneBlock,
        LEADGEN_BLOCK.PhoneOtpBlock,
        LEADGEN_BLOCK.WhatsappOtpBlock,
        LEADGEN_BLOCK.ZaloOtpBlock,
    ].includes(name))
        .map(({ data }) => data.value);
};
const leadGenFieldRequired = (blocks) => {
    if (!(blocks === null || blocks === void 0 ? void 0 : blocks.length)) {
        return [];
    }
    return blocks
        .map(({ data, name, id }) => {
        const { required, value } = data;
        if (name === LEADGEN_BLOCK.TncBlock && id && required) {
            return `TNC-${id}`;
        }
        if (required) {
            return value;
        }
        return;
    })
        .filter(Boolean);
};
const SSO_MAP_LEAD = ['name', 'email', 'birthday', 'phone', 'gender'];
const LEAD_LOCALE_DATA = {
    'vi-VN': {
        popupLang: 'vi',
        countryCode: 'vn',
        countryCodeNumber: 84,
    },
    'id-ID': {
        popupLang: 'id',
        countryCode: 'id',
        countryCodeNumber: 62,
    },
    'th-TH': {
        popupLang: 'th',
        countryCode: 'th',
        countryCodeNumber: 66,
    },
    'ms-MY': {
        popupLang: 'ms',
        countryCode: 'my',
        countryCodeNumber: 60,
    },
    'zh-TW': {
        popupLang: 'zh',
        countryCode: 'tw',
        countryCodeNumber: 886,
    },
    'km-KH': {
        popupLang: 'km',
        countryCode: 'kh',
        countryCodeNumber: 855,
    },
    'my-MM': {
        popupLang: 'my',
        countryCode: 'mm',
        countryCodeNumber: 95,
    },
    'hi-IN': {
        popupLang: 'hi',
        countryCode: 'in',
        countryCodeNumber: 91,
    },
};
const mappingSSOToLead = (userInfoProps) => {
    var _a, _b;
    try {
        const { id, area_code } = userInfoProps;
        if (!userInfoProps || !id) {
            return;
        }
        const user = {};
        for (const ssoKey of SSO_MAP_LEAD) {
            if (ssoKey in userInfoProps &&
                typeof (userInfoProps === null || userInfoProps === void 0 ? void 0 : userInfoProps[ssoKey]) !== 'undefined') {
                const initValue = userInfoProps[ssoKey];
                if (ssoKey === 'birthday') {
                    const dob = dayjs(initValue, 'YYYY-MM-DD', true);
                    if (dob.isValid()) {
                        user.birthday = dob.toDate();
                    }
                }
                else if (ssoKey === 'gender') {
                    user.gender = initValue.toString();
                }
                else if (ssoKey === 'phone' && typeof area_code !== 'undefined') {
                    user.phone = area_code + initValue;
                }
                else {
                    user[ssoKey] = initValue;
                }
            }
        }
        if (((_a = user === null || user === void 0 ? void 0 : user.email) === null || _a === void 0 ? void 0 : _a.includes('@hhg.com')) ||
            ((_b = user === null || user === void 0 ? void 0 : user.email) === null || _b === void 0 ? void 0 : _b.includes('@facebook.com'))) {
            delete user.email;
        }
        return Object.values(user).length ? user : undefined;
    }
    catch (error) {
        return;
    }
};
const formatCampaignDetail = (campaign) => {
    if (!campaign) {
        return {};
    }
    try {
        const { extra_fields, thank_you_image } = campaign || {};
        const { textBlocks: exTextBlocks, imageBlocks: exImageBlocks, listBlockAdded: exListBlockAdded, listBlockThankyou: exListBlockThankyou, actionBlocks: exActionBlocks, } = extra_fields;
        const textBlocks = JSON.parse(exTextBlocks);
        const imageBlocks = JSON.parse(exImageBlocks);
        const listBlockAdded = JSON.parse(exListBlockAdded);
        const listBlockThankyou = JSON.parse(exListBlockThankyou);
        const actionBlocks = JSON.parse(exActionBlocks);
        const ThankYouBlock = {
            image: { src: thank_you_image },
        };
        listBlockThankyou.forEach((block) => {
            const { name, data } = block || {};
            const { value: htmlText, align, newtab, url } = data || {};
            switch (name) {
                case LEADGEN_BLOCK.TitleBlock: {
                    ThankYouBlock.title = { htmlText, align };
                }
                case LEADGEN_BLOCK.SubtitleBlock: {
                    ThankYouBlock.description = { htmlText, align };
                }
                case LEADGEN_BLOCK.LinkButtonBlock: {
                    ThankYouBlock.button = { htmlText, newtab, url };
                }
            }
        });
        return Object.assign(Object.assign({}, campaign), { extra_fields: Object.assign(Object.assign({}, extra_fields), { textBlocks,
                imageBlocks,
                listBlockAdded,
                listBlockThankyou,
                actionBlocks }), ThankYouBlock });
    }
    catch (error) {
        return {};
    }
};

class Store {
    constructor() {
        this.apiSsoUrl = 'https://staging-id.hellobacsi.com/';
        this.apiLeadUrl = 'https://dev.leadgen.hellobacsi.com/';
        this.apiSubotUrl = 'https://staging-service-subot.hellohealthgroup.com/';
    }
}
const leadStore = new Store();

const METHOD = {
    GET: 'get',
    POST: 'POST',
};
const LEADGEN_ERROR_CODE = {
    UNAUTHORIZED: 'UNAUTHORIZED',
};
const LEADGEN_API_PATH = {
    V2_CAMPAIGN: 'api/v2/campaign',
    V2_SUBSCRIPTION_LEAD: 'api/v2/subscription-box',
    V2_SUBSCRIPTION_INFO: 'api/campaign/get-title',
};
const SSO_API_PATH = {
    USER_UPDATE: 'api/user/update',
};
const ssoApi = {
    call(_a) {
        var { url, data } = _a, config = __rest(_a, ["url", "data"]);
        const token = getCookie(BEARER_TOKEN_COOKIE);
        config.body = JSON.stringify(data);
        config.headers = {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        };
        if (!token) {
            return Promise.reject({
                code: LEADGEN_ERROR_CODE.UNAUTHORIZED,
                _data: '',
            });
        }
        return fetch(`${leadStore.apiSsoUrl}${url}`, config)
            .then((res) => res.json())
            .catch(() => ({}));
    },
};
const leadApi = {
    call(_a) {
        var { url, data = undefined } = _a, config = __rest(_a, ["url", "data"]);
        config.body = JSON.stringify(data);
        config.headers = {
            'Content-Type': 'application/json',
        };
        return fetch(`${leadStore.apiLeadUrl}${url}`, config)
            .then((res) => res.json())
            .catch(() => ({}));
    },
};
const subotApi = {
    call(_a) {
        var { url, data } = _a, config = __rest(_a, ["url", "data"]);
        config.body = JSON.stringify(data);
        config.headers = {
            'Content-Type': 'application/json',
        };
        return fetch(`${leadStore.apiSubotUrl}${url}`, config)
            .then((res) => res.json())
            .catch(() => ({}));
    },
};
const campaignGetById = (id) => {
    return leadApi.call({
        url: `api/internal/campaign/${id}`,
        method: 'get',
    });
};
const validateEmailOrPhoneOnLeadGen = ({ campaign_id, email, phone, }) => {
    let phoneToSend = phone;
    // Remove the '0' part. Logic from Back to check between Subot and Lead with different format
    if (phoneToSend && phoneToSend.startsWith('0')) {
        phoneToSend = phoneToSend.substring(1);
    }
    return leadApi.call({
        url: 'api/subot-campaign/check',
        method: 'post',
        data: {
            campaign_id,
            email,
            phone: phoneToSend,
        },
    });
};
const validateEmailOrPhoneOnSubot = ({ bot_id, email, phone, }) => {
    let phoneToSend = phone;
    // Remove the '0' part. Logic from Back to check between Subot and Lead with different format
    if (phoneToSend && phoneToSend.startsWith('0')) {
        phoneToSend = phoneToSend.substring(1);
    }
    return subotApi.call({
        url: 'frontend/api/subot-campaign/check',
        method: 'post',
        data: {
            bot_id,
            email,
            phone: phoneToSend,
        },
    });
};
const validatePhoneNumberOnLeadGen = ({ campaign_id, phone, }) => {
    return leadApi.call({
        url: 'api/collection/log/check-phone-with-campaign',
        method: 'post',
        data: {
            campaign_id,
            phone,
        },
    });
};
const LEAD_OTP_API = {
    whatsapp: 'api/sms/whatsapp_otp',
    phone: 'api/sms/otp',
    zalo: 'api/sms/zalo_otp',
};
const sendSMSOtpLead = ({ phone, type, }) => {
    return leadApi.call({
        url: LEAD_OTP_API[type],
        method: 'post',
        data: {
            // The type Whatsapp/Zalo do not remove the '+'
            phone_number: type === 'phone' ? phone.replace('+', '') : phone,
        },
    });
};
const LEAD_VERIFY_OTP_API = {
    whatsapp: 'api/sms/whatsapp_verify',
    phone: 'api/sms/verify',
    zalo: 'api/sms/zalo_verify',
};
const verifyOtpLead = ({ phone, otp, type, }) => {
    return leadApi.call({
        url: LEAD_VERIFY_OTP_API[type],
        method: 'post',
        data: {
            // The type Whatsapp/Zalo do not remove the '+'
            otp_code: otp,
            phone_number: type === 'phone' ? phone.replace('+', '') : phone,
        },
    });
};
const getCampaignByCode = (campaign_code) => {
    return leadApi.call({
        url: `${LEADGEN_API_PATH.V2_CAMPAIGN}/${campaign_code}`,
        method: METHOD.GET,
    });
};
const getSubscriptionBoxInfo = ({ category, site, }) => {
    return leadApi.call({
        url: `${LEADGEN_API_PATH.V2_SUBSCRIPTION_INFO}?category=${category}&site=${site}`,
        method: METHOD.GET,
    });
};
const postSubscriptionBoxLead = ({ data }) => {
    return leadApi.call({
        url: LEADGEN_API_PATH.V2_SUBSCRIPTION_LEAD,
        method: METHOD.POST,
        data,
    });
};
const postUserInfoFromLeadGen = ({ name }) => {
    return ssoApi.call({
        url: SSO_API_PATH.USER_UPDATE,
        method: METHOD.POST,
        data: { name },
    });
};
const campaignPostImpression = ({ code, action, title_article, ga_client_id, cookie_id, extra, url, referrer, }) => {
    return leadApi.call({
        url: `api/campaign/${code}/impression`,
        method: METHOD.POST,
        data: {
            action,
            title_article,
            cookie_id,
            ga_client_id,
            url,
            extra,
            referrer,
        },
    });
};
const Service = {
    campaignGetById,
    getCampaignByCode,
    getSubscriptionBoxInfo,
    postSubscriptionBoxLead,
    postUserInfoFromLeadGen,
    campaignPostImpression,
    validateEmailOrPhoneOnSubot,
    validateEmailOrPhoneOnLeadGen,
    validatePhoneNumberOnLeadGen,
    sendSMSOtpLead,
    verifyOtpLead,
};

const checkUsedEmailOrPhone = (campaignId, campaign_subot_id, data) => __awaiter(void 0, void 0, void 0, function* () {
    const key = 'email' in data ? 'email' : 'phone';
    const value = 'email' in data ? data.email : data.phone;
    const errorMsg = 'email' in data ? 'validator.emailUsed' : 'validator.phoneUsed';
    /** Check on Leadgen Tool */
    const resLeadGen = yield Service.validateEmailOrPhoneOnLeadGen({
        campaign_id: [campaignId],
        [key]: value, // Can be email or phone
    });
    if (resLeadGen._errorCode === 'SubmitLeadWithBotId_ERR_001' ||
        resLeadGen._errorCode === 'SubmitLeadWithBotId_ERR_002') {
        return errorMsg;
    }
    /** Check on Subot */
    if (campaign_subot_id.length) {
        const resSubot = yield Service.validateEmailOrPhoneOnSubot({
            bot_id: campaign_subot_id,
            [key]: value, // Can be email or phone
        });
        if (resSubot._errorCode === 'CheckSuBotLeadTool_ERR_001') {
            return errorMsg;
        }
    }
});
const checkUsedPhoneOnly = (campaignId, phone) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const resLeadGen = yield Service.validatePhoneNumberOnLeadGen({
        campaign_id: campaignId,
        phone,
    });
    if (((_a = resLeadGen === null || resLeadGen === void 0 ? void 0 : resLeadGen._messages) === null || _a === void 0 ? void 0 : _a[0]) === 'Phone was exist') {
        return 'validator.phoneUsed';
    }
});
const validatedCache = {
    email: {},
    phone: {},
    phoneOnly: {},
};
const checkUsedEmailOrPhoneWithCache = (campaignId, campaign_subot_id, data) => __awaiter(void 0, void 0, void 0, function* () {
    const key = 'email' in data ? 'email' : 'phone';
    const value = 'email' in data ? data.email : data.phone;
    const errorMsg = 'email' in data ? 'validator.emailUsed' : 'validator.phoneUsed';
    if (validatedCache[key][value]) {
        if (validatedCache[key][value].value) {
            return errorMsg;
        }
        else if (!validatedCache[key][value].value &&
            validatedCache[key][value].expire > Date.now()) {
            return '';
        }
    }
    const res = yield checkUsedEmailOrPhone(campaignId, campaign_subot_id, data);
    if (res) {
        validatedCache[key][value] = {
            value: true,
        };
    }
    else {
        validatedCache[key][value] = {
            value: false,
            expire: Date.now() + 1000 * 60,
        };
    }
    return res;
});
const checkUsedPhoneOnlyWithCache = (campaignId, phone) => __awaiter(void 0, void 0, void 0, function* () {
    if (validatedCache.phoneOnly[phone]) {
        if (validatedCache.phoneOnly[phone].value) {
            return 'validator.phoneUsed';
        }
        else if (!validatedCache.phoneOnly[phone].value &&
            validatedCache.phoneOnly[phone].expire > Date.now()) {
            return '';
        }
    }
    const res = yield checkUsedPhoneOnly(campaignId, phone);
    if (res) {
        validatedCache.phoneOnly[phone] = {
            value: true,
        };
    }
    else {
        validatedCache.phoneOnly[phone] = {
            value: false,
            expire: Date.now() + 1000 * 60,
        };
    }
    return res;
});
const clearCacheUsedEmailOrPhone = () => {
    validatedCache.email = {};
    validatedCache.phone = {};
    validatedCache.phoneOnly = {};
};

// You can give context variables any name
const [LeadFormProvider$1, useLeadFormContext$1, useLeadForm$1] = createFormContext();
const useLeadFormConfig$1 = ({ listBlockAdded = [], validatingPhoneRef, validatingEmailRef, campaignId, campaign_subot_id = [], userInfo, }) => {
    const { t } = useTranslations();
    const initialValues = useMemo(() => mappingSSOToLead(userInfo), [userInfo === null || userInfo === void 0 ? void 0 : userInfo.id]);
    useEffect(() => {
        if (!window.intlTelInputUtils) {
            require('intl-tel-input/build/js/utils');
        }
    }, []);
    const validateObj = useMemo(() => {
        const InputBlocks = [
            'TextBlock',
            'NumberBlock',
            'EmailBlock',
            'PhoneBlock',
            'DateBlock',
            'CheckboxBlock',
            'RadioBlock',
            'DropdownBlock',
            'PhoneOtpBlock',
            'WhatsappOtpBlock',
            'ZaloOtpBlock',
            'LocationBlock',
            'TncBlock',
        ];
        // ALL are required and can skip if not touched yet
        const withSharedCheck = (name, cb, 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        block) => {
            return (value) => {
                var _a;
                const isBLockRequired = (_a = block === null || block === void 0 ? void 0 : block.data) === null || _a === void 0 ? void 0 : _a.required;
                if (!formRef.current.isTouched(name))
                    return;
                if (typeof value === 'undefined' ||
                    value === '' ||
                    (Array.isArray(value) && value.length === 0)) {
                    return isBLockRequired
                        ? t('validator.required')
                        : cb === null || cb === void 0 ? void 0 : cb(value);
                }
                return cb === null || cb === void 0 ? void 0 : cb(value);
            };
        };
        return listBlockAdded
            .filter((b) => InputBlocks.includes(b.name))
            .reduce((r, b) => {
            var _a;
            const isRequired = (_a = b.data.required) !== null && _a !== void 0 ? _a : true;
            if (b.name === 'NumberBlock') {
                return Object.assign(Object.assign({}, r), { [b.data.value]: withSharedCheck(b.data.value, (value) => {
                        if (value && isNaN(Number(value))) {
                            return t('validator.number');
                        }
                    }, b) });
            }
            else if (b.name === 'EmailBlock') {
                return Object.assign(Object.assign({}, r), { [b.data.value]: withSharedCheck(b.data.value, (value) => {
                        if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                            return t('validator.email');
                        }
                        if (!value)
                            return;
                        validatingEmailRef.current = true;
                        setTimeout(() => {
                            formRef.current.setFieldError(b.data.value, 'Validating...');
                            checkUsedEmailOrPhoneWithCache(campaignId, campaign_subot_id, {
                                email: value,
                            })
                                .then((tKey) => {
                                if (tKey) {
                                    formRef.current.setFieldError(b.data.value, t(tKey));
                                }
                                else {
                                    formRef.current.clearFieldError(b.data.value);
                                }
                                validatingEmailRef.current = false;
                            })
                                .catch((e) => {
                                console.error(e);
                                formRef.current.setFieldError(b.data.value, e.message || 'Something went wrong');
                                validatingEmailRef.current = false;
                            });
                        }, 200);
                    }, b) });
            }
            else if (b.name === 'PhoneBlock' ||
                b.name === 'PhoneOtpBlock' ||
                b.name === 'ZaloOtpBlock' ||
                b.name === 'WhatsappOtpBlock') {
                return Object.assign(Object.assign({}, r), { [b.data.value]: withSharedCheck(b.data.value, (value) => {
                        if (value &&
                            window.intlTelInputUtils &&
                            !window.intlTelInputUtils.isValidNumber(String(value), LEAD_LOCALE.countryCode)) {
                            return t('validator.phone');
                        }
                        if (!value)
                            return;
                        validatingPhoneRef.current = true;
                        setTimeout(() => {
                            formRef.current.setFieldError(b.data.value, 'Validating...');
                            if (b.data.singleSubmission) {
                                checkUsedPhoneOnlyWithCache(campaignId, value)
                                    .then((tKey) => {
                                    if (tKey) {
                                        formRef.current.setFieldError(b.data.value, t(tKey));
                                    }
                                    else {
                                        formRef.current.clearFieldError(b.data.value);
                                    }
                                    validatingPhoneRef.current = false;
                                })
                                    .catch((err) => {
                                    console.error(err);
                                    formRef.current.setFieldError(b.data.value, err.message || 'Something went wrong');
                                    validatingPhoneRef.current = false;
                                });
                            }
                            else {
                                checkUsedEmailOrPhoneWithCache(campaignId, campaign_subot_id, {
                                    phone: value,
                                })
                                    .then((tKey) => {
                                    if (tKey) {
                                        formRef.current.setFieldError(b.data.value, t(tKey));
                                    }
                                    else {
                                        formRef.current.clearFieldError(b.data.value);
                                    }
                                    validatingPhoneRef.current = false;
                                })
                                    .catch((e) => {
                                    console.error(e);
                                    formRef.current.setFieldError(b.data.value, e.message || 'Something went wrong');
                                    validatingPhoneRef.current = false;
                                });
                            }
                        }, 200);
                    }, b) });
            }
            else if (b.name === 'DateBlock') {
                return Object.assign(Object.assign({}, r), { [b.data.value]: withSharedCheck(b.data.value, (value) => {
                        if (value && isNaN(Date.parse(value))) {
                            return t('validator.date');
                        }
                    }, b) });
            }
            else if (b.name === 'TncBlock') {
                return Object.assign(Object.assign({}, r), { [`TNC-` + b.id]: withSharedCheck('TNC-' + b.id, (value) => {
                        if (isRequired && !value) {
                            return t('validator.required');
                        }
                    }, b) });
            }
            else {
                return Object.assign(Object.assign({}, r), { [b.data.value]: withSharedCheck(b.data.value, undefined, b) });
            }
        }, {});
    }, [listBlockAdded.map((b) => b.name).join(',')]);
    const form = useLeadForm$1({
        validateInputOnChange: true,
        clearInputErrorOnChange: true,
        validate: validateObj,
        initialValues,
    });
    const formRef = useRef(form);
    formRef.current = form;
    return { form, validateObj };
};

const Component = ({ campaign, onClose: onCloseProp, onOtherSubmit, onSubmit, showThankyou, setShowThankyou, locale, children, showEmpty, setShowEmpty, userInfo, }) => {
    var _a, _b;
    const extraFields = campaign.extra_fields;
    const campaignId = campaign.id;
    const campaign_subot_id = campaign.bot_id || [];
    const listBlockAdded = JSON.parse(extraFields.listBlockAdded);
    const actionBlocks = JSON.parse(extraFields.actionBlocks);
    const textBlocks = JSON.parse(extraFields.textBlocks);
    const heading = ((_b = (_a = textBlocks === null || textBlocks === void 0 ? void 0 : textBlocks.titleBlock) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.value) || '';
    const description = textBlocks.subtitleBlock.data.value;
    const validatingPhoneRef = useRef(false);
    const validatingEmailRef = useRef(false);
    const leadFormConfig = useLeadFormConfig$1({
        listBlockAdded,
        validatingPhoneRef,
        validatingEmailRef,
        campaignId,
        campaign_subot_id,
        userInfo,
    });
    const [showOtpPhone, setShowOtpPhone] = useState(null);
    const [formRef, setFormRef] = useState(null);
    const onClose = () => {
        if (showOtpPhone) {
            setShowOtpPhone(null);
        }
        else {
            onCloseProp === null || onCloseProp === void 0 ? void 0 : onCloseProp();
        }
    };
    useEffect(() => {
        clearCacheUsedEmailOrPhone();
    }, []);
    return campaign ? (React__default.createElement(LeadGenComponentContext.Provider, { value: {
            campaignId,
            campaign_subot_id,
            heading,
            description,
            listBlockAdded,
            textBlocks,
            actionBlocks,
            leadFormConfig,
            validatingEmailRef,
            validatingPhoneRef,
            formRef: { current: formRef },
            setFormRef,
            locale,
            onClose,
            onOtherSubmit,
            showOtpPhone,
            setShowOtpPhone,
            onSubmit,
            showThankyou,
            setShowThankyou,
            showEmpty,
            setShowEmpty,
        } }, children)) : null;
};

const Description = (_a) => {
    var rest = __rest(_a, []);
    const { description } = useContext(LeadGenComponentContext);
    return description ? (React__default.createElement(Text, Object.assign({ size: "p3" }, rest), description)) : null;
};

const LeadGenContext$1 = createContext({});

var useStyles$2 = createStyles(() => {
    return {
        control: {},
    };
});

const libraries$1 = ['places'];
const LocationBlock = ({ name, placeholder, locale, required = true, }) => {
    var _a;
    const form = useLeadFormContext$1();
    const [searchValue, setSearchValue] = useState('');
    const [address, setAddress] = useState('');
    const { predictions } = usePlacesAutocomplete(searchValue, '', locale === 'tl-PH' ? 'en' : (_a = locale === null || locale === void 0 ? void 0 : locale.split('-')) === null || _a === void 0 ? void 0 : _a[0]);
    const [LoadScript, setLoadScript] = useState(null);
    const [ready, setReady] = useState(false);
    const randRef = useRef(Math.random().toString(36).substring(7));
    const options = useMemo(() => {
        const _opts = predictions.map((p) => {
            return {
                value: p.description,
                label: p.description,
            };
        });
        const isExist = _opts.find((o) => o.value === address);
        if (!address || isExist) {
            return _opts;
        }
        return [{ value: address, label: address }].concat(_opts);
    }, [predictions, address]);
    useEffect(() => {
        var _a, _b, _c;
        // only load extra google script when not yet loaded
        if (!((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.places) === null || _c === void 0 ? void 0 : _c.AutocompleteService)) {
            import('@react-google-maps/api').then((m) => {
                setLoadScript(() => m.LoadScript);
                setTimeout(() => {
                    setReady(true);
                }, 200);
            });
        }
        else {
            setReady(true);
        }
    }, []);
    if (!ready)
        return (React__default.createElement("div", { style: {
                height: 73,
            } }));
    return (React__default.createElement(React__default.Fragment, null,
        LoadScript && (React__default.createElement(LoadScript, { googleMapsApiKey: GOOGLE_API_KEY, libraries: libraries$1, loadingElement: React__default.createElement(React__default.Fragment, null) })),
        React__default.createElement("div", { style: { display: 'none' }, "data-extra": true, "data-name": name, "data-control": 'text' }),
        React__default.createElement(Select, Object.assign({ className: "lead-modal__form-control", label: placeholder, placeholder: placeholder, withAsterisk: required, name: name, data: options, searchValue: searchValue, onSearchChange: (query) => {
                setSearchValue(query);
            }, filter: () => true, clearable: true, searchable: true, onChange: (val) => setAddress(val || ''), icon: React__default.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none" },
                React__default.createElement("path", { d: "M10 9.792q.605 0 1.032-.427.426-.428.426-1.032 0-.603-.426-1.031A1.4 1.4 0 0 0 10 6.875q-.604 0-1.032.427a1.4 1.4 0 0 0-.426 1.031q0 .604.426 1.032.428.426 1.032.427m0 8.083q-.145 0-.292-.042a.7.7 0 0 1-.27-.145Q6.478 15 5.01 12.708 3.54 10.418 3.54 8.5q0-3.021 1.949-4.823T10 1.875t4.51 1.802q1.95 1.802 1.949 4.823 0 1.917-1.468 4.208-1.47 2.292-4.427 4.98a.7.7 0 0 1-.271.145 1 1 0 0 1-.292.042", fill: "#8C8C8C" })), autoComplete: 'no-auto-complete-' + randRef.current, rightSection: React__default.createElement(React__default.Fragment, null) }, form.getInputProps(name)))));
};

const SubtitleBlock$1 = ({ children, align, }) => (React__default.createElement("p", { className: `lead-modal__description ${'le-text-align-' + (align || '')} ${LEAD_CLASS}` }, children));

const TitleBlock$1 = ({ children, align, }) => (React__default.createElement("h2", { className: `lead-modal__title ${'le-text-align-' + (align || '')} ${LEAD_CLASS}` }, children));

const Fields = ({ listBlockAdded, popupId, locale, onClose, onOtherSubmit, styles, classNames, popoverProps, }) => {
    const { primaryColor } = useContext(LeadGenContext$1);
    const { classes, cx } = useStyles$2(undefined, {
        name: 'LeadGen__Field',
        styles,
        classNames,
    });
    const form = useLeadFormContext$1();
    return (React__default.createElement(React__default.Fragment, null, listBlockAdded.map((b, index) => {
        var _a;
        const { name = '', data = {} } = b || {};
        const { placeholder, value, align, listQuestion, isSendMailChimp = false, newtab, url, } = data;
        const required = (_a = data.required) !== null && _a !== void 0 ? _a : true;
        switch (name) {
            case 'TitleBlock':
                return (React__default.createElement(TitleBlock$1, { key: index, align: align }, value));
            case 'SubtitleBlock':
                return (React__default.createElement(SubtitleBlock$1, { key: index, align: align }, value));
            case 'TextBlock':
                return (React__default.createElement(Input, Object.assign({ key: index, withAsterisk: required, spellCheck: false, type: "text", placeholder: placeholder, className: cx('leadgen-control', classes.control), 
                    // onChangeRaw={(e) => inputOnChange('text', e)}
                    label: placeholder, "data-control": "text", name: value }, form.getInputProps(value))));
            case 'NumberBlock':
                return (React__default.createElement(NumberInput, Object.assign({ key: index, withAsterisk: required, spellCheck: false, type: "number", placeholder: placeholder, className: cx('leadgen-control', classes.control), 
                    // onChange={(e) => inputOnChange('number', e)}
                    label: placeholder, "data-control": "number", name: value }, form.getInputProps(value))));
            case 'EmailBlock':
                return (React__default.createElement(Input, Object.assign({ key: index, withAsterisk: required, spellCheck: false, 
                    // type="email"
                    placeholder: placeholder, className: cx('leadgen-control', classes.control), label: placeholder, "data-control": "email", name: value }, form.getInputProps(value))));
            case 'PhoneOtpBlock':
            case 'WhatsappOtpBlock':
            case 'ZaloOtpBlock':
            case 'PhoneBlock': {
                const id = popupId + '-' + value + '-' + index;
                return (React__default.createElement(Input.Wrapper, Object.assign({ size: "md", withAsterisk: required, key: index, label: placeholder, 
                    // error={errorField.phone}
                    className: cx('leadgen-control', classes.control), labelProps: {
                        htmlFor: id,
                    } }, form.getInputProps(value)),
                    React__default.createElement(Phone, { name: value, spellCheck: false, type: "tel", placeholder: placeholder, value: form.getInputProps(value).value, onChange: (v) => {
                            form.setFieldValue(value, v);
                        }, 
                        // onBlur={(e) => inputOnBlur('tel', e)}
                        id: id, defaultCountry: (locale ? MAPPED_LOCALE[locale] || 'VN' : 'VN'), "data-control": "tel" })));
            }
            case 'LocationBlock': {
                return (React__default.createElement(LocationBlock, { key: index, name: value, placeholder: placeholder, locale: locale, required: required }));
            }
            case 'DateBlock':
                return (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(DatePicker, Object.assign({ withAsterisk: required, key: index, type: "default", name: value, placeholder: placeholder, className: cx('leadgen-control', classes.control), label: placeholder, "data-control": "date", popoverProps: popoverProps }, form.getInputProps(value))),
                    React__default.createElement("input", { type: "hidden", name: value, "data-control": "date" })));
            case 'LinkButtonBlock':
                return (React__default.createElement("div", { key: index },
                    React__default.createElement("a", { target: newtab ? 'blank' : 'parrent', href: url, style: { textDecoration: 'none' } },
                        React__default.createElement(Button, { type: "button", size: "md", color: primaryColor, className: `lead-modal__btn ${LEAD_CLASS}`, onClick: () => {
                                onClose === null || onClose === void 0 ? void 0 : onClose();
                                onOtherSubmit === null || onOtherSubmit === void 0 ? void 0 : onOtherSubmit();
                            } }, value))));
            case 'CheckboxBlock':
                return (React__default.createElement(React__default.Fragment, null,
                    isSendMailChimp && (React__default.createElement("div", { style: {
                            display: 'none',
                        }, "data-name": value + '-mailchimp' })),
                    React__default.createElement(Checkbox.Group, Object.assign({ withAsterisk: required, className: cx('leadgen-control', classes.control), key: index, label: placeholder, size: "md", sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8,
                        } }, form.getInputProps(value)), listQuestion.map((l, _index) => (React__default.createElement(Checkbox, { name: value, key: _index, value: l.value, label: l.placeholder, "data-control": "checkbox" }))))));
            case 'RadioBlock':
                return (React__default.createElement(React__default.Fragment, null,
                    isSendMailChimp && (React__default.createElement(Input, { type: "hidden", name: value + '-mailchimp', value: isSendMailChimp })),
                    React__default.createElement(Radio.Group, Object.assign({ withAsterisk: required, className: cx('leadgen-control', classes.control), key: index, label: placeholder, size: "md" }, form.getInputProps(value)), listQuestion.map((l, _index) => (React__default.createElement(Radio, { name: value, key: _index, value: l.value, label: l.placeholder, "data-control": "radio" }))))));
            case 'DropdownBlock':
                return (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement("div", { style: { display: 'none' }, "data-extra": true, "data-name": value, "data-control": 'dropdown' }),
                    React__default.createElement(Select, Object.assign({ key: index, className: cx('leadgen-control', classes.control), label: placeholder, withAsterisk: required, name: value, data: listQuestion.map((l) => ({
                            value: l.value,
                            label: l.placeholder,
                        })) }, form.getInputProps(value)))));
            case 'TncBlock':
                const tncInputProps = form.getInputProps('TNC-' + b.id);
                return (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(Checkbox, Object.assign({ name: 'TNC-' + b.id, key: b.id, label: React__default.createElement("p", { className: "lead-modal__tnc-link", dangerouslySetInnerHTML: { __html: data.valueHTML } }), className: "tnc-block", "data-control": "checkbox" }, tncInputProps, { error: tncInputProps.error ? tncInputProps.error : undefined }))));
        }
        return null;
    })));
};

var useStyles$1 = createStyles((theme) => {
    return {
        root: {},
        header: {},
        heading: {},
        description: {},
        term: {
            a: {
                color: theme.fn.primaryColor(),
            },
        },
        controlList: {},
        control: {},
        submitBtn: {},
        submitBtnWrapper: {},
    };
});

const Heading = (_a) => {
    var rest = __rest(_a, []);
    const { heading } = useContext(LeadGenComponentContext);
    return heading ? (React__default.createElement(Text, Object.assign({ size: "h3" }, rest), heading)) : null;
};

const FormComponent = ({ styles, className, classNames, fillInfo, popoverProps, submitProps, }) => {
    var _a;
    const { primaryColor } = useContext(LeadGenContext$1);
    const { listBlockAdded, leadFormConfig: { form, validateObj }, validatingEmailRef, validatingPhoneRef, formRef, setFormRef, onClose, onOtherSubmit, actionBlocks, locale, setShowOtpPhone, onSubmit, } = useContext(LeadGenComponentContext);
    const { classes, cx } = useStyles$1(undefined, {
        name: 'LeadGen__FormComponent',
        styles,
        classNames,
    });
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const popUpSubmitText = actionBlocks.submitBlock.data.value;
    const middlewareOnSubmit = (e) => {
        e.preventDefault();
        // mark all as touched to allow validation
        form.setTouched(Object.keys(validateObj).reduce((acc, cur) => {
            acc[cur] = true;
            return acc;
        }, {}));
        if (validatingEmailRef.current || validatingPhoneRef.current) {
            return;
        }
        setTimeout(() => {
            form.onSubmit((v) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                if (Object.keys(form.errors).length)
                    return;
                let newShowOtpPhone = null;
                if (listBlockAdded.findIndex((x) => x.name === 'PhoneOtpBlock') > -1) {
                    // not submit yet, open otp
                    const fieldName = (_b = (_a = listBlockAdded.find((x) => x.name === 'PhoneOtpBlock')) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.value;
                    if ((_c = v[fieldName]) === null || _c === void 0 ? void 0 : _c.startsWith('+')) {
                        newShowOtpPhone = {
                            phone: v[fieldName],
                            type: 'phone',
                        };
                    }
                }
                if (listBlockAdded.findIndex((x) => x.name === 'WhatsappOtpBlock') > -1) {
                    // not submit yet, open otp
                    const fieldName = (_e = (_d = listBlockAdded.find((x) => x.name === 'WhatsappOtpBlock')) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.value;
                    if ((_f = v[fieldName]) === null || _f === void 0 ? void 0 : _f.startsWith('+')) {
                        newShowOtpPhone = {
                            phone: v[fieldName],
                            type: 'whatsapp',
                        };
                    }
                }
                if (listBlockAdded.findIndex((x) => x.name === 'ZaloOtpBlock') > -1) {
                    // not submit yet, open otp
                    const fieldName = (_h = (_g = listBlockAdded.find((x) => x.name === 'ZaloOtpBlock')) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.value;
                    if ((_j = v[fieldName]) === null || _j === void 0 ? void 0 : _j.startsWith('+')) {
                        newShowOtpPhone = {
                            phone: v[fieldName],
                            type: 'zalo',
                        };
                    }
                }
                if (newShowOtpPhone) {
                    setIsSubmitLoading(true);
                    Service.sendSMSOtpLead(newShowOtpPhone)
                        .then((res) => {
                        var _a;
                        const respMessage = (_a = res === null || res === void 0 ? void 0 : res._messages) === null || _a === void 0 ? void 0 : _a[0];
                        if (respMessage === 'This phone number was verified') {
                            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(formRef.current, v);
                            return;
                        }
                        setShowOtpPhone(newShowOtpPhone);
                    })
                        .finally(() => {
                        setIsSubmitLoading(false);
                    });
                    return;
                }
                onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(formRef.current, v);
            })(e);
        }, 100);
    };
    useEffect(() => {
        form === null || form === void 0 ? void 0 : form.setValues(fillInfo);
    }, [fillInfo]);
    return (React__default.createElement(LeadFormProvider$1, { form: form },
        React__default.createElement(Box, { component: "form", ref: (el) => el && setFormRef(el), className: cx(className, classes.root), onSubmit: middlewareOnSubmit, styles: styles },
            React__default.createElement("div", { className: classes.header },
                React__default.createElement(Heading, { className: classes.heading }),
                React__default.createElement(Description, { className: classes.description })),
            React__default.createElement("div", { className: classes.controlList },
                React__default.createElement(Fields, { classNames: {
                        control: classes.control,
                    }, listBlockAdded: listBlockAdded, locale: locale, onClose: onClose, onOtherSubmit: onOtherSubmit, popoverProps: popoverProps })),
            ((_a = actionBlocks === null || actionBlocks === void 0 ? void 0 : actionBlocks.submitBlock) === null || _a === void 0 ? void 0 : _a.isHide) ? null : (React__default.createElement("div", { className: classes.submitBtnWrapper },
                React__default.createElement(Button, Object.assign({ size: "md", id: "lead-submit", type: "submit", className: classes.submitBtn, loading: isSubmitLoading, color: primaryColor }, submitProps), popUpSubmitText))))));
};
const Form = (props) => {
    const { showOtpPhone, showThankyou } = useContext(LeadGenComponentContext);
    return showThankyou || showOtpPhone ? null : React__default.createElement(FormComponent, Object.assign({}, props));
};

var useStyles = createStyles(() => {
    return {
        root: {},
        header: {},
        heading: {},
        description: {},
        control: {},
        actions: {},
        submitBtn: {},
        resendOtp: {},
    };
});

const OtpBlockComponent = ({ otpData, onSuccess, autoSendWhenOpen, className, styles, classNames, }) => {
    const { t } = useTranslations();
    const phone = otpData.phone;
    const otpType = otpData.type;
    const [otp, setOtp] = useState('');
    const [isDirty, setIsDirty] = useState(false);
    const [resendTimer, setResendTimer] = useState(autoSendWhenOpen ? 0 : 60);
    const inputRef = useRef(null);
    const [errorMsg, setErrorMsg] = useState();
    const [displayPhone, setDisplayPhone] = useState('');
    const formatPhoneNumberIntlRef = useRef();
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const { classes, cx } = useStyles(undefined, {
        name: 'LeadGen__OTP',
        styles,
        classNames,
    });
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            if (!formatPhoneNumberIntlRef.current) {
                const res = yield import('react-phone-number-input');
                formatPhoneNumberIntlRef.current = res.formatPhoneNumberIntl;
            }
            setDisplayPhone(((_a = formatPhoneNumberIntlRef.current) === null || _a === void 0 ? void 0 : _a.call(formatPhoneNumberIntlRef, phone)) || phone);
        }))();
    }, [phone]);
    const sendOtp = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!phone) {
            return;
        }
        const res = yield Service.sendSMSOtpLead({
            phone,
            type: otpType,
        });
        const respMessage = (_a = res === null || res === void 0 ? void 0 : res._messages) === null || _a === void 0 ? void 0 : _a[0];
        if (respMessage === 'Send sms successfully' ||
            respMessage === 'Send WhatsApp successfully' ||
            respMessage === 'Send Zalo successfully') {
            setResendTimer(60);
            setTimeout(() => {
                if (inputRef.current) {
                    inputRef.current.focus();
                    inputRef.current.scrollIntoView({ block: 'center' });
                }
            }, 100);
        }
        else if (respMessage === 'This phone number was verified') {
            onSuccess();
        }
        else {
            setErrorMsg(respMessage || 'Something went wrong!');
            // const defaultError = f({ id: 'notification.comment.somethingWrong' })
            // setStatusVerifyOTP('idle')
            // pushNotifications({
            //   title: respMessage || defaultError,
            //   message: '',
            //   type: 'danger',
            // })
        }
    });
    const submitOtp = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!phone || !otp) {
            return;
        }
        setIsSubmitLoading(true);
        const res = yield Service.verifyOtpLead({
            phone,
            otp,
            type: otpType,
        });
        const respMessage = res === null || res === void 0 ? void 0 : res._messages[0];
        if (respMessage === 'Verify successfully' ||
            respMessage === 'Verify WhatsApp OTP sucess' ||
            respMessage === 'Verify Zalo OTP sucess') {
            onSuccess();
        }
        else if (respMessage === 'This phone number was verified') {
            onSuccess();
        }
        else {
            setErrorMsg(respMessage || 'something Wrong');
            // setIsShowError(true)
            // setStatusVerifyOTP('sent')
            // pushNotifications({
            //   title: res?._messages[0] || defaultError,
            //   message: '',
            //   type: 'danger',
            // })
        }
        setIsSubmitLoading(false);
    });
    useEffect(() => {
        setTimeout(() => {
            if (resendTimer > 0) {
                setResendTimer((r) => r - 1);
            }
        }, 1000);
    }, [resendTimer]);
    useEffect(() => {
        if (autoSendWhenOpen && !resendTimer) {
            sendOtp();
        }
    }, []);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Box, { component: "form", onSubmit: (e) => {
                e.preventDefault();
                submitOtp();
            }, className: cx(classes.root, className) },
            React__default.createElement("div", { className: classes.header },
                React__default.createElement(Heading$1, { tag: "h3", className: classes.heading }, t('lead.otp.title')),
                React__default.createElement(Text, { size: "p3", className: classes.description }, t('lead.otp.desc', { phone: displayPhone }))),
            React__default.createElement(Input, { ref: inputRef, name: '_' + name + '-otp', spellCheck: false, type: "number", placeholder: t('lead.otp.phonePlaceholder'), className: classes.control, label: t('lead.otp.phoneLabel'), "data-control": "otp", withAsterisk: true, pattern: "[0-9]*", value: otp, maxLength: 6, onChange: (v) => {
                    setIsDirty(true);
                    setOtp(v);
                    if (isDirty && !v)
                        setErrorMsg('OTP is required');
                    else
                        setErrorMsg(undefined);
                }, error: isDirty ? errorMsg : undefined }),
            React__default.createElement("div", { className: classes.actions },
                React__default.createElement(Button, { type: "submit", size: "md", color: "primary", className: classes.submitBtn, 
                    // onClick={() => submitOtp()}
                    disabled: !otp, loading: isSubmitLoading }, t('lead.otp.verify')),
                React__default.createElement(Button, { type: "button", size: "md", color: "transparent", className: classes.resendOtp, onClick: () => {
                        sendOtp();
                    }, disabled: !!resendTimer }, t('lead.otp.resend', {
                    timer: resendTimer ? ` (${resendTimer}s)` : '',
                }))))));
};
const OtpBlock$1 = (_a) => {
    var rest = __rest(_a, []);
    const { showOtpPhone, setShowOtpPhone, onSubmit, formRef, leadFormConfig: { form }, } = useContext(LeadGenComponentContext);
    return showOtpPhone ? (React__default.createElement(OtpBlockComponent, Object.assign({ otpData: showOtpPhone, autoSendWhenOpen: false, onSuccess: () => {
            setShowOtpPhone(null);
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(formRef.current, form.values);
        } }, rest))) : null;
};

const Thankyou = ({ children, }) => {
    const { showThankyou, setShowThankyou } = useContext(LeadGenComponentContext);
    return showThankyou
        ? children(showThankyou, () => setShowThankyou(null))
        : null;
};

var enPH = {
	"validator.required": "This field is required.",
	"validator.remote": "Please fix this field.",
	"validator.email": "Please enter a valid email address.",
	"validator.phone": "Please input correct phone number.",
	"validator.url": "Please enter a valid URL.",
	"validator.date": "Please enter a valid date.",
	"validator.dateISO": "Please enter a valid date (ISO).",
	"validator.number": "Please enter a valid number.",
	"validator.digits": "Please enter only digits.",
	"validator.creditcard": "Please enter a valid credit card number.",
	"validator.equalTo": "Please enter the same value again.",
	"validator.accept": "Please enter a value with a valid extension.",
	"validator.maxlength": "jQuery.validator.format('Please enter no more than {0} characters.",
	"validator.minlength": "jQuery.validator.format('Please enter at least {0} characters.",
	"validator.rangelength": "jQuery.validator.format('Please enter a value between {0} and {1} characters long.",
	"validator.range": "jQuery.validator.format('Please enter a value between {0} and {1}.",
	"validator.max": "jQuery.validator.format('Please enter a value less than or equal to {0}.",
	"validator.min": "jQuery.validator.format('Please enter a value greater than or equal to {0}.",
	"validator.emailUsed": "Email already in use for this campaign.",
	"validator.phoneUsed": "Your phone number already in use for this campaign.",
	"validator.dateInvalid": "This date is not valid, please update.",
	"lead.otp.title": "Enter OTP",
	"lead.otp.desc": "We have sent an OTP to your mobile number {phone}",
	"lead.otp.verify": "Verify",
	"lead.otp.resend": "Resend OTP{timer}",
	"lead.otp.phoneLabel": "Phone OTP",
	"lead.otp.phonePlaceholder": "Enter OTP",
	"lead.empty.title": "Oops, seem your information is empty, do you want to submit the information again?",
	"lead.empty.cancel": "Cancel",
	"lead.empty.submitAgain": "Submit again",
	"common.day": "Day",
	"common.month": "Month",
	"common.year": "Year"
};

var hiIN = {
	"validator.required": "इस क्षेत्र की आवश्यकता है।",
	"validator.email": "कृपया एक मान्य ईमेल पता दर्ज करें",
	"validator.number": "कृपया एक वैध संख्या दर्ज करें",
	"validator.digits": "कृपया केवल अंक दर्ज करें",
	"validator.maxlength": "कृपया {0} अक्षर से अधिक दर्ज न करें",
	"validator.minlength": "कृपया कम से कम {0} अक्षर दर्ज करें",
	"validator.phone": "कृपया एक वैध संख्या दर्ज करें",
	"validator.dateInvalid": "यह तिथि मान्य नहीं है, कृपया अपडेट करें।",
	"validator.emailUsed": "Email already in use for this campaign.",
	"validator.phoneUsed": "Your phone number already in use for this campaign.",
	"lead.otp.title": "Enter OTP",
	"lead.otp.desc": "We have sent an OTP to your mobile number {phone}",
	"lead.otp.verify": "Verify",
	"lead.otp.resend": "Resend OTP{timer}",
	"lead.empty.title": "ऊप्स! लगता है आपकी जानकारी खाली है। क्या आप जानकारी फिर से सबमिट करना चाहते हैं?",
	"lead.empty.cancel": "रद्द करें",
	"lead.empty.submitAgain": "फिर से सबमिट करें",
	"common.day": "साल",
	"common.month": "महीना",
	"common.year": ""
};

var idID = {
	"validator.required": "Kolom ini wajib diisi",
	"validator.email": "Tolong daftarkan email yang valid",
	"validator.number": "Tolong daftarkan nomor telepon yang valid",
	"validator.digits": "Tolong masukkan angka saja",
	"validator.maxlength": "Jangan memasukkan lebih dari {0} karakter",
	"validator.minlength": "Tolong ketik sedikitnya {0} karakter",
	"validator.phone": "Tolong daftarkan nomor telepon yang valid",
	"validator.emailUsed": "Email sudah digunakan untuk kampanye ini.",
	"validator.phoneUsed": "Nomor telepon Anda sudah digunakan untuk kampanye ini.",
	"validator.dateInvalid": "Tanggal ini tidak valid, silakan perbarui",
	"lead.otp.title": "Masukkan OTP",
	"lead.otp.desc": "Kami telah mengirimkan OTP ke nomor ponsel Anda {phone}",
	"lead.otp.verify": "Verifikasi",
	"lead.otp.resend": "Kirim Ulang OTP {timer}",
	"lead.otp.phoneLabel": "OTP Telepon",
	"lead.otp.phonePlaceholder": "Masukkan OTP",
	"lead.empty.title": "Oops, sepertinya informasi Anda kosong. Apakah Anda ingin mengirimkan informasi lagi?",
	"lead.empty.cancel": "Batal",
	"lead.empty.submitAgain": "Kirim lagi",
	"common.day": "Hari",
	"common.month": "Bulan",
	"common.year": "Tahun"
};

var kmKH = {
	"validator.required": "ព័ត៌មាន​ចាំបាច់​ដែល​ត្រូវ​បំពេញ",
	"validator.email": "សូម​វាយ​អាសយដ្ឋាន​អ៊ីម៉ែល​ឲ្យ​បាន​ត្រឹមត្រូវ",
	"validator.number": "សូម​វាយបញ្ចូល​លេខ​ឲ្យ​បាន​ត្រឹមត្រូវ",
	"validator.digits": "វាយ​បញ្ចូល​បាន​តែ​លេខ​ប៉ុណ្ណោះ",
	"validator.maxlength": "សូម​វាយ​បញ្ចូលកុំ​ឲ្យ​លើស {0} តួអក្សរ",
	"validator.minlength": "សូម​វាយ​បញ្ចូល​តិច​បំផុត {0} តួអក្ស",
	"validator.phone": "សូម​វាយបញ្ចូល​លេខ​ឲ្យ​បាន​ត្រឹមត្រូវ",
	"validator.emailUsed": "អ៊ីមែលត្រូវបានប្រើប្រាស់សម្រាប់យុទ្ធនាការនេះរួចហើយ។",
	"validator.phoneUsed": "លេខទូរស័ព្ទរបស់អ្នកត្រូវបានប្រើប្រាស់សម្រាប់យុទ្ធនាការនេះរួចហើយ។",
	"validator.dateInvalid": "កាលបរិច្ឆេទនេះមិនត្រឹមត្រូវទេ សូមធ្វើបច្ចុប្បន្នភាព។",
	"lead.otp.title": "បញ្ចូល OTP",
	"lead.otp.desc": "យើងបានផ្ញើ OTP ទៅកាន់លេខទូរសព្ទរបស់អ្នក {phone}",
	"lead.otp.verify": "ផ្ទៀងផ្ទាត់",
	"lead.otp.resend": "ផ្ញើ OTP ម្តងទៀត {timer}",
	"lead.otp.phoneLabel": "OTP ទូរស័ព្ទ",
	"lead.otp.phonePlaceholder": "បញ្ចូល OTP",
	"lead.empty.title": "អូុបស! ហាក់ដូចជាព័ត៌មានរបស់អ្នកទទេ។ តើអ្នកចង់ដាក់ស្នើព័ត៌មានម្តងទៀតទេ?",
	"lead.empty.cancel": "លុប​ចោល",
	"lead.empty.submitAgain": "ដាក់ស្នើម្ដងទៀត",
	"common.day": "ឆ្នាំ",
	"common.month": "ខែ",
	"common.year": "ថ្ងៃ"
};

var msMY = {
	"validator.required": "Bahagian ini wajib diisi.",
	"validator.email": "Sila masukkan alamat emel yang sah.",
	"validator.number": "Sila masukkan no telefon yang sah.",
	"validator.digits": "Sila masukkan nombor digit sahaja.",
	"validator.maxlength": "Sila masukkan tidak lebih dari {0} aksara",
	"validator.minlength": "Sila masukkan sekurang-kurangnya {0} aksara",
	"validator.phone": "Sila masukkan no telefon yang sah.",
	"validator.emailUsed": "Emel sudah digunakan untuk kempen ini.",
	"validator.phoneUsed": "Nombor telefon anda sudah digunakan untuk kempen ini.",
	"validator.dateInvalid": "Tarikh ini tidak sah, sila kemas kini",
	"lead.otp.title": "Masukkan OTP",
	"lead.otp.desc": "Kami telah menghantar OTP ke nombor telefon bimbit anda {phone}",
	"lead.otp.verify": "Sahkan",
	"lead.otp.resend": "Hantar semula OTP {timer}",
	"lead.otp.phoneLabel": "OTP Telefon",
	"lead.otp.phonePlaceholder": "Masukkan OTP",
	"lead.empty.title": "Oops, nampaknya maklumat anda kosong. Adakah anda ingin menghantar maklumat semula?",
	"lead.empty.cancel": "Batal",
	"lead.empty.submitAgain": "Hantar semula",
	"common.day": "Hari",
	"common.month": "Bulan",
	"common.year": "Tahun"
};

var myMM = {
	"validator.required": "ဒီနေရာမှာ ဖြည့်ဖို့ လိုအပ်ပါတယ်",
	"validator.email": "မှန်ကန်သော အီးမေးလ်လိပ်စာထည့်သွင်းပါ",
	"validator.number": "မှန်ကန်သော ဖုန်းနံပါတ်ထည့်သွင်းပါ",
	"validator.digits": "နံပါတ်များသာဖြည့်ပါ",
	"validator.maxlength": "ကျေးဇူးပြု၍ {0} ထပ်မပိုသော ဂဏန်းများသာဖြည့်ပါ",
	"validator.minlength": "ကျေးဇူးပြု၍ အနည်းဆုံး {0} ဂဏန်းဖြည့်ပါ",
	"validator.phone": "မှန်ကန်သော ဖုန်းနံပါတ်ထည့်သွင်းပါ",
	"validator.emailUsed": "ဤအေကာင့်အတွက် အီးမေးလ်ကို အသုံးပြုပြီးဖြစ်ပါသည်။",
	"validator.phoneUsed": "ဤအေကာင့်အတွက် သင့်ဖုန်းနံပါတ်ကို အသုံးပြုပြီးဖြစ်ပါသည်။",
	"validator.dateInvalid": "ယနေ့စွဲမှားနေသည်၊ ကျေးဇူးပြု၍ ပြင်ဆင်ပါ။",
	"lead.otp.title": "OTP ကိုထည့်ပါ",
	"lead.otp.desc": "ကျွန်ုပ်တို့သည် OTP ကိုသင့်ဖုန်းနံပါတ် {phone} သို့ပို့ခဲ့သည်",
	"lead.otp.verify": "အတည်ပြုပါ",
	"lead.otp.resend": "OTP ကိုထပ်မံပို့ရန် {timer}",
	"lead.otp.phoneLabel": "ဖုန်း OTP",
	"lead.otp.phonePlaceholder": "OTP ကိုထည့်ပါ",
	"lead.empty.title": "အုပ်စ်! သင့်အချက်အလက်သည် ဗလာဖြစ်နေသလိုဖြစ်သည်။ ထပ်မံတင်သွင်းလိုပါသလား?",
	"lead.empty.cancel": "မလုပ်ဆောင်ပါ",
	"lead.empty.submitAgain": "ထပ်မံတင်သွင်းပါ",
	"common.day": "ရက်",
	"common.month": "လ",
	"common.year": "နှစ်"
};

var thTH = {
	"validator.required": "ต้องระบุข้อมูลในช่องนี้",
	"validator.email": "กรุณาใส่อีเมล์ที่ถูกต้อง",
	"validator.number": "กรุณาใส่ตัวเลขที่ถูกต้อง",
	"validator.digits": "กรุณาส่เฉพาะตัวเลข",
	"validator.maxlength": "กรุณาใส่ตัวเลขมากกว่า {0} หลัก",
	"validator.minlength": "กรุณาใส่ตัวเลขอย่างน้อย {0} หลัก",
	"validator.phone": "กรุณาใส่ตัวเลขที่ถูกต้อง",
	"validator.emailUsed": "อีเมลนี้ถูกใช้สำหรับแคมเปญนี้แล้ว",
	"validator.phoneUsed": "หมายเลขโทรศัพท์ของคุณถูกใช้สำหรับแคมเปญนี้แล้ว",
	"validator.dateInvalid": "วันที่นี้ไม่ถูกต้อง โปรดอัปเดต",
	"lead.otp.title": "ป้อน OTP",
	"lead.otp.desc": "เราได้ส่ง OTP ไปยังหมายเลขโทรศัพท์มือถือของคุณ {phone}",
	"lead.otp.verify": "ยืนยัน",
	"lead.otp.resend": "ส่ง OTP อีกครั้ง {timer}",
	"lead.otp.phoneLabel": "OTP โทรศัพท์",
	"lead.otp.phonePlaceholder": "ป้อน OTP",
	"lead.empty.title": "อุ๊ปส์! ดูเหมือนว่าข้อมูลของคุณว่างเปล่า คุณต้องการส่งข้อมูลอีกครั้งหรือไม่?",
	"lead.empty.cancel": "ยกเลิก",
	"lead.empty.submitAgain": "ส่งอีกครั้ง",
	"common.day": "วัน",
	"common.month": "เดือน",
	"common.year": "ปี"
};

var viVN = {
	"validator.required": "Vui lòng điền mục này",
	"validator.email": "Vui lòng điền email có thật.",
	"validator.number": "Vui lòng điền số có thật",
	"validator.digits": "Vui lòng chỉ điền số",
	"validator.maxlength": "Vui lòng điền dưới {0} số",
	"validator.minlength": "Vui lòng điền hơn {0} số",
	"validator.remote": "Hãy sửa cho đúng.",
	"validator.url": "Hãy nhập URL.",
	"validator.date": "Hãy nhập ngày.",
	"validator.dateISO": "Hãy nhập ngày (ISO).",
	"validator.creditcard": "Hãy nhập số thẻ tín dụng.",
	"validator.equalTo": "Hãy nhập thêm lần nữa.",
	"validator.extension": "Phần mở rộng không đúng.",
	"validator.rangelength": "Hãy nhập từ {0} đến {1} kí tự.",
	"validator.range": "Hãy nhập từ {0} đến {1}.",
	"validator.max": "Hãy nhập từ {0} trở xuống.",
	"validator.min": "Hãy nhập từ {0} trở lên.",
	"validator.phone": "Nhập đúng định dạng số điện thoại",
	"validator.emailUsed": "Email này đã được sử dụng.",
	"validator.phoneUsed": "Số điện thoại này đã được sử dụng.",
	"validator.dateInvalid": "Ngày này không hợp lệ, vui lòng cập nhật.",
	"lead.otp.title": "Nhập OTP",
	"lead.otp.desc": "Chúng tôi đã gửi OTP đến số điện thoại của bạn {phone}",
	"lead.otp.verify": "Xác minh",
	"lead.otp.resend": "Gửi lại OTP {timer}",
	"lead.otp.phoneLabel": "Nhập OTP",
	"lead.otp.phonePlaceholder": "Nhập OTP",
	"lead.empty.title": "Oops, có vẻ như thông tin của bạn đang trống. Bạn có muốn gửi lại thông tin không?",
	"lead.empty.cancel": "Hủy",
	"lead.empty.submitAgain": "Gửi lại",
	"common.day": "Ngày",
	"common.month": "Tháng",
	"common.year": "Năm"
};

var zhTW = {
	"validator.required": "此為必填欄位",
	"validator.email": "請填入有效的 email 地址",
	"validator.number": "請填入有效的電話號碼",
	"validator.digits": "此欄位僅能輸入數字",
	"validator.maxlength": "請輸入少於 {0} 位數",
	"validator.minlength": "請輸入至少 {0} 位數",
	"validator.phone": "請填入有效的電話號碼",
	"validator.emailUsed": "此電子郵件已被使用於此活動。",
	"validator.phoneUsed": "您的手機號碼已被使用於此活動。",
	"validator.dateInvalid": "此日期無效，請更新.",
	"lead.otp.title": "輸入 OTP",
	"lead.otp.desc": "我們已將 OTP 發送到您的手機號碼 {phone}",
	"lead.otp.verify": "驗證",
	"lead.otp.resend": "重新發送 OTP {timer}",
	"lead.otp.phoneLabel": "電話 OTP",
	"lead.otp.phonePlaceholder": "輸入 OTP",
	"lead.empty.title": "哎呀，您的資訊似乎是空的，您想要重新提交資訊嗎？",
	"lead.empty.cancel": "取消",
	"lead.empty.submitAgain": "重新提交",
	"common.day": "日",
	"common.month": "月",
	"common.year": "年"
};

const translationsMap = {
    'en-PH': enPH,
    'vi-VN': viVN,
    'hi-IN': hiIN,
    'id-ID': idID,
    'ms-MY': msMY,
    'my-MM': myMM,
    'km-KH': kmKH,
    'zh-TW': zhTW,
    'zh-CN': zhTW,
    'th-TH': thTH,
    'tl-PH': enPH,
};
const getTranslations = (locale) => {
    const translations = Object.assign(Object.assign({}, translationsMap$1[locale]), translationsMap[locale]);
    if (translations) {
        return translations;
    }
    return translationsMap['en-PH'];
};

const LeadGenTranslationProvider = (props) => {
    const { locale, children } = props;
    const translationContextValue = useMemo(() => ({ locale, values: getTranslations(locale) }), [locale]);
    return (React__default.createElement(TranslationsContext.Provider, { value: translationContextValue }, children));
};

// import mockLeadData from './mockLeadData'
const listCampaignScheduled = [];
const listCampaignScheduledToActivated = [];
const listCampaignActiveButExpired = [];
const listCampaignExcludeSonsored = [];
const listCampaignDifferentSponsor = [];
const listCampaignNotDisplayInRangeOfTime = [];
function isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent);
}
const getShuffleArray = (array) => {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        const temp = newArray[i];
        newArray[i] = newArray[j];
        newArray[j] = temp;
    }
    return newArray;
};
const getTimeByTimezone = (timeZone = 'UTC') => {
    const date = new Date();
    return new Date(date.toLocaleString('en-US', { timeZone }));
};
const parseDateByCampaignTime = (dateStr) => {
    // Format like this: 2023-04-04 00:00:00
    try {
        const [datePart, timePart] = dateStr.split(' ');
        const [year, month, day] = datePart.split('-').map(Number);
        const [hours, minutes, seconds] = timePart.split(':').map(Number);
        /** JavaScript counts months from 0 to 11 */
        return new Date(year, month - 1, day, hours, minutes, seconds);
    }
    catch (err) {
        return null;
    }
};
const checkCampaignNowInTimeframe = (c) => {
    var _a;
    const siteId = ((_a = c.site) === null || _a === void 0 ? void 0 : _a.id) || 1;
    const startedAtStr = c.started_at;
    const endedAtStr = c.ended_at;
    const startedDate = parseDateByCampaignTime(startedAtStr);
    const endedDate = parseDateByCampaignTime(endedAtStr);
    if (!startedDate || !endedDate) {
        return false;
    }
    const timeZone = LEAD_TIMEZONE_DATA[siteId];
    const nowWithTimezoneMs = getTimeByTimezone(timeZone).getTime();
    if (nowWithTimezoneMs <= endedDate.getTime() &&
        nowWithTimezoneMs >= startedDate.getTime()) {
        listCampaignScheduledToActivated.push(c);
        return true;
    }
    return false;
};
function checkCampaignActiveButExpireAlready(c) {
    var _a;
    /** Do not setup timeframe for this campaign. No need to check */
    if (c.forever === 1) {
        return true;
    }
    const startedAtStr = c.started_at;
    const endedAtStr = c.ended_at;
    const startedDate = parseDateByCampaignTime(startedAtStr);
    const endedDate = parseDateByCampaignTime(endedAtStr);
    /** Do not setup timeframe for this campaign. No need to check */
    if (!startedDate || !endedDate) {
        return true;
    }
    const siteId = ((_a = c.site) === null || _a === void 0 ? void 0 : _a.id) || 1;
    const timeZone = LEAD_TIMEZONE_DATA[siteId];
    const nowWithTimezoneMs = getTimeByTimezone(timeZone).getTime();
    /** Check if this expire already, do not show */
    if (nowWithTimezoneMs > endedDate.getTime()) {
        listCampaignActiveButExpired.push(c);
        return false;
    }
    return true;
}
function shouldNotDisplayIfExcludeAllSponsors(c) {
    var _a;
    const excludeSponsored = Number((_a = c.rules.find((i) => i.rule == 'exclude_sponsored')) === null || _a === void 0 ? void 0 : _a.value);
    const isSponsored = Boolean(document.querySelector('.hhg-disclaimer-text'));
    if (isSponsored && excludeSponsored) {
        listCampaignExcludeSonsored.push(c);
        return true;
    }
    return false;
}
function shouldDisplayWithCurrentSponsor(c) {
    var _a, _b;
    try {
        // TODO: BE will rename `exclude_sponsored_list` later
        const stringOrArray = (_a = c.rules.find((i) => i.rule == 'exclude_sponsored_list')) === null || _a === void 0 ? void 0 : _a.value;
        const whiteListSponsors = stringOrArray instanceof Array ? stringOrArray : JSON.parse(stringOrArray);
        const dataSponsoredId = Number((_b = document
            .querySelector('[data-sponsored-id]')) === null || _b === void 0 ? void 0 : _b.getAttribute('data-sponsored-id'));
        // There is no config for sponsor id and white list, should show as default
        if (!dataSponsoredId ||
            dataSponsoredId <= 0 ||
            whiteListSponsors.length === 0) {
            return true;
        }
        // Check the dataSponsoredId exists in the white list or not.
        const isExist = whiteListSponsors.find((s) => s.id == dataSponsoredId);
        if (isExist) {
            return true;
        }
        listCampaignDifferentSponsor.push({ id: c.id, rules: c.rules });
        return false;
    }
    catch (err) {
        // Default is show
        return true;
    }
}
const filterFnCampaign = (c) => {
    if (shouldNotDisplayIfExcludeAllSponsors(c)) {
        return false;
    }
    else if (!shouldDisplayWithCurrentSponsor(c)) {
        return false;
    }
    /** Active */
    if (c.formatted_status === 1) {
        return checkCampaignActiveButExpireAlready(c);
    }
    /** Schedule */
    if (c.formatted_status === 0) {
        listCampaignScheduled.push(c);
        return checkCampaignNowInTimeframe(c);
    }
    return false;
};
const fillterApprearanceTimeCampaign = (c) => {
    var _a;
    try {
        const isTimeInRange = (currentTime, startTime, endTime) => {
            const startParts = startTime.split(':');
            const endParts = endTime.split(':');
            const startDate = new Date();
            startDate.setHours(Number(startParts[0]), Number(startParts[1]), 0, 0);
            const endDate = new Date();
            endDate.setHours(Number(endParts[0]), Number(endParts[1]), 0, 0);
            return currentTime >= startDate && currentTime <= endDate;
        };
        const rulesApprValue = (_a = c.rules.find((i) => i.rule == 'appearance_time')) === null || _a === void 0 ? void 0 : _a.value;
        const startTime = rulesApprValue.startTime;
        const endTime = rulesApprValue.endTime || '23:59';
        if (!startTime) {
            return true;
        }
        if (isTimeInRange(new Date(), startTime, endTime)) {
            return true;
        }
        listCampaignNotDisplayInRangeOfTime.push(c);
        return false;
    }
    catch (err) {
        return true;
    }
};
let timeoutRef = null;
let LEAD_SCROLL_EVENT = null;
function clearPassiveEvent() {
    if (timeoutRef) {
        clearTimeout(timeoutRef);
        timeoutRef = null;
    }
    if (LEAD_SCROLL_EVENT) {
        window.removeEventListener('scroll', LEAD_SCROLL_EVENT);
        LEAD_SCROLL_EVENT = null;
    }
}
function checkShowPopup({ leadApi, leadSiteId, leadDomain, onShowPopup, DEBUG_URL, }) {
    // clear previous passive event, check for new condition
    clearPassiveEvent();
    const leadCurrentUrl = DEBUG_URL ||
        ('https://' +
            location.hostname +
            location.pathname +
            location.search).toLowerCase();
    fetch(leadApi + 'api/campaign/' + leadSiteId, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            url: leadCurrentUrl,
            ga_client_id: getCookie('_ga') || null,
        }),
    })
        .then((response) => {
        return response.json();
        // return mockLeadData || response.json()
    })
        .then((data) => {
        var _a, _b, _c, _d;
        LeadLog('List campagin: ', data);
        LEAD_RESET_VAR();
        if (data._status == 1) {
            const campaigns = (((_b = (_a = data._data) === null || _a === void 0 ? void 0 : _a.campaigns) === null || _b === void 0 ? void 0 : _b.filter(filterFnCampaign)) || []).filter(fillterApprearanceTimeCampaign);
            if (!getCookie('hhg-id')) {
                setCookie('hhg-id', v1(), {
                    domain: '.' + leadDomain,
                    path: '/',
                });
                LeadLog('😍 Set HHG ID cookie');
            }
            // getCookie('hhg-id')
            // TODO: HP-534 Filter desktop
            let campaignsDevice = [];
            if (isMobile()) {
                campaignsDevice = campaigns.filter((c) => c.device_types.some((d) => d.id == LEAD_DEVICE_TYPE.MOBILE));
            }
            else {
                campaignsDevice = campaigns.filter((c) => c.device_types.some((d) => d.id == LEAD_DEVICE_TYPE.DESKTOP));
            }
            LeadLog(`👓 campaignsDevice`, campaignsDevice);
            LeadLog('--listCampaignScheduled', listCampaignScheduled);
            LeadLog('--listCampaignScheduledToActivated', listCampaignScheduledToActivated);
            LeadLog('--listCampaignActiveButExpired', listCampaignActiveButExpired);
            LeadLog('--listCampaignExcludeSonsored', listCampaignExcludeSonsored);
            LeadLog('--listCampaignDifferentSponsor', listCampaignDifferentSponsor);
            LeadLog('--listCampaignNotDisplayInRangeOfTime', listCampaignNotDisplayInRangeOfTime);
            // Check links
            let listLinksObj = campaignsDevice
                .map((i, index) => i.targets
                .filter((i) => i.type == CAMPAIGN_TARGET_TYPE.LINKS)
                .map((i) => (Object.assign(Object.assign({}, i), { campaignIndex: index }))))
                .flat(1);
            // Check list link match current href
            listLinksObj = listLinksObj.filter((i) => {
                var _a;
                const target = new URL(String(i.target).toLowerCase());
                if (i.option == 'exact_match')
                    // FOR TEST LOCAL:
                    // return Boolean(location.pathname === target.pathname)
                    return Boolean(leadCurrentUrl === ((_a = target.href) === null || _a === void 0 ? void 0 : _a.toLowerCase()));
                if (i.option == 'start_with') {
                    // FOR TEST LOCAL:
                    // if (location.pathname.includes(target.pathname)) {
                    if (leadCurrentUrl.includes(String(i.target).toLowerCase())) {
                        const listExcluding = i.sub_target
                            .filter((i) => i.option == 'excluding')
                            .map((i) => { var _a; return (_a = i.value) === null || _a === void 0 ? void 0 : _a.toLowerCase(); });
                        return !listExcluding.includes(leadCurrentUrl.split('?')[0]);
                    }
                    else {
                        return false;
                    }
                }
            });
            // Check tags
            const listMetaTag = Array.from(document.getElementsByTagName('META')).filter((i) => i.getAttribute('property') == 'article:tag');
            const listTags = listMetaTag.map((i) => i.content);
            let listCampaignHasTag = [];
            let listTagsObj = [];
            if (listTags && listTags.length) {
                listCampaignHasTag = campaignsDevice
                    .map((i, index) => i.targets
                    .filter((i) => i.type == CAMPAIGN_TARGET_TYPE.TAGS)
                    .map((i) => (Object.assign(Object.assign({}, i), { campaignIndex: index }))))
                    .flat(1);
                listTagsObj = listCampaignHasTag.filter((i) => listTags.includes(i.target));
            }
            const listCampaginsMatch = [...listLinksObj, ...listTagsObj];
            const cookieKeys = document.cookie
                .split('; ')
                .map((i) => i.split('=')[0]);
            const listCampaignCodeSubmited = cookieKeys.filter((i) => i.includes('lead_submited'));
            LeadLog(`--listCampaignCodeSubmited`, listCampaignCodeSubmited);
            const listCampaignCodeClosed = cookieKeys.filter((i) => i.includes('lead_closed'));
            LeadLog(`--listCampaignCodeClosed`, listCampaignCodeClosed);
            const listCampaignSubmitedClosed = [
                ...listCampaignCodeSubmited,
                ...listCampaignCodeClosed,
            ];
            const listCampaignNoSubmitedClosed = listCampaginsMatch.filter((i) => {
                const hasSubmited = listCampaignSubmitedClosed.some((k) => k.includes(campaignsDevice[i.campaignIndex].code));
                return !hasSubmited;
            });
            const listCampaignValid = getShuffleArray(listCampaignNoSubmitedClosed);
            // .sort(
            //   (a, b) =>
            //     (listCampaignValid[a.campaignIndex]?.score || 0) -
            //     (listCampaignValid[b.campaignIndex]?.score || 0),
            // )
            LeadLog('--listCampaignValid : ', listCampaignValid);
            if (listCampaignValid && listCampaignValid.length) {
                const CAMPAIGN_SHOW = campaignsDevice[listCampaignValid[0].campaignIndex];
                LeadLog(`CAMPAIGN_SHOW`, CAMPAIGN_SHOW);
                const { rules } = CAMPAIGN_SHOW;
                // CHECK RULE TRIGGER POPUP
                const timeoutRule = Number((_c = rules.find((i) => i.rule == 'time')) === null || _c === void 0 ? void 0 : _c.value);
                LeadLog(`timeoutRule`, timeoutRule);
                const scrollRule = Number((_d = rules.find((i) => i.rule == 'scroll')) === null || _d === void 0 ? void 0 : _d.value);
                LeadLog(`scrollRule`, scrollRule);
                let impressionAction = 'TIME';
                if (Number.isInteger(timeoutRule)) {
                    impressionAction = 'TIME';
                    LeadLog('✨ SHOW AWESOME POPUP AFTER: ', timeoutRule, ' seconds');
                    timeoutRef = setTimeout(() => {
                        onShowPopup === null || onShowPopup === void 0 ? void 0 : onShowPopup(CAMPAIGN_SHOW, impressionAction);
                    }, timeoutRule * 1000);
                }
                if (Number.isInteger(scrollRule)) {
                    impressionAction = 'SCROLL';
                    LeadLog('✨ SHOW AWESOME AFTER: SCROLL', scrollRule, ' %');
                    const $p = document.querySelector(`[data-url="${location.pathname}"]`) ||
                        document.querySelector('body');
                    const pct = $p.getBoundingClientRect().top;
                    const pb = $p.offsetHeight;
                    LeadLog(`👓 Element check scroll: `, $p);
                    LEAD_SCROLL_EVENT = function leadScollCheckHandler() {
                        const wt = window.pageYOffset || document.documentElement.scrollTop;
                        let percent = 0;
                        if (wt >= pct) {
                            percent = Math.round(((wt - pct) / (pb - innerHeight)) * 100);
                        }
                        LeadLog('---Scroll', percent, scrollRule);
                        // TODO: CHECK FOOTER HEIGHT
                        if (percent >= scrollRule) {
                            window.removeEventListener('scroll', LEAD_SCROLL_EVENT);
                            onShowPopup === null || onShowPopup === void 0 ? void 0 : onShowPopup(CAMPAIGN_SHOW, impressionAction);
                        }
                    };
                    window.addEventListener('scroll', LEAD_SCROLL_EVENT, {
                        passive: true,
                    });
                }
            }
            else {
                LeadLog('🚧 No lead campaigns on current URL, tags');
            }
        }
    })
        .catch((err) => {
        LeadLog(`Lead error: `, err);
    });
}
const LeadLog = (...params) => {
    if (process.env.NODE_ENV !== 'production' ||
        (process.env.NEXT_PUBLIC_DEPLOY_ENV &&
            process.env.NEXT_PUBLIC_DEPLOY_ENV !== 'production') ||
        (typeof localStorage !== 'undefined' &&
            localStorage.getItem('hhg_debug') === 'true')) {
        console.log(...params);
    }
};

const LeadGenContext = createContext({
    submit(value) {
        /** Init for FAKING function */
        LeadLog('** LeadGen Submit : ', value);
        return Promise.reject(value);
    },
    submitSubscriptionBox(value) {
        /** Init for FAKING function */
        LeadLog('** LeadGen SubmitSubscriptionBox : ', value);
        return Promise.reject(value);
    },
    impression(value) {
        /** Init for FAKING function */
        LeadLog('** LeadGen Impression : ', value);
        return Promise.reject(value);
    },
    /** For Subscription Box */
    subscriptionIcon: '',
    subscriptionTitle: '',
});
const LeadGenContextProvider = (props) => {
    const { campaign_code: campaignCodeProps, apiSsoUrl, apiLeadUrl, apiSubotUrl, locale: localeProps, forceCampaign: forceCampaignProps, extraValues, articleId = 1, categoryId = 1, siteDomain: site_domain, children } = props, restProps = __rest(props, ["campaign_code", "apiSsoUrl", "apiLeadUrl", "apiSubotUrl", "locale", "forceCampaign", "extraValues", "articleId", "categoryId", "siteDomain", "children"]);
    const [forceCampaign, setForceCampaign] = useState(forceCampaignProps);
    const [subscriptionInfo, setSubscriptionInfo] = useState({
        subscriptionIcon: '',
        subscriptionTitle: '',
        subscriptionType: 'TypeA',
    });
    const locale = useMemo(() => {
        return localeProps || LOCALE['PhilippinesEnglish'];
    }, [localeProps]);
    const { url, campaign_id, campaign_code, cookie_id, ga_client_id, category_id, article_id, article_title, } = useMemo(() => ({
        url: location.href.toLowerCase() || '',
        cookie_id: getCookie('hhg-id') || null,
        ga_client_id: getCookie('_ga'),
        campaign_id: forceCampaign === null || forceCampaign === void 0 ? void 0 : forceCampaign.id,
        campaign_code: campaignCodeProps || (forceCampaign === null || forceCampaign === void 0 ? void 0 : forceCampaign.code),
        category_id: categoryId,
        article_id: articleId,
        article_title: (extraValues === null || extraValues === void 0 ? void 0 : extraValues.article_title) || document.title || '',
    }), [
        campaignCodeProps,
        articleId,
        categoryId,
        forceCampaign === null || forceCampaign === void 0 ? void 0 : forceCampaign.id,
        extraValues === null || extraValues === void 0 ? void 0 : extraValues.article_title,
    ]);
    const fetchCampaign = useCallback((campaign_code) => {
        Service.getCampaignByCode(campaign_code).then((res) => {
            const { _data } = res || {};
            const { campaigns } = _data || {};
            LeadLog('** LeadGen Campaign : ', campaigns);
            setForceCampaign(formatCampaignDetail(campaigns));
        });
    }, [campaignCodeProps]);
    // TODO : Update form for LeadGen
    const submit = useCallback((data) => {
        return Service.postSubscriptionBoxLead({ data });
    }, []);
    const submitSubscriptionBox = useCallback((value) => {
        const data = Object.assign(Object.assign(Object.assign(Object.assign({}, value), { campaign_id,
            site_domain, url: (value === null || value === void 0 ? void 0 : value.url) || url, cookie_id, ga_client_id: (value === null || value === void 0 ? void 0 : value.ga_client_id) || ga_client_id }), extraValues), { article_id,
            category_id,
            article_title });
        return Service.postSubscriptionBoxLead({ data });
    }, [
        extraValues,
        site_domain,
        campaign_id,
        article_id,
        article_title,
        category_id,
        url,
        cookie_id,
        ga_client_id,
    ]);
    const impression = useCallback((value) => {
        const impression = {
            url: (value === null || value === void 0 ? void 0 : value.url) || url,
            action: (value === null || value === void 0 ? void 0 : value.action) || LEADGEN_ACTIONS.SCROLL,
            code: (value === null || value === void 0 ? void 0 : value.code) || campaign_code,
            title_article: (value === null || value === void 0 ? void 0 : value.title_article) || article_title,
            cookie_id: (value === null || value === void 0 ? void 0 : value.cookie_id) || cookie_id,
            ga_client_id: (value === null || value === void 0 ? void 0 : value.ga_client_id) || ga_client_id,
            referrer: value === null || value === void 0 ? void 0 : value.referrer,
            extra: Object.assign(Object.assign(Object.assign({}, value === null || value === void 0 ? void 0 : value.extra), { cookie_id,
                article_id, subscription_title: subscriptionInfo.subscriptionTitle, subscription_type: subscriptionInfo.subscriptionType }), extraValues),
        };
        if (!impression.extra.subscription_title) {
            delete impression.extra.subscription_title;
        }
        return Service.campaignPostImpression(impression);
    }, [
        extraValues,
        campaign_id,
        url,
        campaign_code,
        article_title,
        cookie_id,
        ga_client_id,
        article_id,
        subscriptionInfo.subscriptionTitle,
        subscriptionInfo.subscriptionType,
    ]);
    useEffect(() => {
        if (forceCampaignProps) {
            setForceCampaign(formatCampaignDetail(forceCampaignProps));
            return;
        }
        /** For Subscription Box */
        if (categoryId) {
            Service.getSubscriptionBoxInfo({
                category: categoryId,
                site: site_domain,
            }).then((res) => {
                const { _data } = res || {};
                const { item, campaign_code } = _data || {};
                const { icon, content } = item || {};
                LeadLog('** LeadGen SubscriptionBox campaign_code : ', campaign_code);
                LeadLog('** LeadGen SubscriptionBox subscription_icon : ', icon);
                LeadLog('** LeadGen SubscriptionBox subscription_title : ', content);
                setSubscriptionInfo((prev) => (Object.assign(Object.assign({}, prev), { subscriptionIcon: icon, subscriptionTitle: content })));
                if (campaign_code) {
                    fetchCampaign(campaign_code);
                }
            });
            return;
        }
        if (campaignCodeProps) {
            fetchCampaign(campaignCodeProps);
        }
    }, [forceCampaignProps, campaignCodeProps, categoryId]);
    useEffect(() => {
        leadStore.apiSsoUrl = apiSsoUrl;
        leadStore.apiLeadUrl = apiLeadUrl;
        leadStore.apiSubotUrl = apiSubotUrl;
    }, [apiLeadUrl, apiSubotUrl, apiSsoUrl]);
    if (!forceCampaign || !(forceCampaign === null || forceCampaign === void 0 ? void 0 : forceCampaign.id)) {
        return null;
    }
    return (React__default.createElement(LeadGenContext.Provider, { value: Object.assign(Object.assign(Object.assign({}, restProps), subscriptionInfo), { campaign_code: campaignCodeProps, apiSsoUrl,
            apiLeadUrl,
            apiSubotUrl, locale: localeProps, extraValues,
            articleId,
            categoryId, siteDomain: site_domain, forceCampaign,
            submit,
            submitSubscriptionBox,
            impression }) },
        React__default.createElement(LeadGenTranslationProvider, { locale: locale }, children)));
};
const useLeadGenContext = () => {
    const context = useContext(LeadGenContext);
    return Object.assign(Object.assign({}, context), { apiSsoUrl: context.apiSsoUrl || leadStore.apiSsoUrl, apiLeadUrl: context.apiLeadUrl || leadStore.apiLeadUrl, apiSubotUrl: context.apiSubotUrl || leadStore.apiSubotUrl });
};

// eslint-disable-next-line @typescript-eslint/no-var-requires
const customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(customParseFormat);
/** https://hhgdev.atlassian.net/browse/EL-565 */
// const LEADGEN_MAP_VALIDATE = {
//   name: 'leadgen.message.error.name_required',
// }
// You can give context variables any name
const [LeadFormProvider, useLeadFormContext, useLeadForm] = createFormContext();
const useLeadFormConfig = ({ listBlockAdded = [], validatingPhoneRef, validatingEmailRef, campaignId, campaign_subot_id = [], userInfo, format, }) => {
    var _a;
    const { t } = useTranslations();
    const initialValues = useMemo(() => mappingSSOToLead(userInfo), [userInfo === null || userInfo === void 0 ? void 0 : userInfo.id]);
    const LEAD_LOCALE = LEAD_LOCALE_DATA[(_a = document === null || document === void 0 ? void 0 : document.documentElement) === null || _a === void 0 ? void 0 : _a.lang] ||
        LEAD_LOCALE_DATA['vi-VN'];
    const validateObj = useMemo(() => {
        const InputBlocks = [
            'TextBlock',
            'NumberBlock',
            'EmailBlock',
            'PhoneBlock',
            'DateBlock',
            'CheckboxBlock',
            'RadioBlock',
            'DropdownBlock',
            'PhoneOtpBlock',
            'WhatsappOtpBlock',
            'ZaloOtpBlock',
            'LocationBlock',
            'TncBlock',
        ];
        // ALL are required and can skip if not touched yet
        const withSharedCheck = (name, cb, 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        block) => {
            return (value) => {
                var _a;
                const isBLockRequired = (_a = block === null || block === void 0 ? void 0 : block.data) === null || _a === void 0 ? void 0 : _a.required;
                if (!formRef.current.isTouched(name))
                    return;
                if ((typeof value === 'string' && value.trim() === '') ||
                    typeof value === 'undefined' ||
                    (Array.isArray(value) && value.length === 0)) {
                    return isBLockRequired
                        ? t('validator.required')
                        : cb === null || cb === void 0 ? void 0 : cb(value);
                }
                return cb === null || cb === void 0 ? void 0 : cb(value);
            };
        };
        return listBlockAdded
            .filter((b) => InputBlocks.includes(b.name))
            .reduce((r, b) => {
            const { name: fieldType, data } = b || {};
            const { value: fieldName, required } = data || {};
            const isRequired = required !== null && required !== void 0 ? required : true;
            if (fieldType === 'NumberBlock') {
                return Object.assign(Object.assign({}, r), { [fieldName]: withSharedCheck(fieldName, (value) => {
                        if (value && isNaN(Number(value))) {
                            return t('validator.number');
                        }
                    }, b) });
            }
            else if (fieldType === 'EmailBlock') {
                return Object.assign(Object.assign({}, r), { [fieldName]: withSharedCheck(fieldName, (value) => {
                        if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                            return t('validator.email');
                        }
                        if (!value)
                            return;
                        validatingEmailRef.current = true;
                        setTimeout(() => {
                            formRef.current.setFieldError(fieldName, 'Validating...');
                            checkUsedEmailOrPhoneWithCache(campaignId, campaign_subot_id, {
                                email: value,
                            })
                                .then((tKey) => {
                                if (tKey) {
                                    formRef.current.setFieldError(fieldName, t(tKey));
                                }
                                else {
                                    formRef.current.clearFieldError(fieldName);
                                }
                                validatingEmailRef.current = false;
                            })
                                .catch((e) => {
                                console.error(e);
                                formRef.current.setFieldError(fieldName, e.message || 'Something went wrong');
                                validatingEmailRef.current = false;
                            });
                        }, 200);
                    }, b) });
            }
            else if (fieldType === 'PhoneBlock' ||
                fieldType === 'PhoneOtpBlock' ||
                fieldType === 'ZaloOtpBlock' ||
                fieldType === 'WhatsappOtpBlock') {
                return Object.assign(Object.assign({}, r), { [fieldName]: withSharedCheck(fieldName, (value) => {
                        if (value &&
                            window.intlTelInputUtils &&
                            !window.intlTelInputUtils.isValidNumber(String(value), LEAD_LOCALE.countryCode)) {
                            return t('validator.phone');
                        }
                        if (!value)
                            return;
                        validatingPhoneRef.current = true;
                        setTimeout(() => {
                            formRef.current.setFieldError(fieldName, 'Validating...');
                            if (b.data.singleSubmission) {
                                checkUsedPhoneOnlyWithCache(campaignId, value)
                                    .then((tKey) => {
                                    if (tKey) {
                                        formRef.current.setFieldError(fieldName, t(tKey));
                                    }
                                    else {
                                        formRef.current.clearFieldError(fieldName);
                                    }
                                    validatingPhoneRef.current = false;
                                })
                                    .catch((err) => {
                                    console.error(err);
                                    formRef.current.setFieldError(fieldName, err.message || 'Something went wrong');
                                    validatingPhoneRef.current = false;
                                });
                            }
                            else {
                                checkUsedEmailOrPhoneWithCache(campaignId, campaign_subot_id, {
                                    phone: value,
                                })
                                    .then((tKey) => {
                                    if (tKey) {
                                        formRef.current.setFieldError(fieldName, t(tKey));
                                    }
                                    else {
                                        formRef.current.clearFieldError(fieldName);
                                    }
                                    validatingPhoneRef.current = false;
                                })
                                    .catch((e) => {
                                    console.error(e);
                                    formRef.current.setFieldError(fieldName, e.message || 'Something went wrong');
                                    validatingPhoneRef.current = false;
                                });
                            }
                        }, 200);
                    }, b) });
            }
            else if (fieldType === 'DateBlock') {
                return Object.assign(Object.assign({}, r), { [fieldName]: withSharedCheck(fieldName, (value) => {
                        if (!isRequired && !value) {
                            return;
                        }
                        const errMsg = t('validator.dateInvalid');
                        const dayInJS = typeof value === 'string'
                            ? dayjs(value, format, true)
                            : dayjs(value);
                        if (!dayInJS.isValid()) {
                            return errMsg;
                        }
                    }, b) });
            }
            else if (fieldType === 'TncBlock') {
                return Object.assign(Object.assign({}, r), { [`TNC-` + b.id]: withSharedCheck('TNC-' + b.id, (value) => {
                        if (isRequired && !value) {
                            return t('validator.required');
                        }
                    }, b) });
            }
            else {
                return Object.assign(Object.assign({}, r), { [fieldName]: withSharedCheck(fieldName, undefined, b) });
            }
        }, {});
    }, [listBlockAdded.map((b) => b.name).join(','), format]);
    const form = useLeadForm({
        validateInputOnChange: true,
        validateInputOnBlur: true,
        clearInputErrorOnChange: true,
        validate: validateObj,
        initialValues,
    });
    const formRef = useRef(form);
    formRef.current = form;
    return { form, validateObj };
};

const StyledLeadGenThankYou = styled.div `
  display: flex;
  gap: 8px;
  flex-direction: column;
  padding-block: 24px;

  .leadgen-image {
    width: 120px;
    height: 120px;
    margin-inline: auto;
    object-fit: contain;
    object-position: center;
    text-align: center;
  }

  .leadgen-title {
    margin-block: 0;
    color: ${theme.colors.gray900};
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: -0.2px;
  }

  .leadgen-description {
    margin-block: 0;
    color: ${theme.colors.gray600};
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.2px;
    text-align: center;
  }

  > [data-align] {
    &[data-align='right'] {
      text-align: right;
    }
    &[data-align='center'] {
      text-align: center;
    }
  }
`;
const LeadGenThankYou = ({ image, title, description, showButton = false, button, className, style, }) => {
    const { src } = image;
    const { htmlText: titleText, align: titleAlign } = title;
    const { htmlText: descriptionText, align: descriptionAlign } = description;
    const { htmlText: buttonText, newtab, url, onClick } = button;
    return (React__default.createElement(StyledLeadGenThankYou, { className: className, style: style },
        React__default.createElement("img", { src: src, alt: "", className: "leadgen-thankyou_image leadgen-image" }),
        React__default.createElement("p", { className: "leadgen-thankyou_title leadgen-title", "data-align": titleAlign }, titleText),
        React__default.createElement("p", { className: "leadgen-thankyou_description leadgen-description", "data-align": descriptionAlign }, descriptionText),
        !!buttonText && showButton && (React__default.createElement(Button$1, { component: url ? 'a' : 'button', target: newtab ? '_blank' : undefined, href: url, size: "lg", variant: "filled", className: "leadgen-thankyoue_btn leadgen-btn", onClick: onClick }, buttonText))));
};

const StyledLeadGenSubscriptionBoxBody = styled.div `
  margin-top: 16px;
  .leadgen-btn {
    margin-top: 16px;
  }
`;
const StyledLeadGenSubscriptionBoxHeaderImage = styled.div `
  margin-top: 3px;
  margin-right: 20px;
  width: 44px;
  height: 44px;

  img {
    width: 100%;
    height: 100%;
    object-fix: contain;
    onject-position: center;
  }

  :has(img[src='']) {
    display: none;
  }
`;
const StyledLeadGenSubscriptionBoxHeader = styled.div `
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  .leadgen-title {
    margin-bottom: 0;
    flex: 1;
    min-width: 0;
    color: ${theme.colors.gray900};
    font-size: 16px;
    font-weight: 400;
    line-height: 1.4;
    letter-spacing: -0.4px;
  }

  ${MediaQueries.mbUp} {
    .leadgen-title {
      font-size: 18px;
      letter-spacing: -0.8px;
    }
  }
`;
const StyledLeadGenSubscriptionBox = styled.div `
  padding: 16px;
  border: 1px solid ${theme.colors.neutral100};
  border-radius: 12px;
  margin-inline: auto;
  .leadgen-form_inputs {
    .leadgen-form_input {
      width: 100%;
    }
  }

  .leadgen-form_input {
    .mantine-Input-wrapper {
      max-height: 56px;
    }
  }

  ${MediaQueries.mbUp} {
    .leadgen-subscription_box_body {
      display: flex;
      > form {
        flex: 1;
        min-width: 0;

        .leadgen-form_inputs {
          .leadgen-form_input {
            width: calc(50% - 4px);
          }
        }
      }

      .leadgen-btn {
        margin-top: 0;
        margin-left: 8px;
        width: auto;
        min-height: 56px;
      }
    }
  }

  ${MediaQueries.smbDown} {
    &[data-type='subscription_box_A'] {
      border-inline: 0;
      border-radius: 0;
      margin-inline: -16px;
      box-shadow: 0px 0px 1px 0px #0000000a, 0px 0px 2px 0px #0000000f,
        0px 4px 8px 0px #0000000a;
    }
  }
`;
const StyledLeadGenSubscriptionBoxA = styled.div `
  .leadgen-form_input {
    --phone-select: 45px;
    .PhoneInput {
      --phone-select: 45px;
      .PhoneInputCountry {
        margin-top: 1px;
        pointer-events: none;
        .PhoneInputCountryIconImg,
        .PhoneInputArrowContainer {
          display: none;
        }
      }
    }
  }
`;

const PhoneInput = forwardRef((props, ref) => {
    const { defaultCountry, id: idProps, name, placeholder, label, labelElement, labelProps, description, descriptionProps, withAsterisk, inputMode, inputContainer, inputWrapperOrder, error, className, classNames, style, styles } = props, restProps = __rest(props, ["defaultCountry", "id", "name", "placeholder", "label", "labelElement", "labelProps", "description", "descriptionProps", "withAsterisk", "inputMode", "inputContainer", "inputWrapperOrder", "error", "className", "classNames", "style", "styles"]);
    const id = idProps || v1() + name;
    return (React__default.createElement(Input$1.Wrapper, { size: "md", label: label, labelElement: labelElement, labelProps: Object.assign({ htmlFor: id }, labelProps), description: description, descriptionProps: descriptionProps, withAsterisk: withAsterisk, inputMode: inputMode, inputContainer: inputContainer, inputWrapperOrder: inputWrapperOrder, error: error, "data-invalid": !!error, className: className, classNames: classNames, style: style, styles: styles },
        React__default.createElement("div", { className: "mantine-Input-wrapper" },
            React__default.createElement(Phone, Object.assign({}, restProps, { id: id, ref: ref, name: name, spellCheck: false, placeholder: placeholder, defaultCountry: defaultCountry, className: "mantine-Input-input", type: "tel", "data-control": "tel" })))));
});

const formatLeadGenFormValue = (values, blocks) => {
    const newValues = {};
    for (const block of blocks) {
        const { data } = block || {};
        const { value: fieldName } = data || {};
        if (fieldName in values) {
            newValues[fieldName] = values[fieldName];
        }
    }
    return newValues;
};

const StyledLeadGenFormInner = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  .leadgen-form_input {
    width: calc(50% - 4px);
  }

  .leadgen-form_input_checkbox {
    width: 100%;
  }

  .mantine-InputWrapper-error {
    margin-top: 4px;
    padding-top: 1px;
    padding-bottom: 1px;
    color: #f44d2c;
    font-size: 12px;
    line-height: 1.5;
  }
`;

const cssInputNotShrink$1 = css `
  height: 100% !important;
  min-height: calc(var(--container-height, 56px) * 24 / 56);
  color: ${theme.colors.gray800};
  font-size: var(--input, 15px);
  line-height: calc(var(--container-height, 56px) * 24 / 56);
  letter-spacing: -0.3px;
  border: none !important;
  border-radius: 0 !important;
  outline: none !important;
  box-shadow: none !important;
  padding: 0;
  cursor: pointer;
  opacity: 0;

  ::placeholder {
    color: ${theme.colors.gray400};
  }
`;
const cssInputShrink$1 = css `
  height: auto !important;
  cursor: text;
  opacity: 1;
  transition: 0.1s ease-in-out all;
`;
const cssLabelNotShrink$1 = css `
  position: absolute;
  top: calc(var(--container-height) / 2);
  left: var(--space-x, 16px);
  color: ${theme.colors.gray400};
  font-size: var(--label-not-shrink, 15px);
  font-weight: 400;
  line-height: calc(var(--container-height, 56px) * 18 / 56);
  margin: 0;
  z-index: 1;
  cursor: pointer;
  transform: translateY(-50%);
  transition: 0.125s ease-in all;
`;
const cssLabelShrink$1 = css `
  color: ${theme.colors.gray600};
  font-size: var(--label-shrink, 12px);
  top: calc(var(--container-height) * 7 / 56);
  transform: none;
  transition: 0.125s ease-out all;
`;
const cssWrapperInputNotShrink$1 = css `
  min-height: var(--container-height, 56px);
  display: flex;
  align-items: flex-end;
  border: 1px solid ${theme.colors.gray200};
  border-radius: 8px;
  background-color: #fff;
  padding-inline: var(--space-x, 16px);
  padding-block: var(--space-y-not-shrink, 16px);
  cursor: pointer;
  pointer-events: none;

  &:has(.mantine-Input-rightSection) {
    padding-right: var(--container-height, 56px);
  }

  .mantine-Input-icon {
    display: none;
  }

  .mantine-NumberInput-control {
    border-color: ${theme.colors.gray200};
  }
`;
const cssWrapperInputShrink$1 = css `
  height: auto;
  min-height: var(--container-height, 56px);
  padding-block: var(--space-y-shrink, 7px);
  cursor: text;
  pointer-events: auto;
`;
const cssInputWrapperError$1 = css `
  color: ${theme.colors.red800};
  font-size: 12px;
  line-height: 1.5;
`;
const StyledTextFieldContainer$1 = styled.div `
  --space-x: 16px;
  --space-y-not-shrink: 15px;
  --space-y-shrink: 7px;
  --container-height: 56px;
  --label-not-shrink: 16px;
  --label-shrink: 12px;
  --input: 15px;

  position: relative;
  min-width: 100px;
  max-width: 100%;
  display: inline-block;

  .textField_wrapper {
    display: inline-block;
    width: 100%;
    cursor: pointer;
  }

  .mantine-InputWrapper-root {
    &[data-invalid='true'] {
      .mantine-Input-wrapper {
        border-color: ${theme.colors.red400};
      }
    }

    .mantine-Input-wrapper {
      &:has([data-invalid]) {
        border-color: ${theme.colors.red400};
      }
    }
  }

  .mantine-InputWrapper-label {
    ${cssLabelNotShrink$1}
  }

  .mantine-Input-wrapper {
    ${cssWrapperInputNotShrink$1}

    + .mantine-Popover-dropdown[data-position="bottom-start"] {
      left: 0 !important;
    }
    + .mantine-Popover-dropdown[data-position='top-start'] {
      top: unset !important;
      left: 0 !important;
      bottom: 100% !important;
    }
  }

  .mantine-Input-input {
    ${cssInputNotShrink$1}
  }

  &.textField_shrink,
  &:focus-within {
    .mantine-InputWrapper-label {
      ${cssLabelShrink$1}
    }

    .mantine-Input-wrapper {
      ${cssWrapperInputShrink$1}
      &.mantine-Select-wrapper {
        .mantine-Select-rightSection {
          pointer-events: auto !important;
        }
      }
    }

    .mantine-Input-input {
      ${cssInputShrink$1}
    }

    &:has(.PhoneInput) {
      .mantine-InputWrapper-label {
        left: var(--space-x, 16px);
      }
      .PhoneInput {
        .PhoneInputInput {
          opacity: 1;
        }
      }
    }
  }

  &:focus-within {
    .mantine-Input-wrapper {
      transition: 0.25s linear border;
      border-color: ${theme.colors.primary600};
      box-shadow: 0 0 4px ${theme.colors.primary200};
    }
  }

  .PhoneInput {
    --phone-select: 75px;
    --phone-input-space-x: 8px;
    width: 100%;
    opacity: 1;
    border: none;
    .PhoneInputCountry {
      background-color: transparent;
      border: none;
      padding: 0;
      width: var(--phone-select, 75px);
    }
    .PhoneInputInput {
      flex: 1;
      min-width: 0;
      line-height: 1.5;
      outline: none !important;
      border: none;
      box-shadow: none;
      padding: 0 var(--phone-input-space-x, 8px);
      opacity: 0;
      color: ${theme.colors.gray800} !important;
      :focus {
        color: ${theme.colors.gray800} !important;
      }
    }
  }

  &:has(.PhoneInput) {
    .mantine-InputWrapper-label {
      left: calc(
        var(--space-x, 16px) + var(--phone-select, 75px) +
          var(--phone-input-space-x, 8px)
      );
    }
  }
`;
const StyledChoiceFieldContainer$1 = styled.div `
  &.leadgen-form_checkbox,
  &.leadgen-form_radio {
    width: 100%;
  }

  &.leadgen-form_dropdown {
    width: calc(50% - 12px);
  }

  .mantine-InputWrapper-root {
    display: block;
  }

  .mantine-InputWrapper-label {
    margin-bottom: 0.5rem;
    color: ${theme.colors.gray800};
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
  }

  .mantine-Radio-root,
  .mantine-Checkbox-root {
    gap: 8px;
    min-width: calc(50% - 4px);

    input[type='radio'],
    input[type='checkbox'] {
      border-color: ${theme.colors.gray600};
      width: 18px;
      height: 18px;
    }
    input[type='checkbox'] {
      border-radius: 4px;
    }

    &[data-checked='true'] {
      input[type='radio'],
      input[type='checkbox'] {
        border-color: ${theme.colors.primary600};
      }

      input[type='radio'] {
        background-color: white;
      }
    }

    .mantine-Checkbox-input {
      &:checked {
        border-color: ${theme.colors.primary600};
      }
    }
  }

  .mantine-Radio-inner,
  .mantine-Checkbox-inner {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mantine-Radio-body,
  .mantine-Checkbox-body {
    display: flex;
    align-items: center;
  }

  .mantine-Radio-label,
  .mantine-Checkbox-label {
    padding-left: 8px;
    color: ${theme.colors.gray800};
    font-size: 14px;
    line-height: 1.4;
    letter-spacing: -0.2px;
  }

  .leadgen-choiceContainer {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px;
  }

  .mantine-InputWrapper-error {
    ${cssInputWrapperError$1}
  }
`;

const TextField$1 = (props) => {
    const { shrink: shrinkProps, onChangeShrink, className, children } = props, restProps = __rest(props, ["shrink", "onChangeShrink", "className", "children"]);
    const containerRef = useClickOutside(() => {
        if (shrinkProps) {
            return;
        }
        setShrink(false);
        onChangeShrink === null || onChangeShrink === void 0 ? void 0 : onChangeShrink(false);
    });
    const [shrink, setShrink] = useState(shrinkProps);
    const onClick = useCallback((e) => {
        setShrink(true);
        onChangeShrink === null || onChangeShrink === void 0 ? void 0 : onChangeShrink(true);
        if (shrink) {
            return;
        }
        const $textEl = e.currentTarget.querySelectorAll('input:not([disabled]):not([type="submit"]),select:not([disabled]),textarea:not([disabled])');
        const $focusEl = $textEl.item($textEl.length - 1);
        if ($focusEl) {
            $focusEl.focus();
        }
    }, [shrink]);
    useEffect(() => {
        setShrink(shrinkProps);
    }, [shrinkProps]);
    return (React__default.createElement(StyledTextFieldContainer$1, Object.assign({ shrink: shrink, className: clsx(className, 'textField', { textField_shrink: !!shrink }) }, restProps),
        React__default.createElement("div", { ref: containerRef, onClick: onClick, className: "textField_wrapper" }, children)));
};
const ChoiceField$1 = (props) => {
    const { children, className } = props, restProps = __rest(props, ["children", "className"]);
    return (React__default.createElement(StyledChoiceFieldContainer$1, Object.assign({ className: clsx(className, 'choiceField') }, restProps), children));
};

const libraries = ['places'];
const GoogleLocationBlock = (props) => {
    var _a;
    const { inputWrapperOrder = ['label', 'input', 'description', 'error'], defaultValue, value: valueProps, onChange: onChangeProps, locale } = props, restProps = __rest(props, ["inputWrapperOrder", "defaultValue", "value", "onChange", "locale"]);
    const [LoadScript, setLoadScript] = useState(null);
    const [value, setValue] = useState(defaultValue || valueProps);
    const { predictions } = usePlacesAutocomplete(value, '', locale === 'tl-PH' ? 'en' : (_a = locale === null || locale === void 0 ? void 0 : locale.split('-')) === null || _a === void 0 ? void 0 : _a[0]);
    const onChangeAutocomplete = useCallback((s) => {
        setValue(s);
        onChangeProps === null || onChangeProps === void 0 ? void 0 : onChangeProps(s);
    }, []);
    const onClickItem = useCallback((item) => {
        /** For sure get value */
        setValue(item.value);
        const predCur = predictions === null || predictions === void 0 ? void 0 : predictions.find(({ description }) => description === item.value);
        onChangeProps === null || onChangeProps === void 0 ? void 0 : onChangeProps(item.value, predCur === null || predCur === void 0 ? void 0 : predCur.rawData);
    }, [onChangeProps, predictions]);
    useEffect(() => {
        setValue(valueProps);
    }, [valueProps]);
    useEffect(() => {
        var _a, _b, _c;
        // only load extra google script when not yet loaded
        if (!((_c = (_b = (_a = window === null || window === void 0 ? void 0 : window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.places) === null || _c === void 0 ? void 0 : _c.AutocompleteService) && !LoadScript) {
            import('@react-google-maps/api').then((m) => {
                setLoadScript(() => m.LoadScript);
            });
        }
    }, []);
    return (React__default.createElement(Autocomplete, Object.assign({ defaultValue: defaultValue, value: value, onChange: onChangeAutocomplete, data: predictions.map((pred) => {
            return { value: pred.description, label: pred.description };
        }), filter: () => true, onItemSubmit: onClickItem, inputWrapperOrder: inputWrapperOrder, zIndex: ZINDEX_SSO - 9e6 + 2, withinPortal: true, styles: { dropdown: { pointerEvents: 'auto' } }, inputContainer: (children) => {
            return (React__default.createElement(React__default.Fragment, null,
                LoadScript && (React__default.createElement(LoadScript, { googleMapsApiKey: GOOGLE_API_KEY, libraries: libraries, loadingElement: React__default.createElement(React__default.Fragment, null), style: { width: '100%' } })),
                children));
        } }, restProps)));
};

const LeadGenForm = forwardRef((props, ref) => {
    const { locale, blocks, scrollToErrorField = true, form: formProps, rules: validate, initialValues, onFinish, onFinishFailed, className, style, } = props;
    const formRef = useRef(null);
    const form = formProps || useForm({ initialValues, validate });
    const middlewareFinish = useCallback((values, event) => {
        /** Set `touched` all values for validation when submiting */
        form.setTouched(blocks.reduce((touched, { data }) => {
            touched[data.value] = true;
            return touched;
        }, {}));
        /** Wait for `touched` state and then submit */
        setTimeout(() => {
            const { hasErrors } = form.validate();
            if (hasErrors) {
                return;
            }
            onFinish === null || onFinish === void 0 ? void 0 : onFinish(formatLeadGenFormValue(values, blocks), event);
        }, 100);
    }, [form, blocks]);
    const middlewareFinishFailed = useCallback((errors, values, events) => {
        const targetForm = events.target;
        if (scrollToErrorField && errors) {
            const firstErrorKey = Object.keys(errors)[0];
            const firstErrorElement = targetForm.querySelector(`[name="${firstErrorKey}"]`);
            if (firstErrorElement && (firstErrorElement === null || firstErrorElement === void 0 ? void 0 : firstErrorElement.focus)) {
                setTimeout(() => {
                    firstErrorElement === null || firstErrorElement === void 0 ? void 0 : firstErrorElement.focus();
                    firstErrorElement.scrollIntoView({
                        behavior: 'auto',
                        block: 'center',
                        inline: 'center',
                    });
                }, 100);
            }
        }
        onFinishFailed === null || onFinishFailed === void 0 ? void 0 : onFinishFailed(errors, values, events);
    }, [scrollToErrorField]);
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (!window.intlTelInputUtils) {
                yield require('intl-tel-input/build/js/utils');
            }
        }))();
    }, []);
    useImperativeHandle(ref, () => (Object.assign(Object.assign({}, form), { submit: () => {
            formRef.current.requestSubmit();
        } })), [form, formRef]);
    if (!blocks || !blocks.length) {
        return null;
    }
    return (React__default.createElement("form", { ref: formRef, onSubmit: form.onSubmit(middlewareFinish, middlewareFinishFailed), className: className, style: style },
        React__default.createElement(StyledLeadGenFormInner, { className: "leadgen-form_inputs" }, blocks.map((block, idx) => {
            const { id, name: blockName, data } = block;
            const { placeholder, value: name, required, listQuestion, valueHTML, isSendMailChimp = false, } = data;
            const formInputProps = form.getInputProps(name);
            const { value, error } = formInputProps;
            const reactKey = `${id}-${idx}`;
            switch (blockName) {
                case LEADGEN_BLOCK.TextBlock: {
                    return (React__default.createElement(TextField$1, { key: reactKey, shrink: !!value, className: "leadgen-form_input" },
                        React__default.createElement(TextInput, Object.assign({ name: name, spellCheck: false, withAsterisk: required, label: placeholder, placeholder: placeholder, inputWrapperOrder: LEADGEN_ORDER_INPUT_WRAPPER, type: "text", "data-control": "text" }, formInputProps))));
                }
                case LEADGEN_BLOCK.NumberBlock: {
                    return (React__default.createElement(TextField$1, { key: reactKey, shrink: !!value, className: "leadgen-form_input" },
                        React__default.createElement(NumberInput$1, Object.assign({ name: value, spellCheck: false, withAsterisk: required, label: placeholder, placeholder: placeholder, inputWrapperOrder: LEADGEN_ORDER_INPUT_WRAPPER, type: "number", "data-control": "number" }, formInputProps))));
                }
                case LEADGEN_BLOCK.EmailBlock: {
                    return (React__default.createElement(TextField$1, { key: reactKey, shrink: !!value, className: "leadgen-form_input" },
                        React__default.createElement(TextInput, Object.assign({ name: name, spellCheck: false, withAsterisk: required, label: placeholder, placeholder: placeholder, inputWrapperOrder: LEADGEN_ORDER_INPUT_WRAPPER, "data-control": "email" }, formInputProps))));
                }
                case LEADGEN_BLOCK.PhoneOtpBlock:
                case LEADGEN_BLOCK.WhatsappOtpBlock:
                case LEADGEN_BLOCK.ZaloOtpBlock:
                case LEADGEN_BLOCK.PhoneBlock: {
                    return (React__default.createElement(TextField$1, { key: reactKey, shrink: !!value, className: "leadgen-form_input" },
                        React__default.createElement(PhoneInput, Object.assign({ name: name, spellCheck: false, withAsterisk: required, label: placeholder, placeholder: placeholder, inputWrapperOrder: LEADGEN_ORDER_INPUT_WRAPPER, defaultCountry: (locale ? MAPPED_LOCALE[locale] || 'VN' : 'VN'), type: "text", "data-control": "text" }, formInputProps))));
                }
                case LEADGEN_BLOCK.LocationBlock: {
                    return (React__default.createElement(TextField$1, { key: reactKey, shrink: !!value, className: "leadgen-form_input" },
                        React__default.createElement(GoogleLocationBlock, Object.assign({ name: name, withAsterisk: required, label: placeholder, placeholder: placeholder, inputWrapperOrder: LEADGEN_ORDER_INPUT_WRAPPER, locale: locale, "data-control": "text" }, formInputProps))));
                }
                case LEADGEN_BLOCK.DateBlock: {
                    return (React__default.createElement(TextField$1, { key: reactKey, shrink: !!value, className: "leadgen-form_input" },
                        React__default.createElement(DateInput, Object.assign({ locale: (MAPPED_LOCALE === null || MAPPED_LOCALE === void 0 ? void 0 : MAPPED_LOCALE[locale]) || MAPPED_LOCALE['vi-VN'], valueFormat: "DD/MM/YYYY", name: name, withAsterisk: required, label: placeholder, placeholder: placeholder, inputWrapperOrder: LEADGEN_ORDER_INPUT_WRAPPER, type: "default", "data-control": "date" }, formInputProps))));
                }
                case LEADGEN_BLOCK.DropdownBlock:
                    return (React__default.createElement(TextField$1, { key: reactKey, shrink: !!value, className: "leadgen-form_input" },
                        React__default.createElement("div", { style: { display: 'none' }, "data-extra": true, "data-name": value, "data-control": 'dropdown' }),
                        React__default.createElement(Select$1, Object.assign({ name: name, withAsterisk: required, label: placeholder, placeholder: placeholder, data: listQuestion.map((l) => ({
                                value: l.value,
                                label: l.placeholder,
                            })) }, formInputProps))));
                case LEADGEN_BLOCK.CheckboxBlock: {
                    const formInputCheckboxProps = form.getInputProps(name, {
                        type: 'checkbox',
                    });
                    return (React__default.createElement(ChoiceField$1, { className: "leadgen-form_input leadgen-form_input_checkbox", key: reactKey },
                        isSendMailChimp && (React__default.createElement("div", { style: { display: 'none' }, "data-name": name + '-mailchimp' })),
                        React__default.createElement(Checkbox$1.Group, Object.assign({ size: "md", withAsterisk: required, label: placeholder, value: value, sx: {
                                display: 'flex',
                                flexDirection: 'column',
                                flexWrap: 'wrap',
                                gap: 8,
                            }, inputWrapperOrder: LEADGEN_ORDER_INPUT_WRAPPER, inputContainer: (children) => {
                                return (React__default.createElement("div", { className: "leadgen-choiceContainer" }, children));
                            } }, formInputCheckboxProps), listQuestion.map((l, _idx) => (React__default.createElement(Checkbox$1, { name: name, key: _idx, value: l.value, label: l.placeholder, "data-control": "checkbox" }))))));
                }
                case LEADGEN_BLOCK.RadioBlock: {
                    return (React__default.createElement(ChoiceField$1, { className: "leadgen-form_input leadgen-form_input_checkbox", key: reactKey },
                        isSendMailChimp && (React__default.createElement("div", { style: { display: 'none' }, "data-name": name + '-mailchimp' })),
                        React__default.createElement(Radio$1.Group, Object.assign({ size: "md", withAsterisk: required, label: placeholder, value: value, spellCheck: true, inputWrapperOrder: LEADGEN_ORDER_INPUT_WRAPPER, inputContainer: (children) => {
                                return (React__default.createElement("div", { className: "leadgen-choiceContainer" }, children));
                            } }, formInputProps), listQuestion.map((l, _index) => (React__default.createElement(Radio$1, { name: name, key: _index, value: l.value, label: l.placeholder, "data-control": "radio" }))))));
                }
                case LEADGEN_BLOCK.TncBlock:
                    return (React__default.createElement(ChoiceField$1, { className: "leadgen-form_input leadgen-form_input_checkbox", key: reactKey },
                        React__default.createElement(Input$1.Wrapper, { error: error },
                            React__default.createElement(Checkbox$1, Object.assign({ value: value, name: 'TNC-' + id, label: React__default.createElement("p", { className: "lead-modal__tnc-link", dangerouslySetInnerHTML: { __html: valueHTML } }), className: "tnc-block", "data-control": "checkbox" }, formInputProps)))));
                default: {
                    return null;
                }
            }
        }))));
});

const LEADGEN_ORDER_INPUT_WRAPPER = ['label', 'input', 'description', 'error'];

const LeadGenSubscriptionBoxA = (props) => {
    const { loading, image, title, submitText, locale, blocks, form, rules, onFinish, } = props;
    const formRef = useRef();
    const imageComp = useMemo(() => {
        if (!image) {
            return null;
        }
        return (React__default.createElement(StyledLeadGenSubscriptionBoxHeaderImage, null,
            React__default.createElement("img", { src: image, alt: "" })));
    }, [image]);
    const titleComp = useMemo(() => {
        if (typeof title === 'string') {
            return (React__default.createElement("p", { className: "leadgen-title", dangerouslySetInnerHTML: { __html: title } }));
        }
        return React__default.createElement("p", { className: "leadgen-title" }, title);
    }, [title]);
    return (React__default.createElement(StyledLeadGenSubscriptionBoxA, { className: "subcription_box_A" },
        React__default.createElement(StyledLeadGenSubscriptionBoxHeader, { className: "leadgen-subscription_box_header" },
            imageComp,
            titleComp),
        React__default.createElement(StyledLeadGenSubscriptionBoxBody, { className: "leadgen-subscription_box_body" },
            React__default.createElement(LeadGenForm, { ref: formRef, form: form, rules: rules, blocks: blocks, locale: locale, onFinish: onFinish, className: "leadgen-subscription_box_form" }),
            React__default.createElement(Button$1, { disabled: loading, loading: loading, variant: "filled", size: "lg", onClick: () => {
                    formRef.current.submit();
                }, className: "leadgen-btn leadgen-btn_action", fullWidth: true }, submitText))));
};

const LeadGenSubscriptionBoxWithoutMemo = ({ locale, userInfo, forceCampaign, categoryId, }) => {
    var _a, _b, _c;
    const { image, extra_fields, id: campaign_id, bot_id: campaign_subot_id = [], ThankYouBlock, } = forceCampaign || {};
    const { textBlocks, listBlockAdded, actionBlocks } = extra_fields || {};
    const { submitBlock } = actionBlocks || {};
    const { apiLeadUrl, subscriptionIcon, subscriptionTitle, submitSubscriptionBox, impression, onFinish, } = useLeadGenContext();
    const { t } = useTranslations();
    const { action: { pushNotifications }, } = useContext(TogetherComponentGlobalContext);
    const refContainer = useRef(null);
    const [loading, setLoading] = useState(false);
    const [showThankyou, setShowThankyou] = useState(false);
    const validatingEmailRef = useRef(false);
    const validatingPhoneRef = useRef(false);
    const { form, validateObj } = useLeadFormConfig({
        listBlockAdded,
        campaignId: campaign_id,
        campaign_subot_id,
        validatingEmailRef,
        validatingPhoneRef,
        userInfo,
    });
    const subscription_title = useMemo(() => {
        var _a, _b;
        return subscriptionTitle ||
            ((_b = (_a = textBlocks === null || textBlocks === void 0 ? void 0 : textBlocks.titleBlock) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.value) ||
            t('leadgen.message.title.default');
    }, [subscriptionTitle, (_b = (_a = textBlocks === null || textBlocks === void 0 ? void 0 : textBlocks.titleBlock) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.value]);
    const { image: thankyouImage, title: thankyouTitle, description: thankyouDescription, button: thankyouButton, } = ThankYouBlock || {};
    const intersectionObserverCallback = useCallback((entries) => {
        entries.forEach((entry) => {
            const { isIntersecting, target } = entry;
            if (!showThankyou &&
                isIntersecting &&
                target === refContainer.current) {
                impression();
            }
        });
    }, [impression, showThankyou]);
    const IObserver = new IntersectionObserver(intersectionObserverCallback);
    const middlewareOnSubmit = useCallback((values) => __awaiter(void 0, void 0, void 0, function* () {
        const newValues = {
            subscription_title,
        };
        const ssoValues = {
            sso_user_id: undefined,
            sso_uuid: undefined,
            sso_verified_profile: undefined,
        };
        const valueKeys = Object.keys(values);
        for (const key of valueKeys) {
            const isPhoneField = leadGenFieldNamePhone(listBlockAdded).some((k) => k === key);
            if (isPhoneField) {
                const phone = parsePhoneNumber(values[key]);
                if (phone.isValid()) {
                    /** Seperate `area_code` and `phone_number` for BE */
                    newValues['area_code'] = `+${phone.countryCallingCode}`;
                    newValues['phone_number'] = phone.nationalNumber;
                    /** Only case login has this update */
                    if ((userInfo === null || userInfo === void 0 ? void 0 : userInfo.id) && (userInfo === null || userInfo === void 0 ? void 0 : userInfo.uid)) {
                        const userInfoPhone = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.area_code) + (userInfo === null || userInfo === void 0 ? void 0 : userInfo.phone);
                        ssoValues['sso_verified_profile'] =
                            phone.number === userInfoPhone ? 1 : 0;
                        ssoValues['sso_user_id'] = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id;
                        ssoValues['sso_uuid'] = userInfo === null || userInfo === void 0 ? void 0 : userInfo.uid;
                        LeadLog('** LeadGen SB userInfoPhone : ', userInfoPhone);
                        LeadLog('** LeadGen SB userInfoPhoneInput : ', phone.number);
                    }
                }
                continue;
            }
            newValues[key] = values[key];
        }
        setLoading(true);
        try {
            const reqValues = Object.assign(Object.assign({}, newValues), ssoValues);
            const { _data } = (yield submitSubscriptionBox(reqValues)) || {};
            const { model } = _data || {};
            if (model && (model === null || model === void 0 ? void 0 : model.id)) {
                setShowThankyou(true);
                const metaValues = {
                    blocks: listBlockAdded || [],
                    isUpdateSso: false,
                };
                /**
                 *  https://hhgdev.atlassian.net/browse/EL-468
                 * 	This feature is just using in Subscription Box
                 */
                if (newValues === null || newValues === void 0 ? void 0 : newValues.name) {
                    Service.postUserInfoFromLeadGen({ name: newValues === null || newValues === void 0 ? void 0 : newValues.name })
                        .then((res) => {
                        const { _data: ssoData, code: ssoErrorCode } = res;
                        if (!ssoErrorCode && ssoData) {
                            metaValues.isUpdateSso = true;
                            onFinish === null || onFinish === void 0 ? void 0 : onFinish(reqValues, metaValues);
                        }
                    })
                        .catch(() => {
                        onFinish === null || onFinish === void 0 ? void 0 : onFinish(reqValues, metaValues);
                    });
                    return;
                }
                onFinish === null || onFinish === void 0 ? void 0 : onFinish(reqValues, metaValues);
            }
        }
        catch (error) {
            LeadLog('** LeadGen SubscriptionBox error : ', error);
            pushNotifications({
                message: t('leadgen.message.error.default'),
                type: 'danger',
            });
        }
        setLoading(false);
    }), [
        subscription_title,
        listBlockAdded,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.id,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.uid,
        userInfo === null || userInfo === void 0 ? void 0 : userInfo.phone,
    ]);
    useEffect(() => {
        if (refContainer.current) {
            IObserver.observe(refContainer.current);
        }
        return () => {
            IObserver.disconnect();
        };
    }, [categoryId]);
    return (React__default.createElement("div", { ref: refContainer },
        React__default.createElement(StyledLeadGenSubscriptionBox, { "data-type": "subscription_box_A" },
            showThankyou && (React__default.createElement(LeadGenThankYou, { image: Object.assign(Object.assign({}, thankyouImage), { src: thankyouImage.src || `${apiLeadUrl}admin/img/thanksyou.png` }), title: thankyouTitle, description: thankyouDescription, button: thankyouButton })),
            !showThankyou && (React__default.createElement(LeadGenSubscriptionBoxA, { loading: loading, image: subscriptionIcon || image, title: subscription_title, submitText: (_c = submitBlock === null || submitBlock === void 0 ? void 0 : submitBlock.data) === null || _c === void 0 ? void 0 : _c.value, blocks: listBlockAdded, locale: locale, form: form, rules: validateObj, onFinish: middlewareOnSubmit })))));
};
const LeadGenSubscriptionBox$1 = memo(LeadGenSubscriptionBoxWithoutMemo);

const Container = () => {
    const context = useContext(LeadGenContext);
    const { campaign_code, locale, siteId, siteDomain, userInfo, forceCampaign } = context;
    if (!forceCampaign || !(forceCampaign === null || forceCampaign === void 0 ? void 0 : forceCampaign.id)) {
        return null;
    }
    return (React__default.createElement(LeadGenSubscriptionBox$1, { locale: locale, siteId: siteId, siteDomain: siteDomain, userInfo: userInfo, forceCampaign: forceCampaign, campaign_code: campaign_code }));
};
Container.displayName = 'LeadGenSubscriptionBox';
const LeadGenSubscriptionBoxContainer = (props) => {
    const { apiUrl, apiSubotUrl } = props;
    return (React__default.createElement(LeadGenContextProvider, Object.assign({}, props, { apiLeadUrl: apiUrl, apiSubotUrl: apiSubotUrl }),
        React__default.createElement(Container, null)));
};
const LeadGenSubscriptionBox = LeadGenSubscriptionBoxContainer;

const useImageSize = (src) => {
    const [width, setWidth] = useState(16);
    const [height, setHeight] = useState(9);
    const [loaded, setLoaded] = useState(false);
    // load src image to get its width and height
    useEffect(() => {
        setLoaded(false);
        if (src) {
            const img = new Image();
            img.addEventListener('load', () => {
                setWidth(img.naturalWidth);
                setHeight(img.naturalHeight);
                setLoaded(true);
            });
            img.addEventListener('error', () => {
                setWidth(16);
                setHeight(9);
                setLoaded(true);
            });
            img.src = src;
        }
        else {
            setWidth(16);
            setHeight(9);
            setLoaded(true);
        }
    }, [src]);
    return {
        loaded,
        width,
        height,
    };
};

const CloseButton = ({ onClose, containerClassName, svgClassName, }) => (React__default.createElement("button", { onClick: onClose, className: `le-newbuilder-close-button js-modal__close ${containerClassName || ''}` },
    React__default.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", className: svgClassName },
        React__default.createElement("path", { d: "M9.99981 10.8432L14.0583 14.9017C14.1691 15.0125 14.3083 15.0691 14.476 15.0717C14.6437 15.0743 14.7854 15.0176 14.9013 14.9017C15.0172 14.7858 15.0752 14.6453 15.0752 14.4802C15.0752 14.3151 15.0172 14.1746 14.9013 14.0587L10.8429 10.0002L14.9013 5.9417C15.0121 5.83094 15.0688 5.69172 15.0713 5.52402C15.0739 5.35634 15.0172 5.21456 14.9013 5.09866C14.7854 4.98276 14.6449 4.9248 14.4798 4.9248C14.3147 4.9248 14.1742 4.98276 14.0583 5.09866L9.99981 9.15712L5.94133 5.09866C5.83057 4.98789 5.69135 4.93122 5.52365 4.92866C5.35598 4.92609 5.21419 4.98276 5.09829 5.09866C4.98239 5.21456 4.92444 5.35506 4.92444 5.52018C4.92444 5.6853 4.98239 5.82581 5.09829 5.9417L9.15675 10.0002L5.09829 14.0587C4.98752 14.1694 4.93085 14.3087 4.9283 14.4763C4.92572 14.644 4.98239 14.7858 5.09829 14.9017C5.21419 15.0176 5.3547 15.0756 5.51982 15.0756C5.68493 15.0756 5.82544 15.0176 5.94133 14.9017L9.99981 10.8432Z" }))));

// url: imageBlocks.imageMobile.data.url
// newTab: imageBlocks.imageMobile.data.newtab
// imageMobile: campaignShow.image
// imageDestkop: campaignShow.image_desktop
const CenterTabLayout = ({ popupId, url, newTab, imageDestkop, imageMobile, onClose, onOtherSubmit, }) => {
    const { width: imageMobileWidth, height: imageMobileHeight, loaded: imageMobileLoaded, } = useImageSize(imageMobile);
    const { width: imageDestkopWidth, height: imageDestkopHeight, loaded: imageDestkopLoaded, } = useImageSize(imageDestkop);
    if (!imageMobileLoaded || !imageDestkopLoaded)
        return null;
    return (React__default.createElement("div", { id: popupId, className: "lead-modal-wrapper", "data-popup-url": location.pathname, "data-popup-type": "center_tab" },
        React__default.createElement("div", { className: "le-center-tab-popup" },
            React__default.createElement("div", { style: { position: 'relative' } },
                React__default.createElement("a", { className: "js-popup-other-submit", href: url, target: newTab ? 'blank' : '_parent', onClick: onOtherSubmit },
                    isVideo(imageMobile) ? (React__default.createElement("video", { loop: true, muted: true, autoPlay: true, className: "le-only-mobile" },
                        React__default.createElement("source", { src: imageMobile }))) : (React__default.createElement("img", { className: "le-only-mobile", src: imageMobile, style: {
                            aspectRatio: `${imageMobileWidth}/${imageMobileHeight}`,
                        } })),
                    isVideo(imageDestkop) ? (React__default.createElement("video", { loop: true, muted: true, autoPlay: true, className: "le-only-desktop" },
                        React__default.createElement("source", { src: imageDestkop }))) : (React__default.createElement("img", { className: "le-only-desktop", src: imageDestkop, style: {
                            aspectRatio: `${imageDestkopWidth}/${imageDestkopHeight}`,
                        } }))),
                React__default.createElement(CloseButton, { onClose: onClose, containerClassName: "close-button-top-right" })))));
};

// title: titleText
// titleAlign: textBlocks.titleBlock.data.align
// subtitle: textBlocks.subtitleBlock.data.value
// subtitleAlign: textBlocks.subtitleBlock.data.align
// url: actionBlocks.linkButtonBlock.data.url
// urlText: actionBlocks.linkButtonBlock.data.value
// newTab: actionBlocks.linkButtonBlock.data.newtab
// imageMobile: campaignShow.image
// imageDesktop: campaignShow.image_desktop
const FloatingLayout = ({ popupId, url, title, urlText, titleAlign, subtitle, subtitleAlign, newTab, imageDesktop, imageMobile, onClose, onOtherSubmit, }) => {
    const { width: imageMobileWidth, height: imageMobileHeight, loaded: imageMobileLoaded, } = useImageSize(imageMobile);
    const { width: imageDesktopWidth, height: imageDesktopHeight, loaded: imageDesktopLoaded, } = useImageSize(imageDesktop);
    if (!imageMobileLoaded || !imageDesktopLoaded)
        return null;
    return (React__default.createElement("div", { id: popupId, className: "lead-modal-wrapper lead-floating-wrapper", "data-popup-url": location.pathname, "data-popup-type": "floating" },
        React__default.createElement("aside", { className: "le-only-desktop" },
            React__default.createElement("div", { className: "le-floating-desktop" },
                React__default.createElement("div", { className: "le-floating-desktop-wrap", style: { position: 'relative', background: '#fff' } },
                    imageDesktop ? (React__default.createElement("div", null,
                        React__default.createElement("img", { style: {
                                maxWidth: 120,
                                borderTopLeftRadius: 5,
                                borderBottomLeftRadius: 5,
                                aspectRatio: `${imageDesktopWidth}/${imageDesktopHeight}`,
                            }, src: imageDesktop }))) : null,
                    React__default.createElement("div", { style: { padding: 20 } },
                        React__default.createElement("div", { className: `le-floating-desktop-title le-text-align-${titleAlign}` }, title),
                        React__default.createElement("div", { className: `le-floating-desktop-desc le-text-align-${subtitleAlign}` }, subtitle)),
                    React__default.createElement("a", { target: newTab ? 'blank' : '_parent', style: { marginLeft: 35, textDecoration: 'none' }, href: url },
                        React__default.createElement("button", { className: "le-joinbow-floating-btn js-popup-other-submit", onClick: onOtherSubmit }, urlText)),
                    React__default.createElement(CloseButton, { onClose: onClose, containerClassName: "close-button-top-right" })))),
        React__default.createElement("aside", { className: "le-only-mobile" },
            React__default.createElement("div", { className: "le-floating-mobile" },
                React__default.createElement("div", { className: "le-floating-mobile-wrap", style: { position: 'relative', background: '#fff' } },
                    React__default.createElement("aside", { style: { display: 'flex', justifyContent: 'space-between' } },
                        React__default.createElement("div", null,
                            React__default.createElement("div", { className: `le-floating-mobile-title le-text-align-${titleAlign}` }, title),
                            React__default.createElement("div", { className: `le-floating-mobile-desc le-text-align-${subtitleAlign}` }, subtitle)),
                        imageMobile ? (React__default.createElement("div", null,
                            React__default.createElement("img", { style: {
                                    marginLeft: 15,
                                    marginTop: 4,
                                    maxWidth: 100,
                                    aspectRatio: `${imageMobileWidth}/${imageMobileHeight}`,
                                }, src: imageMobile }))) : null),
                    React__default.createElement("div", { style: { textAlign: 'center', marginTop: 10 } },
                        React__default.createElement("a", { target: newTab ? 'blank' : '_parent', href: url, style: { textDecoration: 'none' } },
                            React__default.createElement("button", { className: "le-joinbow-floating-btn js-popup-other-submit", onClick: onOtherSubmit }, urlText))),
                    React__default.createElement(CloseButton, { onClose: onClose, containerClassName: "close-button-top-right" }))))));
};

const ThankyouPopup = ({ title, titleAlign, subtitle, subtitleAlign, link, linkNewTab, linkText, image, }) => {
    const { primaryColor } = useContext(LeadGenContext$1);
    const { width: imageWidth, height: imageHeight, loaded: imageLoaded, } = useImageSize(image);
    if (!imageLoaded)
        return null;
    return (React__default.createElement("div", { className: "lead-modal__thank-you leadgen-inner_thankyou" },
        React__default.createElement("div", { style: { width: '100%' } },
            React__default.createElement("img", { src: image, style: {
                    maxHeight: 162,
                    objectFit: 'cover',
                    aspectRatio: `${imageWidth}/${imageHeight}`,
                }, loading: "lazy" }),
            title && (React__default.createElement("h1", { className: `le-thankyou-title le-text-align-${titleAlign}` }, title)),
            subtitle && (React__default.createElement("p", { className: `le-thankyou-subtitle le-text-align-${subtitleAlign}` }, subtitle.split('\n').map((text, idx, list) => {
                const isShowBr = idx < list.length - 1;
                return (React__default.createElement(React__default.Fragment, null,
                    text,
                    isShowBr && React__default.createElement("br", null)));
            }))),
            linkText && (React__default.createElement("div", null,
                React__default.createElement("a", { href: link, target: linkNewTab ? '_blank' : 'parrent', rel: "noreferrer" },
                    React__default.createElement(Button, { className: `lead-modal__btn ${LEAD_CLASS}`, color: primaryColor }, linkText)))))));
};

const InlineLayout = ({ content, inlinePosition, }) => {
    const target = useMemo(() => {
        if (!inlinePosition)
            return null;
        const parents = document.querySelectorAll(`[data-url="${location.pathname}"] .body-content`);
        const allChildren = Array.from(parents).reduce((r, p) => {
            return [...r, ...Array.from(p.children)];
        }, []);
        if (allChildren === null || allChildren === void 0 ? void 0 : allChildren.length) {
            // find the third p tag in the body content, some other tags might mix in between
            const allPTags = allChildren.filter((c) => c.nodeName === 'P');
            const allH2Tags = allChildren.filter((c) => c.nodeName === 'H2');
            let target = null;
            switch (inlinePosition) {
                case '1th':
                    target = allPTags[0];
                    break;
                case '2th':
                    target = allPTags[1];
                    break;
                case '3th':
                    target = allPTags[2];
                    break;
                case '4th':
                    target = allPTags[3];
                    break;
                case '5th':
                    target = allPTags[4];
                    break;
                case '6th':
                    target = allPTags[5];
                    break;
                case '7th':
                    target = allPTags[6];
                    break;
                case '8th':
                    target = allPTags[7];
                    break;
                case '9th':
                    target = allPTags[8];
                    break;
                case '10th':
                    target = allPTags[9];
                    break;
                case '11th':
                    target = allPTags[10];
                    break;
                case '12th':
                    target = allPTags[11];
                    break;
                case 'lastP':
                    target = allPTags[allPTags.length - 1];
                    break;
                case '1thH2':
                    target = allH2Tags[0];
                    break;
                case '2thH2':
                    target = allH2Tags[1];
                    break;
                case '3thH2':
                    target = allH2Tags[2];
                    break;
                case '4thH2':
                    target = allH2Tags[3];
                    break;
                case '5thH2':
                    target = allH2Tags[4];
                    break;
                case '6thH2':
                    target = allH2Tags[5];
                    break;
                case '7thH2':
                    target = allH2Tags[6];
                    break;
                case '8thH2':
                    target = allH2Tags[7];
                    break;
                case '9thH2':
                    target = allH2Tags[8];
                    break;
                case '10thH2':
                    target = allH2Tags[9];
                    break;
                case 'lastH2':
                    target = allH2Tags[allH2Tags.length - 1];
                    break;
            }
            if (target) {
                if (!target.parentElement.querySelector('.inline-lead-wrapper')) {
                    const wrapper = document.createElement('div');
                    wrapper.classList.add('inline-lead-wrapper');
                    if (target.nextElementSibling) {
                        target.parentElement.insertBefore(wrapper, target.nextElementSibling);
                    }
                    else {
                        target.parentElement.appendChild(wrapper);
                    }
                    return wrapper;
                }
                else {
                    return target.parentElement.querySelector('.inline-lead-wrapper');
                }
            }
        }
    }, [inlinePosition]);
    if (!inlinePosition || !target)
        return null;
    return createPortal(content, target);
};

const SideBarLayout = ({ content }) => {
    const targets = useMemo(() => {
        const targetDoms = Array.from(document.querySelectorAll('.hc2-sidebar-with-ads,.page-main-col .right-col.f-right,.hhg-lead-sidebar'));
        targetDoms.forEach((dom) => {
            if (dom.querySelector('.sidebar-lead-modal-wrapper'))
                return;
            const wrapper = document.createElement('div');
            wrapper.classList.add('sidebar-lead-modal-wrapper');
            dom.prepend(wrapper);
        });
        return targetDoms.map((d) => d.querySelector('.sidebar-lead-modal-wrapper'));
    }, []);
    return (React__default.createElement(React__default.Fragment, null, targets.map((target) => createPortal(content, getWrapperDomWithSelector(target, 'sidebar-lead-modal-wrapper')))));
};

const EmptyIcon = (props) => {
    const { className, style } = props;
    return (React__default.createElement("svg", { width: "160", height: "160", viewBox: "0 0 160 160", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className, style: style },
        React__default.createElement("path", { d: "M79.9974 113.333C98.4069 113.333 113.331 98.4096 113.331 80.0001C113.331 61.5906 98.4069 46.6667 79.9974 46.6667C61.5879 46.6667 46.6641 61.5906 46.6641 80.0001C46.6641 98.4096 61.5879 113.333 79.9974 113.333Z", fill: "#F44D2C" }),
        React__default.createElement("path", { d: "M92.434 95.0004C91.7771 95.0004 91.1213 94.7499 90.6194 94.249L65.7521 69.3807C64.7493 68.3779 64.7493 66.7542 65.7521 65.7524C66.7549 64.7507 68.3786 64.7497 69.3804 65.7524L94.2487 90.6208C95.2515 91.6235 95.2515 93.2473 94.2487 94.249C93.7468 94.7499 93.0909 95.0004 92.434 95.0004Z", fill: "white" }),
        React__default.createElement("path", { d: "M67.5648 95C66.9079 95 66.252 94.7496 65.7501 94.2487C64.7474 93.2459 64.7474 91.6222 65.7501 90.6204L90.6185 65.7521C91.6212 64.7493 93.245 64.7493 94.2467 65.7521C95.2485 66.7549 95.2495 68.3786 94.2467 69.3804L69.3794 94.2487C68.8786 94.7496 68.2217 95 67.5648 95Z", fill: "white" })));
};

const EmptyComponent = ({ onClose, onContinue, }) => {
    const { t } = useTranslations();
    return (React__default.createElement("div", { className: "leadgen-empty" },
        React__default.createElement("div", { className: "leadgen-empty_body" },
            React__default.createElement("div", { className: "leadgen-empty_wrapper" },
                React__default.createElement(EmptyIcon, { className: "leadgen-empty_image" }),
                React__default.createElement("h5", { className: "leadgen-empty_title" }, t('lead.empty.title')))),
        React__default.createElement("div", { className: "leadgen-empty_footer" },
            React__default.createElement(Button$1, { onClick: onClose, size: "lg", variant: "default", fullWidth: false, className: "leadgen-btn leadgen-btn_empty_cancel" }, t('lead.empty.cancel')),
            React__default.createElement(Button$1, { onClick: onContinue, size: "lg", variant: "filled", fullWidth: false, className: "leadgen-btn leadgen-btn_empty_again" }, t('lead.empty.submitAgain')))));
};

const SubtitleBlock = ({ children, align, }) => (React__default.createElement("p", { className: `lead-modal__description ${'le-text-align-' + (align || '')} ${LEAD_CLASS}` }, children));

const cssInputNotShrink = css `
  height: 100% !important;
  min-height: calc(var(--container-height, 56px) * 24 / 56);
  color: ${theme.colors.gray800};
  font-size: var(--input, 15px);
  line-height: calc(var(--container-height, 56px) * 24 / 56);
  letter-spacing: -0.3px;
  border: none !important;
  border-radius: 0 !important;
  outline: none !important;
  box-shadow: none !important;
  padding: 0;
  cursor: pointer;
  opacity: 0;

  ::placeholder {
    color: ${theme.colors.gray400};
  }
`;
const cssInputShrink = css `
  height: auto !important;
  cursor: text;
  opacity: 1;
  transition: 0.1s ease-in-out all;
`;
const cssLabelNotShrink = css `
  position: absolute;
  top: calc(var(--container-height) / 2);
  left: var(--space-x, 16px);
  color: ${theme.colors.gray400};
  font-size: var(--label-not-shrink, 15px);
  font-weight: 500;
  line-height: calc(var(--container-height, 56px) * 24 / 56);
  letter-spacing: -0.3px;
  margin: 0;
  z-index: 1;
  cursor: pointer;
  transform: translateY(-50%);
  transition: 0.125s ease-in all;
`;
const cssLabelShrink = css `
  color: ${theme.colors.gray400};
  font-size: var(--label-shrink, 12px);
  line-height: calc(var(--container-height, 56px) * 18 / 56);
  letter-spacing: -0.2px;
  top: calc(var(--container-height) * 7 / 56);
  transform: none;
  transition: 0.125s ease-out all;
`;
const cssWrapperInputNotShrink = css `
  min-height: var(--container-height, 56px);
  display: flex;
  align-items: flex-end;
  border: 1px solid ${theme.colors.gray200};
  border-radius: 8px;
  background-color: #fff;
  padding-inline: var(--space-x, 16px);
  padding-block: var(--space-y-not-shrink, 16px);
  cursor: pointer;
  pointer-events: none;

  &:has(.mantine-Input-rightSection) {
    padding-right: var(--container-height, 56px);
  }

  .mantine-Input-icon {
    display: none;
  }

  .mantine-NumberInput-control {
    border-color: ${theme.colors.gray200};
  }
`;
const cssWrapperInputShrink = css `
  height: auto;
  min-height: var(--container-height, 56px);
  padding-block: var(--space-y-shrink, 7px);
  cursor: text;
  pointer-events: auto;
`;
const cssInputWrapperError = css `
  color: ${theme.colors.red800};
  font-size: 12px;
  line-height: 1.5;
`;
const StyledTextFieldContainer = styled.div `
  --space-x: 16px;
  --space-y-not-shrink: 15px;
  --space-y-shrink: 7px;
  --container-height: 56px;
  --label-not-shrink: 16px;
  --label-shrink: 12px;
  --input: 15px;

  position: relative;
  min-width: 100px;
  max-width: 100%;
  display: inline-block;

  .textField_wrapper {
    display: inline-block;
    width: 100%;
    cursor: pointer;
  }

  .mantine-InputWrapper-root {
    &[data-invalid='true'] {
      .mantine-Input-wrapper {
        border-color: ${theme.colors.red400};
      }
    }

    .mantine-Input-wrapper {
      &:has([data-invalid]) {
        border-color: ${theme.colors.red400};
      }
    }
  }

  .mantine-InputWrapper-label {
    ${cssLabelNotShrink}
  }

  .mantine-Input-wrapper {
    ${cssWrapperInputNotShrink}

    + .mantine-Popover-dropdown[data-position="bottom-start"] {
      left: 0 !important;
    }
    + .mantine-Popover-dropdown[data-position='top-start'] {
      top: unset !important;
      left: 0 !important;
      bottom: 100% !important;
    }
  }

  .mantine-Input-input {
    ${cssInputNotShrink}
  }

  &.textField_shrink,
  &:focus-within {
    .mantine-InputWrapper-label {
      ${cssLabelShrink}
    }

    .mantine-Input-wrapper {
      ${cssWrapperInputShrink}
      &.mantine-Select-wrapper {
        .mantine-Select-rightSection {
          pointer-events: auto !important;
        }
      }
    }

    .mantine-Input-input {
      ${cssInputShrink}
    }

    &:has(.PhoneInput) {
      .mantine-InputWrapper-label {
        left: var(--space-x, 16px);
      }
      .PhoneInput {
        .PhoneInputInput {
          opacity: 1;
        }
      }
    }
  }

  &:focus-within {
    .mantine-Input-wrapper {
      transition: 0.25s linear border;
      border-color: ${theme.colors.primary600};
      box-shadow: 0 0 4px ${theme.colors.primary200};
    }
  }

  .PhoneInput {
    --phone-select: 75px;
    --phone-input-space-x: 8px;
    width: 100%;
    opacity: 1;
    border: none;
    .PhoneInputCountry {
      background-color: transparent;
      border: none;
      padding: 0;
      width: var(--phone-select, 75px);
    }
    .PhoneInputInput {
      flex: 1;
      min-width: 0;
      line-height: 1.5;
      outline: none !important;
      border: none;
      box-shadow: none;
      padding: 0 var(--phone-input-space-x, 8px);
      opacity: 0;
      color: ${theme.colors.gray800} !important;
      :focus {
        color: ${theme.colors.gray800} !important;
      }
    }
  }

  &:has(.PhoneInput) {
    .mantine-InputWrapper-label {
      left: calc(
        var(--space-x, 16px) + var(--phone-select, 75px) +
          var(--phone-input-space-x, 8px)
      );
    }
  }
`;
const StyledChoiceFieldContainer = styled.div `
  &.leadgen-form_checkbox,
  &.leadgen-form_radio {
    width: 100%;
  }

  &.leadgen-form_dropdown {
    width: calc(50% - 12px);
  }

  .mantine-InputWrapper-root {
    display: block;
  }

  .mantine-InputWrapper-label {
    margin-bottom: 0.5rem;
    color: ${theme.colors.gray800};
    font-size: 16px;
    font-weight: 400;
    line-height: 1.5;
  }

  .mantine-Radio-root,
  .mantine-Checkbox-root {
    gap: 8px;
    min-width: calc(50% - 4px);

    input[type='radio'],
    input[type='checkbox'] {
      border-color: ${theme.colors.gray600};
      width: 18px;
      height: 18px;
    }
    input[type='checkbox'] {
      border-radius: 4px;
    }

    &[data-checked='true'] {
      input[type='radio'],
      input[type='checkbox'] {
        border-color: ${theme.colors.primary600};
      }

      input[type='radio'] {
        background-color: white;
      }
    }

    .mantine-Checkbox-input {
      &:checked {
        border-color: ${theme.colors.primary600};
      }
    }
  }

  .mantine-Radio-inner,
  .mantine-Checkbox-inner {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .mantine-Radio-body,
  .mantine-Checkbox-body {
    display: flex;
    align-items: center;
  }

  .mantine-Radio-label,
  .mantine-Checkbox-label {
    padding-left: 8px;
    color: ${theme.colors.gray800};
    font-size: 14px;
    line-height: 1.4;
    letter-spacing: -0.2px;
  }

  .leadgen-choiceContainer {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    gap: 8px;
  }

  .mantine-InputWrapper-error {
    ${cssInputWrapperError}
  }
`;

const TextField = (props) => {
    const { shrink: shrinkProps, onChangeShrink, className, children } = props, restProps = __rest(props, ["shrink", "onChangeShrink", "className", "children"]);
    const containerRef = useClickOutside(() => {
        if (shrinkProps) {
            return;
        }
        setShrink(false);
        onChangeShrink === null || onChangeShrink === void 0 ? void 0 : onChangeShrink(false);
    });
    const [shrink, setShrink] = useState(shrinkProps);
    const onClick = useCallback((e) => {
        setShrink(true);
        onChangeShrink === null || onChangeShrink === void 0 ? void 0 : onChangeShrink(true);
        if (shrink) {
            return;
        }
        const $textEl = e.currentTarget.querySelectorAll('input:not([disabled]):not([type="submit"]),select:not([disabled]),textarea:not([disabled])');
        const $focusEl = $textEl.item($textEl.length - 1);
        if ($focusEl) {
            $focusEl.focus();
        }
    }, [shrink]);
    useEffect(() => {
        setShrink(shrinkProps);
    }, [shrinkProps]);
    return (React__default.createElement(StyledTextFieldContainer, Object.assign({ shrink: shrink, className: clsx(className, 'textField', { textField_shrink: !!shrink }) }, restProps),
        React__default.createElement("div", { ref: containerRef, onClick: onClick, className: "textField_wrapper" }, children)));
};
const ChoiceField = (props) => {
    const { children, className } = props, restProps = __rest(props, ["children", "className"]);
    return (React__default.createElement(StyledChoiceFieldContainer, Object.assign({ className: clsx(className, 'choiceField') }, restProps), children));
};

const TitleBlock = ({ children, align, }) => (React__default.createElement("h2", { className: `lead-modal__title ${'le-text-align-' + (align || '')} ${LEAD_CLASS}` }, children));

const LightboxFields = ({ listBlockAdded, popupId, locale, onClose, onOtherSubmit, }) => {
    const { t } = useTranslations();
    const form = useLeadFormContext();
    const formValues = form.values;
    const labelTuples = useMemo(() => {
        return ((ISO_FORMAT === null || ISO_FORMAT === void 0 ? void 0 : ISO_FORMAT[locale]) || ISO_FORMAT['vi-VN']).dateFormat
            .split('/')
            .map((key) => { var _a; return t((_a = COMMON_DATE_TRANSLATE_KEY === null || COMMON_DATE_TRANSLATE_KEY === void 0 ? void 0 : COMMON_DATE_TRANSLATE_KEY[key]) === null || _a === void 0 ? void 0 : _a.id); });
    }, [locale]);
    return (React__default.createElement(React__default.Fragment, null, listBlockAdded.map((b, index) => {
        var _a;
        const { name = '', data = {}, id } = b || {};
        const { placeholder, value, align, listQuestion, isSendMailChimp = false, newtab, url, } = data;
        const required = (_a = data.required) !== null && _a !== void 0 ? _a : true;
        const formValue = (formValues === null || formValues === void 0 ? void 0 : formValues[value]) || null;
        switch (name) {
            case 'TitleBlock':
                return (React__default.createElement(TitleBlock, { key: index, align: align }, value));
            case 'SubtitleBlock':
                return (React__default.createElement(SubtitleBlock, { key: index, align: align }, value));
            case 'TextBlock':
                return (React__default.createElement(TextField, { key: index, shrink: !!formValue, className: "lead-modal__form-control leadgen-form_field" },
                    React__default.createElement(TextInput, Object.assign({ withAsterisk: required, spellCheck: false, type: "text", placeholder: placeholder, 
                        // className="lead-modal__form-control leadgen-form_field"
                        // onChangeRaw={(e) => inputOnChange('text', e)}
                        label: placeholder, "data-control": "text", name: value, inputWrapperOrder: ['label', 'input', 'description', 'error'] }, form.getInputProps(value)))));
            case 'NumberBlock':
                return (React__default.createElement(TextField, { key: index, shrink: !!formValue, className: "lead-modal__form-control leadgen-form_field" },
                    React__default.createElement(NumberInput$1, Object.assign({ withAsterisk: required, spellCheck: false, type: "number", placeholder: placeholder, 
                        // className="lead-modal__form-control leadgen-form_field"
                        // onChange={(e) => inputOnChange('number', e)}
                        label: placeholder, "data-control": "number", name: value, inputWrapperOrder: ['label', 'input', 'description', 'error'] }, form.getInputProps(value)))));
            case 'EmailBlock':
                return (React__default.createElement(TextField, { key: index, shrink: !!formValue, className: "lead-modal__form-control leadgen-form_field" },
                    React__default.createElement(TextInput, Object.assign({ withAsterisk: required, spellCheck: false, 
                        // type="email"
                        placeholder: placeholder, 
                        // className="lead-modal__form-control leadgen-form_field"
                        label: placeholder, "data-control": "email", name: value, inputWrapperOrder: ['label', 'input', 'description', 'error'] }, form.getInputProps(value)))));
            case 'PhoneOtpBlock':
            case 'WhatsappOtpBlock':
            case 'ZaloOtpBlock':
            case 'PhoneBlock': {
                const htmlForId = popupId + '-' + value + '-' + index;
                const _b = form.getInputProps(value), { error } = _b, formPhoneInputWrapper = __rest(_b, ["error"]);
                return (React__default.createElement(TextField, { key: index, shrink: !!formValue, className: clsx('lead-modal__form-control leadgen-form_field', {
                        'leadgen-form_field_error': !!error,
                    }) },
                    React__default.createElement(Input$1.Wrapper, { size: "md", withAsterisk: required, label: placeholder, "data-invalid": !!error, labelProps: { htmlFor: htmlForId }, inputWrapperOrder: ['label', 'input', 'description', 'error'], error: error },
                        React__default.createElement("div", { className: "mantine-Input-wrapper" },
                            React__default.createElement(Phone, Object.assign({ className: "mantine-Input-input", name: value, spellCheck: false, type: "tel", placeholder: placeholder, 
                                // onBlur={(e) => inputOnBlur('tel', e)}
                                id: htmlForId, defaultCountry: (locale ? MAPPED_LOCALE[locale] || 'VN' : 'VN'), "data-control": "tel" }, formPhoneInputWrapper))))));
            }
            case 'LocationBlock': {
                return (React__default.createElement(TextField, { key: index, shrink: !!formValue, className: "lead-modal__form-control leadgen-form_field" },
                    React__default.createElement(GoogleLocationBlock, Object.assign({ withAsterisk: required, name: value, placeholder: placeholder, label: placeholder, "data-control": "text", locale: locale, inputWrapperOrder: ['label', 'input', 'description', 'error'] }, form.getInputProps(value)))));
            }
            case 'DateBlock': {
                const _c = form.getInputProps(value), { error } = _c, formInputProps = __rest(_c, ["error"]);
                return (React__default.createElement(Input$1.Wrapper, { key: index, size: "md", withAsterisk: required, label: placeholder, "data-invalid": !!error, inputWrapperOrder: ['label', 'input', 'description', 'error'], error: error, className: "lead-modal__form-control leadgen-form_field" },
                    React__default.createElement(InputDate, Object.assign({ name: value, error: Boolean(error), locale: locale, "data-extra": true, "data-name": value, "data-control": "date", className: "leadgen-form_field_date", labelTuples: labelTuples }, formInputProps))));
            }
            case 'LinkButtonBlock':
                return (React__default.createElement("div", { key: index },
                    React__default.createElement("a", { target: newtab ? 'blank' : 'parrent', href: url, style: { textDecoration: 'none' } },
                        React__default.createElement(Button$2, { type: "button", size: "md", className: `lead-modal__btn ${LEAD_CLASS}`, onClick: () => {
                                onClose === null || onClose === void 0 ? void 0 : onClose();
                                onOtherSubmit === null || onOtherSubmit === void 0 ? void 0 : onOtherSubmit();
                            } }, value))));
            case 'CheckboxBlock':
                return (React__default.createElement(ChoiceField, { className: "leadgen-form_checkbox", key: index },
                    isSendMailChimp && (React__default.createElement("div", { style: {
                            display: 'none',
                        }, "data-name": value + '-mailchimp' })),
                    React__default.createElement(Checkbox.Group, Object.assign({ withAsterisk: required, 
                        // className="lead-modal__form-control leadgen-form_field"
                        label: placeholder, size: "md", sx: {
                            display: 'flex',
                            flexDirection: 'column',
                            flexWrap: 'wrap',
                            gap: 8,
                        }, inputWrapperOrder: ['label', 'input', 'description', 'error'], inputContainer: (children) => {
                            return (React__default.createElement("div", { className: "leadgen-choiceContainer" }, children));
                        } }, form.getInputProps(value)), listQuestion.map((l, _index) => (React__default.createElement(Checkbox, { name: value, key: _index, value: l.value, label: l.placeholder, "data-control": "checkbox" }))))));
            case 'RadioBlock':
                return (React__default.createElement(ChoiceField, { className: "leadgen-form_radio", key: index },
                    isSendMailChimp && (React__default.createElement(Input$1, { type: "hidden", name: value + '-mailchimp', value: isSendMailChimp })),
                    React__default.createElement(Radio.Group, Object.assign({ withAsterisk: required, 
                        // className="lead-modal__form-control leadgen-form_field"
                        label: placeholder, size: "md", inputWrapperOrder: ['label', 'input', 'description', 'error'], inputContainer: (children) => {
                            return (React__default.createElement("div", { className: "leadgen-choiceContainer" }, children));
                        } }, form.getInputProps(value)), listQuestion.map((l, _index) => (React__default.createElement(Radio, { name: value, key: _index, value: l.value, label: l.placeholder, "data-control": "radio" }))))));
            case 'DropdownBlock':
                return (React__default.createElement(TextField, { shrink: !!formValue, className: "lead-modal__form-control leadgen-form_field", key: index },
                    React__default.createElement("div", { style: { display: 'none' }, "data-extra": true, "data-name": value, "data-control": 'dropdown' }),
                    React__default.createElement(Select
                    // className="lead-modal__form-control leadgen-form_field"
                    , Object.assign({ 
                        // className="lead-modal__form-control leadgen-form_field"
                        label: placeholder, placeholder: placeholder, withAsterisk: required, name: value, data: listQuestion.map((l) => ({
                            value: l.value,
                            label: l.placeholder,
                        })) }, form.getInputProps(value)))));
            case 'TncBlock':
                const _d = form.getInputProps(`TNC-${id}`), { error } = _d, tncInputProps = __rest(_d, ["error"]);
                return (React__default.createElement(ChoiceField, { className: "leadgen-form_checkbox", key: id },
                    React__default.createElement(Input$1.Wrapper, { error: error },
                        React__default.createElement(Checkbox, Object.assign({ name: 'TNC-' + id, label: React__default.createElement("p", { className: "lead-modal__tnc-link", dangerouslySetInnerHTML: { __html: data.valueHTML } }), className: "tnc-block", "data-control": "checkbox" }, tncInputProps)))));
        }
        return null;
    })));
};

const StyledFormContainer = styled.div `
  height: 100%;
  .leadgen-form_wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .leadgen-form_inner {
    flex: 1;
    min-height: 0;
    display: flex;

    &:has(.leadgen-header) {
      display: block;
    }
  }

  .leadgen-form_body {
    flex: 1;
    min-height: 0;
    overflow: auto;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-track {
      background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.4);
      border-radius: 6px;
    }
  }

  &[data-hidden-form='true'] {
    .leadgen-form_body {
      display: none;
    }
  }

  [data-align='right'] {
    text-align: right;
  }

  [data-align='center'] {
    text-align: center;
  }
`;
/**
 *
 *  Use this component inside <form></form> tag
 *
 */
const FormContainer = (_a) => {
    var { iconComponent, title, titleAlign, description, descriptionAlign, className, style, children, header, footer } = _a, restProps = __rest(_a, ["iconComponent", "title", "titleAlign", "description", "descriptionAlign", "className", "style", "children", "header", "footer"]);
    const HeaderContent = (React__default.createElement("div", { className: "leadgen-form_header" },
        iconComponent,
        React__default.createElement("h2", { title: title, className: "leadgen-title", "data-align": titleAlign }, title),
        !!description && (React__default.createElement("p", { title: description, className: "leadgen-description", "data-align": descriptionAlign, dangerouslySetInnerHTML: { __html: description } }))));
    if (!title && !description) {
        return null;
    }
    return (React__default.createElement(StyledFormContainer, Object.assign({ className: clsx(className, 'leadgen-form_container'), style: style }, restProps),
        React__default.createElement("div", { className: "leadgen-form_wrapper" },
            !!header && (React__default.createElement("div", { className: "leadgen-form_scrollable" },
                header,
                HeaderContent,
                React__default.createElement("div", { className: "leadgen-form_body" }, children))),
            !header && (React__default.createElement(React__default.Fragment, null,
                HeaderContent,
                React__default.createElement("div", { className: "leadgen-form_body" }, children))),
            React__default.createElement("div", { className: "leadgen-form_footer" }, footer))));
};

const StyleHeaderImage = styled.div `
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  padding-top: ${({ paddingTop }) => paddingTop}%;
  .leadgen-header_image_feature {
    position: absolute;
    inset: 0;
    min-width: 100%;
    min-height: 100%;
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    object-position: center;
  }
`;
const HeaderImage = ({ src, ratio = 3 / 2, className, style, }) => {
    if (!src) {
        return null;
    }
    return (React__default.createElement(StyleHeaderImage, { paddingTop: (1 / ratio) * 100, className: clsx(className, 'leadgen-header_image'), style: style }, isVideo(src) ? (React__default.createElement("video", { muted: true, autoPlay: true, loop: true, className: "leadgen-header_image_feature leadgen-header_image_video", src: src })) : (React__default.createElement("img", { src: src, draggable: "false", alt: "", className: "leadgen-header_image_feature leadgen-header_image_image" }))));
};

const OtpBlock = ({ otpData, onSuccess, autoSendWhenOpen, }) => {
    const { primaryColor } = useContext(LeadGenContext$1);
    const { t } = useTranslations();
    const phone = otpData.phone;
    const otpType = otpData.type;
    const [otp, setOtp] = useState('');
    const [isDirty, setIsDirty] = useState(false);
    const [resendTimer, setResendTimer] = useState(autoSendWhenOpen ? 0 : 60);
    const inputRef = useRef(null);
    const [errorMsg, setErrorMsg] = useState();
    const [displayPhone, setDisplayPhone] = useState('');
    const formatPhoneNumberIntlRef = useRef();
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            if (!formatPhoneNumberIntlRef.current) {
                const res = yield import('react-phone-number-input');
                formatPhoneNumberIntlRef.current = res.formatPhoneNumberIntl;
            }
            setDisplayPhone(((_a = formatPhoneNumberIntlRef.current) === null || _a === void 0 ? void 0 : _a.call(formatPhoneNumberIntlRef, phone)) || phone);
        }))();
    }, [phone]);
    const sendOtp = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!phone) {
            return;
        }
        const res = yield Service.sendSMSOtpLead({
            phone,
            type: otpType,
        });
        const respMessage = (_a = res === null || res === void 0 ? void 0 : res._messages) === null || _a === void 0 ? void 0 : _a[0];
        if (respMessage === 'Send sms successfully' ||
            respMessage === 'Send WhatsApp successfully' ||
            respMessage === 'Send Zalo successfully') {
            setResendTimer(60);
            setTimeout(() => {
                if (inputRef.current) {
                    inputRef.current.focus();
                    inputRef.current.scrollIntoView({ block: 'center' });
                }
            }, 100);
        }
        else if (respMessage === 'This phone number was verified') {
            onSuccess();
        }
        else {
            setErrorMsg(respMessage || 'Something went wrong!');
            // const defaultError = f({ id: 'notification.comment.somethingWrong' })
            // setStatusVerifyOTP('idle')
            // pushNotifications({
            //   title: respMessage || defaultError,
            //   message: '',
            //   type: 'danger',
            // })
        }
    });
    const submitOtp = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!phone || !otp) {
            return;
        }
        setIsSubmitLoading(true);
        const res = yield Service.verifyOtpLead({
            phone,
            otp,
            type: otpType,
        });
        const respMessage = res === null || res === void 0 ? void 0 : res._messages[0];
        if (respMessage === 'Verify successfully' ||
            respMessage === 'Verify WhatsApp OTP sucess' ||
            respMessage === 'Verify Zalo OTP sucess') {
            onSuccess();
        }
        else if (respMessage === 'This phone number was verified') {
            onSuccess();
        }
        else {
            setErrorMsg(respMessage || 'something Wrong');
            // setIsShowError(true)
            // setStatusVerifyOTP('sent')
            // pushNotifications({
            //   title: res?._messages[0] || defaultError,
            //   message: '',
            //   type: 'danger',
            // })
        }
        setIsSubmitLoading(false);
    });
    useEffect(() => {
        setTimeout(() => {
            if (resendTimer > 0) {
                setResendTimer((r) => r - 1);
            }
        }, 1000);
    }, [resendTimer]);
    useEffect(() => {
        if (autoSendWhenOpen && !resendTimer) {
            sendOtp();
        }
    }, []);
    return (React__default.createElement("form", { onSubmit: (e) => {
            e.preventDefault();
            submitOtp();
        }, className: "lead-phone-otp-form leadgen-form leadgen-form_otp" },
        React__default.createElement(FormContainer, { title: t('lead.otp.title'), description: t('lead.otp.desc', {
                phone: `<strong>${displayPhone}</strong>`,
            }), footer: React__default.createElement(React__default.Fragment, null,
                React__default.createElement(Button$1, { type: "submit", size: "lg", variant: "filled", className: `lead-modal__btn leadgen-btn_action ${LEAD_CLASS}`, color: primaryColor, disabled: !otp, loading: isSubmitLoading }, t('lead.otp.verify')),
                React__default.createElement(Button$1, { type: "button", size: "lg", variant: "light", className: `lead-modal__btn lead-phone-otp-button leadgen-btn_action ${LEAD_CLASS}`, color: primaryColor, onClick: () => {
                        sendOtp();
                    }, disabled: !!resendTimer }, t('lead.otp.resend', {
                    timer: resendTimer ? ` (${resendTimer}s)` : '',
                }))) },
            React__default.createElement("div", { className: "leadgen-form_inner" },
                React__default.createElement(Input.Wrapper, { error: isDirty ? errorMsg : undefined, className: "leadgen-form_field" },
                    React__default.createElement(OTP, { ref: inputRef, name: '_' + name + '-otp', value: otp, onChange: (v) => {
                            setIsDirty(true);
                            setOtp(v.toString());
                            if (isDirty && !v)
                                setErrorMsg('OTP is required');
                            else
                                setErrorMsg(undefined);
                        } }))))));
};

// url: imageBlocks.imageMobile.data.url
// newTab: imageBlocks.imageMobile.data.newtab
// image: campaignShow.image
// imageDestkop: campaignShow.image_desktop
const LEADGEN_LAYOUT_NOT_SHOW_IN_MOBILE = [
    LEADGEN_LAYOUT.Fullscreen,
    LEADGEN_LAYOUT.Slider,
];
const LEADGEN_LIMIT_LIGHTBOXB = 6;
const LEADGEN_SHOW_HEADER = [
    'LightBoxA',
    'InlineA',
    LEADGEN_LAYOUT.Sidebar,
    LEADGEN_LAYOUT.Slider,
];
const LightboxLayout = ({ popupId, extraFields, onClose: onCloseProp, onOtherSubmit, imageMobile, imageDesktop, imageOverlayMobile, imageOverlayDesktop, imageBackground, currentLayout, title, onSubmit, showThankyou, campaignId, campaign_subot_id, locale, showEmpty, setShowEmpty, userInfo, }) => {
    var _a, _b;
    const { primaryColor } = useContext(LeadGenContext$1);
    const { isMobile } = useScreenSize();
    const [open, setOpen] = useState(!!campaignId);
    const [showOtpPhone, setShowOtpPhone] = useState(null);
    const [isSubmitLoading, setIsSubmitLoading] = useState(false);
    const [snap, setSnap] = useState(0.8);
    const formRef = useRef();
    const onClose = () => {
        if (showOtpPhone) {
            setShowOtpPhone(null);
        }
        else {
            onCloseProp === null || onCloseProp === void 0 ? void 0 : onCloseProp();
        }
    };
    const textBlocks = JSON.parse(extraFields.textBlocks);
    const listBlockAdded = JSON.parse(extraFields.listBlockAdded);
    const actionBlocks = JSON.parse(extraFields.actionBlocks);
    const popUpSubmitText = actionBlocks.submitBlock.data.value;
    const currentPath = location.pathname;
    const { align: descriptionAlign, value: description } = textBlocks.subtitleBlock.data || {};
    const { align: titleAlign } = textBlocks.titleBlock.data || {};
    const isSlider = currentLayout === LEADGEN_LAYOUT.Slider;
    const isSidebar = currentLayout === LEADGEN_LAYOUT.Sidebar;
    const isLightBox = currentLayout.includes('LightBox');
    const isLightBoxA = currentLayout === LEADGEN_LAYOUT.LightBoxA;
    const isLightBoxB = currentLayout === LEADGEN_LAYOUT.LightBoxB;
    const isInline = currentLayout.includes('Inline');
    const isFullscreen = currentLayout === LEADGEN_LAYOUT.Fullscreen;
    const isInPage = isInline || isSidebar;
    const isDrawer = isLightBoxB && isMobile;
    const limitFieldsLightBoxB = isLightBoxB && listBlockAdded.length <= LEADGEN_LIMIT_LIGHTBOXB;
    const hasForm = isLightBoxA
        ? listBlockAdded.some((item) => LEADGEN_BLOCK_INPUT.some((k) => k === (item === null || item === void 0 ? void 0 : item.name)))
        : true;
    const headerInsideFormContainer = isSlider || isLightBoxA || isFullscreen;
    const showHeader = !!imageMobile || !!imageDesktop;
    const onlyHeader = !title && !description;
    const showButtonClose = !isInline;
    if (window.innerWidth < 769 &&
        LEADGEN_LAYOUT_NOT_SHOW_IN_MOBILE.includes(currentLayout)) {
        console.log('😎 Not show fullscreen, slider on mobile ');
        return null;
    }
    useEffect(() => {
        if (isLightBox || isFullscreen) {
            document.body.classList.add('noscroll');
        }
        if (!window.intlTelInputUtils) {
            require('intl-tel-input/build/js/utils');
        }
        clearCacheUsedEmailOrPhone();
    }, []);
    const validatingPhoneRef = useRef(false);
    const validatingEmailRef = useRef(false);
    const { form, validateObj } = useLeadFormConfig({
        listBlockAdded,
        validatingPhoneRef,
        validatingEmailRef,
        campaignId,
        campaign_subot_id,
        userInfo,
        format: (_a = (ISO_FORMAT[locale] || ISO_FORMAT['vi-VN'])) === null || _a === void 0 ? void 0 : _a.dateFormat,
    });
    const listBlockAddedRequired = useMemo(() => leadGenFieldRequired(listBlockAdded), listBlockAdded);
    const disabledButtonSubmit = useMemo(() => {
        if (listBlockAddedRequired.length) {
            return listBlockAddedRequired.some((k) => !form.values[k]);
        }
        return false;
    }, [...listBlockAddedRequired.map((k) => form.values[k])]);
    const onFocus = (e) => {
        e.preventDefault();
        setTimeout(() => {
            const target = e.target;
            target.scrollIntoView({ block: 'center', behavior: 'auto' });
        }, 300); // Wait a bit to let keyboard open
    };
    const middlewareOnSubmit = (e) => {
        e.preventDefault();
        // mark all as touched to allow validation
        const fields = Object.keys(validateObj);
        const fieldStatus = fields.reduce((acc, cur) => {
            acc[cur] = true;
            return acc;
        }, {});
        form.setTouched(fieldStatus);
        if (validatingEmailRef.current || validatingPhoneRef.current) {
            return;
        }
        setTimeout(() => {
            form.onSubmit((v) => {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                if (Object.keys(form.errors).length)
                    return;
                let newShowOtpPhone = null;
                if (listBlockAdded.findIndex((x) => x.name === LEADGEN_BLOCK.PhoneOtpBlock) > -1) {
                    // not submit yet, open otp
                    const fieldName = (_b = (_a = listBlockAdded.find((x) => x.name === LEADGEN_BLOCK.PhoneOtpBlock)) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.value;
                    if ((_c = v[fieldName]) === null || _c === void 0 ? void 0 : _c.startsWith('+')) {
                        newShowOtpPhone = {
                            phone: v[fieldName],
                            type: 'phone',
                        };
                    }
                }
                if (listBlockAdded.findIndex((x) => x.name === LEADGEN_BLOCK.WhatsappOtpBlock) > -1) {
                    // not submit yet, open otp
                    const fieldName = (_e = (_d = listBlockAdded.find((x) => x.name === LEADGEN_BLOCK.WhatsappOtpBlock)) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.value;
                    if ((_f = v[fieldName]) === null || _f === void 0 ? void 0 : _f.startsWith('+')) {
                        newShowOtpPhone = {
                            phone: v[fieldName],
                            type: 'whatsapp',
                        };
                    }
                }
                if (listBlockAdded.findIndex((x) => x.name === LEADGEN_BLOCK.ZaloOtpBlock) > -1) {
                    // not submit yet, open otp
                    const fieldName = (_h = (_g = listBlockAdded.find((x) => x.name === LEADGEN_BLOCK.ZaloOtpBlock)) === null || _g === void 0 ? void 0 : _g.data) === null || _h === void 0 ? void 0 : _h.value;
                    if ((_j = v[fieldName]) === null || _j === void 0 ? void 0 : _j.startsWith('+')) {
                        newShowOtpPhone = {
                            phone: v[fieldName],
                            type: 'zalo',
                        };
                    }
                }
                if (newShowOtpPhone) {
                    setIsSubmitLoading(true);
                    Service.sendSMSOtpLead(newShowOtpPhone)
                        .then((res) => {
                        var _a;
                        const respMessage = (_a = res === null || res === void 0 ? void 0 : res._messages) === null || _a === void 0 ? void 0 : _a[0];
                        if (respMessage === 'This phone number was verified') {
                            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(formRef.current, v);
                            return;
                        }
                        setShowOtpPhone(newShowOtpPhone);
                    })
                        .finally(() => {
                        setIsSubmitLoading(false);
                    });
                    return;
                }
                onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(formRef.current, v);
            })(e);
        }, 100);
    };
    const onOpenChange = (_open) => {
        setOpen(_open);
        if (!_open) {
            setTimeout(() => {
                onClose();
            }, 250);
        }
    };
    const { width: imageBackgroundWidth, height: imageBackgroundHeight, loaded: imageBackgroundLoaded, } = useImageSize(imageBackground);
    const { loaded: imageMobileLoaded } = useImageSize(imageMobile);
    const { loaded: imageDesktopLoaded } = useImageSize(imageDesktop);
    const renderAfterImageSizes = imageMobileLoaded &&
        imageDesktopLoaded &&
        (isFullscreen ? imageBackgroundLoaded : true);
    const ButtonSubmit = useMemo(() => {
        var _a;
        return !((_a = actionBlocks === null || actionBlocks === void 0 ? void 0 : actionBlocks.submitBlock) === null || _a === void 0 ? void 0 : _a.isHide) && (React__default.createElement(Button$1, { size: "lg", id: "lead-submit", type: "submit", variant: "filled", className: "leadgen-btn leadgen-btn_action", color: primaryColor, loading: isSubmitLoading, disabled: disabledButtonSubmit }, popUpSubmitText));
    }, [
        popUpSubmitText,
        isSubmitLoading,
        disabledButtonSubmit,
        (_b = actionBlocks === null || actionBlocks === void 0 ? void 0 : actionBlocks.submitBlock) === null || _b === void 0 ? void 0 : _b.isHide,
    ]);
    const LinkButtonBlock = listBlockAdded.filter(({ name }) => name == LEADGEN_BLOCK.LinkButtonBlock);
    const ButtonLink = !!(LinkButtonBlock === null || LinkButtonBlock === void 0 ? void 0 : LinkButtonBlock.length) && (React__default.createElement(React__default.Fragment, null, LinkButtonBlock.map((item, index) => {
        var _a, _b, _c;
        return (React__default.createElement(Button$1, { key: `${item.name}-${index}`, component: "a", href: (_a = item === null || item === void 0 ? void 0 : item.data) === null || _a === void 0 ? void 0 : _a.url, target: ((_b = item === null || item === void 0 ? void 0 : item.data) === null || _b === void 0 ? void 0 : _b.newtab) ? '_blank' : undefined, size: "lg", variant: "filled", className: "leadgen-btn leadgen-btn_action", color: primaryColor, onClick: () => {
                onClose === null || onClose === void 0 ? void 0 : onClose();
                onOtherSubmit === null || onOtherSubmit === void 0 ? void 0 : onOtherSubmit();
            } }, (_c = item === null || item === void 0 ? void 0 : item.data) === null || _c === void 0 ? void 0 : _c.value));
    })));
    const PopupHeader = showHeader && (React__default.createElement("header", { className: clsx('leadgen-header', { 'leadgen-header_only': onlyHeader }) }, LEADGEN_SHOW_HEADER.includes(currentLayout) ? (React__default.createElement(HeaderImage, { src: imageMobile, className: "lead-modal__image" })) : (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(HeaderImage, { src: imageDesktop, className: "le-only-desktop lead-modal__image" }),
        React__default.createElement(HeaderImage, { src: imageMobile, className: "le-only-mobile lead-modal__image" })))));
    const PopupEmpty = showEmpty && (React__default.createElement(EmptyComponent, { onClose: onClose, onContinue: () => setShowEmpty(false) }));
    const PopupForm = (React__default.createElement(LeadFormProvider, { form: form },
        React__default.createElement("form", { ref: formRef, className: "leadgen-form", onFocus: onFocus, onSubmit: middlewareOnSubmit },
            React__default.createElement(FormContainer, { title: title, titleAlign: titleAlign, description: description, descriptionAlign: descriptionAlign, header: headerInsideFormContainer && PopupHeader, footer: hasForm ? ButtonSubmit : ButtonLink, "data-hidden-form": !hasForm },
                React__default.createElement("div", { className: "leadgen-form_inner" },
                    React__default.createElement(LightboxFields, { listBlockAdded: listBlockAdded, popupId: popupId, locale: locale, onClose: onClose, onOtherSubmit: onOtherSubmit }))))));
    const PopupOtp = showOtpPhone && (React__default.createElement(OtpBlock, { otpData: showOtpPhone, autoSendWhenOpen: false, onSuccess: () => {
            setShowOtpPhone(null);
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(formRef.current, form.values);
        } }));
    const PopupThankYou = showThankyou && (React__default.createElement(ThankyouPopup, { title: showThankyou.title, titleAlign: showThankyou.titleAlign, subtitle: showThankyou.subtitle, subtitleAlign: showThankyou.subtitleAlign, link: showThankyou.link, linkNewTab: showThankyou.linkNewTab, linkText: showThankyou.linkText, image: showThankyou.image }));
    const PopupContent = (React__default.createElement("div", { className: clsx('leadgen-content', {
            'leadgen-content_small': limitFieldsLightBoxB,
        }) },
        !headerInsideFormContainer && PopupHeader,
        !onlyHeader && (React__default.createElement("div", { className: "leadgen-inner" },
            PopupThankYou,
            !showThankyou && (React__default.createElement(React__default.Fragment, null,
                PopupOtp,
                PopupEmpty,
                !(showOtpPhone || showEmpty) && PopupForm))))));
    const styleOverlay = useMemo(() => {
        let styleContent = `.leadgen-inner {background-repeat: no-repeat;background-size: cover;background-position:center;}`;
        if (isMobile && imageOverlayMobile) {
            styleContent += `.leadgen-inner {background-image: url(${imageOverlayMobile});}`;
        }
        if (!isMobile && imageOverlayDesktop) {
            styleContent += `@media screen and (min-width:768px) {.leadgen-inner {background-image: url(${imageOverlayDesktop});}}`;
        }
        return styleContent;
    }, [isMobile, imageOverlayDesktop, imageOverlayMobile]);
    const PopupWrapper = (React__default.createElement(React__default.Fragment, null,
        React__default.createElement("style", { dangerouslySetInnerHTML: { __html: styleOverlay } }),
        React__default.createElement("div", { className: clsx('leadgen-wrapper', {
                'leadgen-wrapper_small': limitFieldsLightBoxB,
            }) },
            showButtonClose && (React__default.createElement(CloseButton, { onClose: () => onOpenChange(false), containerClassName: "leadgen-close_btn" })),
            PopupContent)));
    const popupContainerClassName = clsx('leadgen', `leadgen-${currentLayout}`, {
        'leadgen-lightbox': isLightBox,
        'leadgen-inline': isInPage,
        'leadgen-slider': isSlider,
    });
    const PopupContainer = isDrawer ? (
    // <LeadGenLightBoxB
    //   form={form}
    //   loading={isSubmitLoading}
    //   visible={open}
    //   onVisible={() => onOpenChange(false)}
    // >
    //   {PopupWrapper}
    // </LeadGenLightBoxB>
    React__default.createElement(DrawerComponent, { fadeFromIndex: ZINDEX_SSO - 9e6, open: open, snapPoints: [0.8, 1], activeSnapPoint: snap, setActiveSnapPoint: setSnap, onOpenChange: onOpenChange, overlayClassName: popupContainerClassName, className: "leadgen-drawer" },
        PopupWrapper,
        React__default.createElement("div", { style: { position: 'absolute', inset: 0, zIndex: snap === 1 ? -1 : 1 }, onClick: () => setSnap(1) }))) : (React__default.createElement("div", { id: popupId, "data-popup-url": currentPath, "data-popup-type": "lightbox-inline", className: popupContainerClassName },
        isFullscreen ? (React__default.createElement("img", { className: "le-only-desktop le-fullscreen-img", draggable: false, src: imageBackground || '', style: {
                aspectRatio: `${imageBackgroundWidth}/${imageBackgroundHeight}`,
            } })) : null,
        PopupWrapper));
    if (!renderAfterImageSizes)
        return null;
    if (isLightBox || isFullscreen || isSlider) {
        return PopupContainer;
    }
    else if (isSidebar) {
        return React__default.createElement(SideBarLayout, { content: PopupContainer });
    }
    else if (isInline) {
        return (React__default.createElement(InlineLayout, { content: PopupContainer, inlinePosition: extraFields.popupInlinePosition }));
    }
    return null;
};

const SkinLayout = ({ popupId, link, linkText, linkNewTab, onClose, imageMobile, imageDesktop, currentLayout, onOtherSubmit, }) => {
    const currentPath = location.pathname;
    const { width: imageMobileWidth, height: imageMobileHeight, loaded: imageMobileLoaded, } = useImageSize(imageMobile);
    const { width: imageDesktopWidth, height: imageDesktopHeight, loaded: imageDesktopLoaded, } = useImageSize(imageDesktop);
    if (!imageMobileLoaded || !imageDesktopLoaded)
        return null;
    return (React__default.createElement("div", { id: popupId, className: "lead-modal-wrapper", "data-popup-url": currentPath, "data-popup-type": "skin_ab" },
        currentLayout == 'SkinA' ? (React__default.createElement("aside", { className: "le-only-desktop" },
            React__default.createElement("div", { className: "le-skin-a-desktop" },
                React__default.createElement("div", { style: { position: 'relative' } },
                    React__default.createElement("img", { src: imageDesktop, style: {
                            aspectRatio: `${imageDesktopWidth}/${imageDesktopHeight}`,
                        } }),
                    React__default.createElement("a", { style: {
                            position: 'absolute',
                            top: '75%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            textAlign: 'center',
                            width: 'calc(100% - 15px)',
                        }, href: link, target: linkNewTab ? 'blank' : '_parent' },
                        React__default.createElement("button", { onClick: onOtherSubmit, className: "le-joinbow-btn js-popup-other-submit" }, linkText)),
                    React__default.createElement(CloseButton, { onClose: onClose, containerClassName: "close-button-top-right" }))))) : currentLayout == 'SkinB' ? (React__default.createElement("aside", { className: "le-only-desktop" },
            React__default.createElement("div", { className: "" },
                React__default.createElement("div", { style: { position: 'relative', zIndex: 10000 } },
                    React__default.createElement("img", { src: imageDesktop, style: {
                            width: '100%',
                            aspectRatio: `${imageDesktopWidth}/${imageDesktopHeight}`,
                        } }),
                    React__default.createElement("a", { style: {
                            position: 'absolute',
                            top: '75%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            textAlign: 'center',
                            width: '100%',
                        }, href: link, target: linkNewTab ? 'blank' : '_parent' },
                        React__default.createElement("button", { onClick: onOtherSubmit, className: "le-joinbow-btn-mobile js-popup-other-submit" }, linkText)),
                    React__default.createElement(CloseButton, { containerClassName: "close-button-top-right", onClose: onClose }))))) : null,
        React__default.createElement("aside", { className: "le-only-mobile" },
            React__default.createElement("div", { className: "le-skin-mobile" },
                React__default.createElement("div", { style: { position: 'relative' } },
                    isVideo(imageMobile) ? (React__default.createElement("video", { muted: true, autoPlay: true, loop: true },
                        React__default.createElement("source", { src: imageMobile, type: "video/mp4" }))) : (React__default.createElement("img", { src: imageMobile, style: {
                            width: '100%',
                            aspectRatio: `${imageMobileWidth}/${imageMobileHeight}`,
                        } })),
                    React__default.createElement("a", { style: {
                            position: 'absolute',
                            top: '82%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            textAlign: 'center',
                            maxWidth: 'calc(100% - 15px)',
                        }, href: link, target: linkNewTab ? 'blank' : '_parent' },
                        React__default.createElement("button", { onClick: onOtherSubmit, className: "le-joinbow-btn-mobile js-popup-other-submit" }, linkText)),
                    React__default.createElement(CloseButton, { containerClassName: "close-button-top-right", svgClassName: "le-mobile-btn", onClose: onClose }))))));
};

// url: imageBlocks.imageMobile.data.url
// newTab: imageBlocks.imageMobile.data.newtab
// image: campaignShow.image
// imageDestkop: campaignShow.image_desktop
const TabLayout = ({ popupId, url, newTab, image, onClose, onOtherSubmit, }) => {
    const { width: imageWidth, height: imageHeight, loaded: imageLoaded, } = useImageSize(image);
    if (!imageLoaded)
        return null;
    return (React__default.createElement("div", { id: popupId, className: "lead-modal-wrapper", "data-popup-url": location.pathname, "data-popup-type": "tab" },
        React__default.createElement("div", { className: "le-tab-popup" },
            React__default.createElement("div", { style: { position: 'relative' } },
                React__default.createElement("a", { href: url, target: newTab ? 'blank' : '_parent', onClick: onOtherSubmit },
                    React__default.createElement("img", { className: "js-popup-other-submit", src: image, style: {
                            aspectRatio: `${imageWidth}/${imageHeight}`,
                        } })),
                React__default.createElement(CloseButton, { onClose: onClose, containerClassName: "close-button-top-right" })))));
};

function getCategoryLevel(t = 'Xin chao {{category_2}} extra') {
    if (t.includes('{{category_')) {
        const cl = '{{category_'.length;
        const sc = t.search('{{category_');
        const sf = t.charAt(cl + sc);
        return +sf;
    }
    else {
        return null;
    }
}
const NewLeadPopup = ({ campaign, action, onSubmit, onClose, showThankyou, locale, showEmpty, setShowEmpty, userInfo, }) => {
    var _a, _b;
    const { apiUrl, siteDomain } = useContext(LeadGenContext$1);
    useEffect(() => {
        const gaCookie = getCookie('_ga') || null;
        fetch(`${apiUrl}api/campaign/${code}/impression`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                action,
                url: location.href.toLowerCase(),
                title_article: document.title,
                cookie_id: getCookie('hhg-id'),
                ga_client_id: gaCookie,
            }),
        });
    }, []);
    const { extra_fields, image, image_desktop, code, image_background, image_overlay_mobile, image_overlay_desktop, } = campaign || {};
    const { currentLayout } = extra_fields;
    const imageBlocks = extra_fields.imageBlocks
        ? JSON.parse(extra_fields.imageBlocks)
        : {};
    const actionBlocks = JSON.parse(extra_fields.actionBlocks);
    const textBlocks = JSON.parse(extra_fields.textBlocks);
    let titleText = ((_b = (_a = textBlocks === null || textBlocks === void 0 ? void 0 : textBlocks.titleBlock) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.value) || '';
    const categoryData = {
        1: {},
        2: {},
        3: {},
    };
    const popupIdRef = useRef('lead-modal-' + v1());
    const categoryLevel = getCategoryLevel(titleText);
    if (categoryLevel) {
        LeadLog('⚡️ Has categoryLevel', categoryLevel);
        const listMeta = Array.from(document.getElementsByTagName('META'));
        const valueMeta = listMeta.find((i) => i.name === `content_category_${categoryLevel}`);
        const valueMetaEn = listMeta.find((i) => i.name === `content_category_en_${categoryLevel}`);
        if (valueMeta && valueMetaEn) {
            categoryData[categoryLevel] = {
                value: valueMeta.content,
                value_en: valueMetaEn.content,
            };
            titleText = titleText.replace(`{{category_${categoryLevel}}}`, valueMeta.content);
            LeadLog('⚡️ Set categoryData ', categoryLevel);
        }
        else {
            LeadLog('⚡️ No META TAG for categoryLevel, not show popup', categoryLevel);
            return null;
        }
    }
    else {
        LeadLog('⚡️ No categoryLevel', categoryLevel);
    }
    const onOtherSubmit = () => {
        var _a, _b, _c, _d;
        LeadLog('👌 Other submit click');
        document.body.classList.remove('noscroll');
        if (currentLayout.includes('Skin')) {
            const $head = document.querySelector('#masthead');
            if ($head) {
                $head.style.top = 0 + 'px !important;';
            }
        }
        const expiresDay = Number((_b = (_a = campaign.rules.find((r) => r.rule == 'days_to_show_again')) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : 7);
        const showAgain = Number((_d = (_c = campaign.rules.find((r) => r.rule == 'show_again_after_submit')) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : 0);
        if (showAgain === 0) {
            LeadLog('⛔ Popup never show again!');
            setCookie(`lead_submited_${code}`, `target_${extra_fields.popupVersion}`, { domain: '.' + siteDomain, path: '/' });
        }
        if (showAgain == 1) {
            LeadLog(`⌛ Popup will show again after ${expiresDay} days!`);
            setCookie(`lead_submited_${code}`, `target_${extra_fields.popupVersion}`, { domain: '.' + siteDomain, days: expiresDay, path: '/' });
        }
        const gaCookie = getCookie('_ga') || null;
        const data = {
            url: location.href.toLowerCase(),
            title_article: document.title,
            meta: [],
            cookie_id: getCookie('hhg-id'),
            ga_client_id: gaCookie,
        };
        if (categoryLevel) {
            data['category'] = categoryData[categoryLevel].value_en;
        }
        fetch(`${apiUrl}api/campaign/${code}/lead`, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
            },
        })
            .then((response) => response.json())
            .then((data) => {
            if (data.status === 'error') {
                LeadLog(data);
            }
        })
            .catch((error) => {
            LeadLog('Error:', error);
        });
        onClose === null || onClose === void 0 ? void 0 : onClose();
    };
    if (currentLayout === 'CenterTab') {
        return (React__default.createElement(CenterTabLayout, { popupId: popupIdRef.current, url: imageBlocks.imageMobile.data.url, newTab: imageBlocks.imageMobile.data.newtab, imageMobile: image, imageDestkop: image_desktop, onClose: onClose, onOtherSubmit: onOtherSubmit }));
    }
    else if (currentLayout === 'Tab') {
        return (React__default.createElement(TabLayout, { popupId: popupIdRef.current, url: imageBlocks.imageMobile.data.url, newTab: imageBlocks.imageMobile.data.newtab, image: image, onClose: onClose, onOtherSubmit: onOtherSubmit }));
    }
    else if (currentLayout === 'Floating') {
        return (React__default.createElement(FloatingLayout, { popupId: popupIdRef.current, title: titleText, titleAlign: textBlocks.titleBlock.data.align, subtitle: textBlocks.subtitleBlock.data.value, subtitleAlign: textBlocks.subtitleBlock.data.align, url: actionBlocks.linkButtonBlock.data.url, urlText: actionBlocks.linkButtonBlock.data.value, newTab: actionBlocks.linkButtonBlock.data.newtab, imageMobile: image, imageDesktop: image_desktop, onClose: onClose, onOtherSubmit: onOtherSubmit }));
    }
    else if (currentLayout.includes('LightBox') ||
        currentLayout.includes('Inline') ||
        currentLayout == 'Fullscreen' ||
        currentLayout == 'Sidebar' ||
        currentLayout == 'Slider') {
        return (React__default.createElement(LightboxLayout, { popupId: popupIdRef.current, extraFields: extra_fields, onClose: onClose, onOtherSubmit: onOtherSubmit, imageMobile: image, imageDesktop: image_desktop, imageBackground: image_background, currentLayout: currentLayout, title: titleText, onSubmit: (form, values) => onSubmit(form, values, categoryLevel, categoryData), key: currentLayout, imageOverlayDesktop: image_overlay_desktop, imageOverlayMobile: image_overlay_mobile, showThankyou: showThankyou, campaignId: campaign.id, campaign_subot_id: campaign.bot_id || [], locale: locale, showEmpty: showEmpty, setShowEmpty: setShowEmpty, userInfo: userInfo }));
    }
    else if (currentLayout.includes('Skin')) {
        return (React__default.createElement(SkinLayout, { popupId: popupIdRef.current, link: actionBlocks.linkButtonBlock.data.url, linkNewTab: !!actionBlocks.linkButtonBlock.data.newtab, linkText: actionBlocks.linkButtonBlock.data.value, onClose: onClose, onOtherSubmit: onOtherSubmit, imageMobile: image, imageDesktop: image_desktop, currentLayout: currentLayout }));
    }
    return null;
};

// mount css
const _LeadGen = ({ apiUrl: apiUrlProp, siteDomain, siteId, locale, primaryColor, apiSubotUrl, DEBUG_URL, forceCampaign, children, extraPayloadValues = [], excludeExitRulesHandler, userInfo, onClose: onCloseProps, }) => {
    var _a;
    const scrollEventHandlerRef = useRef();
    const leadStartTimeRef = useRef(Date.now());
    const { apiUrl } = useMemo(() => {
        let apiUrl = apiUrlProp;
        if (apiUrl.includes('localhost')) {
            apiUrl = 'https://dev.leadgen.hellobacsi.com/';
        }
        return {
            apiUrl,
        };
    }, [apiUrlProp, siteDomain, siteId]);
    const [showCampaign, setShowCampaign] = useState(forceCampaign);
    const [action, setAction] = useState('');
    const [showThankyou, setShowThankyou] = useState(null);
    const [showEmpty, setShowEmpty] = useState(false);
    useEffect(() => {
        if (forceCampaign) {
            setShowCampaign(forceCampaign);
            setAction('SHOW');
        }
    }, [forceCampaign === null || forceCampaign === void 0 ? void 0 : forceCampaign.code]);
    useEffect(() => {
        leadStore.apiLeadUrl = apiUrl;
        leadStore.apiSubotUrl = apiSubotUrl;
    }, [apiUrl, apiSubotUrl]);
    const onShowPopup = (campaign, action) => {
        // TODO: run campaign
        setShowCampaign(campaign);
        setAction(action);
    };
    const onCloseBase = () => {
        document.body.classList.remove('noscroll');
        setShowCampaign(null);
        setShowThankyou(null);
        setAction('HIDE');
        onCloseProps === null || onCloseProps === void 0 ? void 0 : onCloseProps();
    };
    const onClose = () => {
        var _a, _b;
        if (!showCampaign)
            return;
        LeadLog(`👋👋👋 CLOSE POPUP ${showCampaign.code} 👋👋👋`);
        if (!excludeExitRulesHandler) {
            const showAfterExit = Number((_a = showCampaign.rules.find((rule) => rule.rule == 'show_again_after_exit')) === null || _a === void 0 ? void 0 : _a.value);
            const expiresDay = Number((_b = showCampaign.rules.find((rule) => rule.rule == 'days_to_show_again')) === null || _b === void 0 ? void 0 : _b.value);
            if (showAfterExit == 0) {
                if (!expiresDay) {
                    setCookie(`lead_closed_${showCampaign.code}`, `target_${showCampaign === null || showCampaign === void 0 ? void 0 : showCampaign.extra_fields.popupVersion}`, { domain: '.' + siteDomain, path: '/' });
                }
                else {
                    setCookie(`lead_closed_${showCampaign.code}`, `target_${showCampaign === null || showCampaign === void 0 ? void 0 : showCampaign.extra_fields.popupVersion}`, { domain: '.' + siteDomain, days: expiresDay, path: '/' });
                }
            }
        }
        fetch(`${apiUrl}api/campaign/${showCampaign.code}/popup_exit`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                action: 'CLICK',
                url: location.href.toLowerCase(),
                title_article: document.title,
                cookie_id: getCookie('hhg-id'),
                duration: Math.ceil((Date.now() - leadStartTimeRef.current) / 1000),
            }),
        });
        onCloseBase();
    }; //
    useEffect(() => {
        if (forceCampaign === null || forceCampaign === void 0 ? void 0 : forceCampaign.code)
            return;
        // window.next only on nextjs page
        if (window.next) {
            const debounced = debounce((e) => {
                LeadLog('--🌻 routeChangeComplete', e, Date.now());
                const currentPath = location.pathname;
                // Remove floating, inline when url change
                onClose();
                clearPassiveEvent();
                if (document.querySelectorAll(`[data-popup-url="${currentPath}"]`).length) {
                    LeadLog('🔥 This URL page has show popup!');
                }
                else {
                    LeadLog('--Process checkShowPopup');
                    checkShowPopup({
                        leadApi: apiUrl,
                        leadDomain: siteDomain,
                        leadSiteId: siteId,
                        onShowPopup,
                        DEBUG_URL,
                    });
                }
                if (scrollEventHandlerRef.current) {
                    window.removeEventListener('scroll', scrollEventHandlerRef.current);
                }
            }, 500);
            window.next.router.events.on('routeChangeComplete', debounced);
        }
        checkShowPopup({
            leadApi: apiUrl,
            leadDomain: siteDomain,
            leadSiteId: siteId,
            onShowPopup,
            DEBUG_URL,
        });
    }, []);
    const onSubmit = (currentForm, formDataObj, categoryLevel, categoryData) => __awaiter(void 0, void 0, void 0, function* () {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (!formDataObj || Object.values(formDataObj).every((v) => !Boolean(v))) {
            setShowEmpty(true);
            return;
        }
        LeadLog('submitHandler', categoryLevel, categoryData);
        const formData = Object.keys(formDataObj)
            .filter((key) => !!formDataObj[key])
            .map((key) => ({
            name: key,
            value: String(formDataObj[key]),
        }));
        console.log('** RYAN index.tsx 218 formData : ', formData);
        const numberFormatType = 2; // i18n.phonenumbers.PhoneNumberFormat.NATIONAL
        // Get ga_client_id from cookies
        const gaCookie = getCookie('_ga') || null;
        if (!window.intlTelInputUtils) {
            yield require('intl-tel-input/build/js/utils');
        }
        const data = {
            url: location.href.toLowerCase(),
            title_article: document.title,
            meta: [
                ...formData.map((i) => {
                    var _a, _b;
                    const control = ((_a = currentForm
                        .querySelector(`*[name="${i.name}"][data-control]`)) === null || _a === void 0 ? void 0 : _a.getAttribute('data-control')) ||
                        ((_b = currentForm
                            .querySelector(`*[data-extra][data-name="${i.name}"]`)) === null || _b === void 0 ? void 0 : _b.getAttribute('data-control')) ||
                        'text';
                    const value = control === 'tel'
                        ? window.intlTelInputUtils
                            .formatNumber(String(i.value), LEAD_LOCALE === null || LEAD_LOCALE === void 0 ? void 0 : LEAD_LOCALE.countryCodeNumber, numberFormatType)
                            .replace(/\s+/g, '')
                        : control === 'date'
                            ? dayjs(i.value).format('YYYY-MM-DD')
                            : i.value;
                    return {
                        key: i.name,
                        value,
                        control,
                        // is_sent_mailchimp: currentForm.querySelector(
                        //   `div[data-name="${i.name}-mailchimp"]`,
                        // )
                        //   ? 'true'
                        //   : 'false',
                    };
                }),
                ...extraPayloadValues,
            ],
            cookie_id: getCookie('hhg-id'),
            ga_client_id: gaCookie,
        };
        // categoryLevel
        if (categoryLevel) {
            if (categoryData[categoryLevel].value_en) {
                data['category'] = categoryData[categoryLevel].value_en;
            }
        }
        const expiresDay = Number(((_c = (_b = showCampaign.rules) === null || _b === void 0 ? void 0 : _b.find((r) => r.rule === 'days_to_show_again')) === null || _c === void 0 ? void 0 : _c.value) ||
            7);
        const showAgain = Number(((_e = (_d = showCampaign.rules) === null || _d === void 0 ? void 0 : _d.find((r) => r.rule === 'show_again_after_submit')) === null || _e === void 0 ? void 0 : _e.value) || 0);
        if (showAgain == 0) {
            LeadLog('⛔ Popup never show again!');
            setCookie(`lead_submited_${showCampaign.code}`, `target_${showCampaign === null || showCampaign === void 0 ? void 0 : showCampaign.extra_fields.targetType}`, { domain: '.' + siteDomain, path: '/' });
        }
        if (showAgain == 1) {
            LeadLog(`⌛ Popup will show again after ${expiresDay} days!`);
            setCookie(`lead_submited_${showCampaign.code}`, `target_${showCampaign === null || showCampaign === void 0 ? void 0 : showCampaign.extra_fields.targetType}`, { domain: '.' + siteDomain, days: expiresDay, path: '/' });
        }
        fetch(`${apiUrl}api/campaign/${showCampaign.code}/lead`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
        });
        if ((showCampaign === null || showCampaign === void 0 ? void 0 : showCampaign.extra_fields.popupShowThankYou) == 'notshow') {
            onClose();
            document.body.classList.remove('noscroll');
            return;
        }
        const thanksImg = showCampaign.thank_you_image || `${apiUrl}admin/img/thanksyou.png`;
        let thankTitle = (showCampaign === null || showCampaign === void 0 ? void 0 : showCampaign.extra_fields.popupThankyouTitle) || 'Thank you.';
        let thankDesc = (showCampaign === null || showCampaign === void 0 ? void 0 : showCampaign.extra_fields.popupThankyouDesc) || 'We appreciate your time!';
        let titleAlign = '';
        let descAlign = '';
        let linkText, linkNewTab, linkUrl = '';
        if ((showCampaign === null || showCampaign === void 0 ? void 0 : showCampaign.extra_fields.popupVersion) == '2.1') {
            const extra = showCampaign.extra_fields;
            const listBlockThankyou = JSON.parse(extra.listBlockThankyou);
            const titleBlock = listBlockThankyou.find((i) => i.name == 'TitleBlock');
            const subtitleBlock = listBlockThankyou.find((i) => i.name == 'SubtitleBlock');
            const linkButtonBlock = listBlockThankyou.find((i) => i.name == 'LinkButtonBlock');
            thankTitle = ((_f = titleBlock === null || titleBlock === void 0 ? void 0 : titleBlock.data) === null || _f === void 0 ? void 0 : _f.value) || '';
            titleAlign = ((_g = titleBlock === null || titleBlock === void 0 ? void 0 : titleBlock.data) === null || _g === void 0 ? void 0 : _g.align) || '';
            thankDesc = ((_h = subtitleBlock === null || subtitleBlock === void 0 ? void 0 : subtitleBlock.data) === null || _h === void 0 ? void 0 : _h.value) || '';
            descAlign = ((_j = subtitleBlock === null || subtitleBlock === void 0 ? void 0 : subtitleBlock.data) === null || _j === void 0 ? void 0 : _j.align) || '';
            linkText = ((_k = linkButtonBlock === null || linkButtonBlock === void 0 ? void 0 : linkButtonBlock.data) === null || _k === void 0 ? void 0 : _k.value) || '';
            linkNewTab = ((_l = linkButtonBlock === null || linkButtonBlock === void 0 ? void 0 : linkButtonBlock.data) === null || _l === void 0 ? void 0 : _l.newtab) || false;
            linkUrl = ((_m = linkButtonBlock === null || linkButtonBlock === void 0 ? void 0 : linkButtonBlock.data) === null || _m === void 0 ? void 0 : _m.url) || '';
            // ALWAYS SHOW THANK YOU ON COMPOUND COMP
            // const curLayout = showCampaign.extra_fields.currentLayout
            // TODO: newbuilder thank you
            // List layout not show thanks you
            // if (
            //   ['SkinA', 'SkinB', 'Floating', 'Tab', 'CenterTab'].includes(curLayout)
            // ) {
            //   isShowThanksYou = false
            // }
        }
        {
            setShowThankyou({
                title: thankTitle,
                titleAlign,
                subtitle: thankDesc,
                subtitleAlign: descAlign,
                link: linkUrl,
                linkNewTab,
                linkText,
                image: thanksImg,
            });
        }
        // Other
        // Init Insider Obj
        if (sessionStorage.getItem('insider_object')) {
            window.insider_object = JSON.parse(sessionStorage.getItem('insider_object'));
        }
        else {
            window.insider_object = {
                user: {
                    email: '',
                    phone_number: '',
                    gdpr_optin: true,
                    sms_optin: true,
                    email_optin: true,
                },
            };
        }
        // Submit Inisder Obj
        formData.map((data) => {
            const name = data.name;
            const value = data.value;
            if (name == 'tel') {
                window.insider_object.user.phone_number = value;
            }
            else if (name == 'email') {
                window.insider_object.user.email = value;
            }
        });
        sessionStorage.setItem('insider_object', JSON.stringify(window.insider_object));
        // End Init Insider Obj
        // End Submit handler
    });
    useEffect(() => {
        if (showCampaign) {
            leadStartTimeRef.current = Date.now();
        }
    }, [showCampaign]);
    return (React__default.createElement(LeadGenContext$1.Provider, { value: { primaryColor, apiUrl, siteDomain, siteId, locale } },
        React__default.createElement(TranslationsContext.Provider, { value: { locale, values: getTranslations(locale) } }, children ? (React__default.createElement(Component, { campaign: showCampaign, onSubmit: onSubmit, onClose: onClose, showThankyou: showThankyou, setShowThankyou: setShowThankyou, locale: locale, showEmpty: showEmpty, setShowEmpty: setShowEmpty, userInfo: userInfo }, children)) : (React__default.createElement(Portal, { target: getPopupWrapperDom() },
            React__default.createElement(Box, { sx: { position: 'fixed', zIndex: ZINDEX_SSO - 9e6 } },
                React__default.createElement(Transition, { mounted: Boolean(((_a = showCampaign === null || showCampaign === void 0 ? void 0 : showCampaign.extra_fields) === null || _a === void 0 ? void 0 : _a.popupVersion) === '2.1'), transition: "fade", duration: 600, timingFunction: "ease", exitDuration: 200 }, (styles) => {
                    var _a;
                    return (React__default.createElement(Box, { style: styles }, ((_a = showCampaign === null || showCampaign === void 0 ? void 0 : showCampaign.extra_fields) === null || _a === void 0 ? void 0 : _a.popupVersion) === '2.1' && (React__default.createElement(React__default.Fragment, null,
                        !!showCampaign.extra_fields.currentLayout &&
                            !showCampaign.extra_fields.currentLayout.includes('Inline') &&
                            !showCampaign.extra_fields.currentLayout.includes('Sidebar') && (React__default.createElement(Overlay, { color: "#000", opacity: 0.6, center: true, zIndex: 400, pos: 'fixed', onClick: () => onClose() })),
                        React__default.createElement(NewLeadPopup, { campaign: showCampaign, action: action, onSubmit: onSubmit, onClose: onClose, showThankyou: showThankyou, locale: locale, showEmpty: showEmpty, setShowEmpty: setShowEmpty, userInfo: userInfo })))));
                })))))));
};
const LeadGen = _LeadGen;
LeadGen.Heading = Heading;
LeadGen.Description = Description;
LeadGen.Form = Form;
LeadGen.Thankyou = Thankyou;
LeadGen.OtpForm = OtpBlock$1;
LeadGen.Close = Close;

export { LeadGen, LeadGenSubscriptionBox };
